<!-- // ┌───────────────────────────────────────────────────────────────┐ \\
// │ MAPROOM - Interactive Map Paths                                    │ \\
// ├────────────────────────────────────────────────────────────────────┤ \\
// │ Copyright © 2015 Maproom (http://maproom.net)                      │ \\
// │ Copyright © 2015 Thameside Media (http://thamesidemedia.com)       │ \\
// | All rights reserved                                                | \\
// ├────────────────────────────────────────────────────────────────────┤ \\
// │ Licensed Strictly Under Maproom Terms                              │ \\
// | See http://maproom.net/royalty-free-license                        | \\
// | The use of this work outside of these terms is prohibited          | \\
// | This copyright notice must not be removed                          | \\
// | Unauthorised use can be detected even if copyright is removed      | \\
// └────────────────────────────────────────────────────────────────────  -->

<div #buttoncontainer>
  <button class="selection-button" pButton label="Select All" (click)="selectAreas(true)"></button>
  <button
    class="selection-button"
    pButton
    label="Select None"
    (click)="selectAreas(false)"
  ></button>
</div>

<div class="key-container">
  <div class="key-text" style="">Unselected</div>
  <div class="key-text">Selected</div>
</div>
<div class="key-container">
  <div class="key-unselected" style=""></div>
  <div class="key-selected"></div>
</div>

<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 674.5 909"
  enable-background="new 0 0 674.5 909"
  xml:space="preserve"
>
  <g id="Postcode_letters">
    <text id="AB-text" transform="matrix(1 0 0 1 406.6201 233.1074)">AB</text>
    <text id="AL-text" transform="matrix(1 0 0 1 540.7438 738.1565)">AL</text>
    <text id="B-text" transform="matrix(1 0 0 1 455.5762 684.6438)">B</text>
    <text id="BA-text" transform="matrix(1 0 0 1 425.729 788.6702)">BA</text>
    <text id="BB-text" transform="matrix(1 0 0 1 431.4878 557.0286)">BB</text>
    <text id="BD-text" transform="matrix(1 0 0 1 438.7412 537.2483)">BD</text>
    <text id="BH-text" transform="matrix(1 0 0 1 453.3783 821.5256)">BH</text>
    <text id="BL-text" transform="matrix(1 0 0 1 426.7388 576.3375)">BL</text>
    <text id="BN-text" transform="matrix(1 0 0 1 546.1335 815.5286)">BN</text>
    <text id="BR-text" transform="matrix(1 0 0 1 562.1634 770.5731)">BR</text>
    <text id="BS-text" transform="matrix(1 0 0 1 411.3302 769.9319)">BS</text>
    <text id="BT-text" transform="matrix(1 0 0 1 190.1572 485.2102)">BT</text>
    <text id="CA-text" transform="matrix(1 0 0 1 394.2764 475.5354)">CA</text>
    <text id="CB-text" transform="matrix(1 0 0 1 566.915 701.0256)">CB</text>
    <text id="CF-text" transform="matrix(1 0 0 1 371.2959 760.7418)">CF</text>
    <text id="CH-text" transform="matrix(1 0 0 1 396.3203 614.218)">CH</text>
    <text id="CM-text" transform="matrix(1 0 0 1 573.5107 738.7385)">CM</text>
    <text id="CO-text" transform="matrix(1 0 0 1 599.1509 724.9065)">CO</text>
    <text id="CR-text" transform="matrix(1 0 0 1 553.4697 775.8231)">CR</text>
    <text id="CT-text" transform="matrix(1 0 0 1 618.6729 785.3079)">CT</text>
    <text id="CV-text" transform="matrix(1 0 0 1 475.1367 691.6252)">CV</text>
    <text id="CW-text" transform="matrix(1 0 0 1 420.3223 619.3199)">CW</text>
    <text id="DA-text" transform="matrix(1 0 0 1 572.8936 770.1311)">DA</text>
    <text id="DD-text" transform="matrix(1 0 0 1 403.3672 294.3518)">DD</text>
    <text id="DE-text" transform="matrix(1 0 0 1 467.8574 636.9387)">DE</text>
    <text id="DG-text" transform="matrix(1 0 0 1 338.624 446.7385)">DG</text>
    <text id="DH-text" transform="matrix(1 0 0 1 467.8561 467.5041)">DH</text>
    <text id="DL-text" transform="matrix(1 0 0 1 453.4902 496.8967)">DL</text>
    <text id="DN-text" transform="matrix(1 0 0 1 508.6689 583.928)">DN</text>
    <text id="DT-text" transform="matrix(1 0 0 1 421.3529 823.4954)">DT</text>
    <text id="DY-text" transform="matrix(1 0 0 1 432.6029 685.8492)">DY</text>
    <text id="E-text" transform="matrix(1 0 0 1 559.6912 756.4898)">E</text>
    <text id="EH-text" transform="matrix(1 0 0 1 380.0352 371.5178)">EH</text>
    <text id="EN-text" transform="matrix(1 0 0 1 552.2468 744.8231)">EN</text>
    <text id="EX-text" transform="matrix(1 0 0 1 346.3457 814.1663)">EX</text>
    <text id="FK-text" transform="matrix(1 0 0 1 317.4082 333.1203)">FK</text>
    <text id="FY-text" transform="matrix(1 0 0 1 397.4443 554.5396)">FY</text>
    <text id="G-text" transform="matrix(1 0 0 1 328.3203 363.882)">G</text>
    <text id="GL-text" transform="matrix(1 0 0 1 438.915 734.2551)">GL</text>
    <text id="GU-text" transform="matrix(1 0 0 1 510.2144 794.0667)">GU</text>
    <text id="HA-text" transform="matrix(1 0 0 1 538.6634 752.6565)">HA</text>
    <text id="HD-text" transform="matrix(1 0 0 1 459.133 577.0067)">HD</text>
    <text id="HG-text" transform="matrix(1 0 0 1 463.6183 532.5012)">HG</text>
    <text id="HP-text" transform="matrix(1 0 0 1 516.6465 741)">HP</text>
    <text id="HR-text" transform="matrix(1 0 0 1 403.4395 711.3108)">HR</text>
    <text id="HS-text" transform="matrix(1 0 0 1 190.752 153.3544)">HS</text>
    <text id="HU-text" transform="matrix(1 0 0 1 535.0059 558.6106)">HU</text>
    <text id="HX-text" transform="matrix(1 0 0 1 452.7266 566.5315)">HX</text>
    <text id="IG-text" transform="matrix(1 0 0 1 562.2471 749.5731)">IG</text>
    <text id="IM-text" transform="matrix(1 0 0 1 313.6683 521.2815)">IM</text>
    <text id="IP-text" transform="matrix(1 0 0 1 605.8174 697.8596)">IP</text>
    <text id="IV-text" transform="matrix(1 0 0 1 285.9736 207.5881)">IV</text>
    <text id="KA-text" transform="matrix(1 0 0 1 318.6533 405.1194)">KA</text>
    <text id="KT-text" transform="matrix(1 0 0 1 538.136 775.4898)">KT</text>
    <text id="KW-text" transform="matrix(1 0 0 1 353.4697 124.8713)">KW</text>
    <text id="KY-text" transform="matrix(1 0 0 1 377.2012 340.4592)">KY</text>
    <text id="L-text" transform="matrix(1 0 0 1 403.5317 590.2268)">L</text>
    <text id="LA-text" transform="matrix(1 0 0 1 400.0342 516.6682)">LA</text>
    <text id="LD-text" transform="matrix(1 0 0 1 367.8682 703.3811)">LD</text>
    <text id="LE-text" transform="matrix(1 0 0 1 495.7549 662.2571)">LE</text>
    <text id="LL-text" transform="matrix(1 0 0 1 353.3857 629.0266)">LL</text>
    <text id="LN-text" transform="matrix(1 0 0 1 538.1475 605.2913)">LN</text>
    <text id="LS-text" transform="matrix(1 0 0 1 475.9248 555.4456)">LS</text>
    <text id="LU-text" transform="matrix(1 0 0 1 526.2959 727.4905)">LU</text>
    <text id="M-text" transform="matrix(1 0 0 1 434.126 588.7034)">M</text>
    <text id="ME-text" transform="matrix(1 0 0 1 588.8491 778.4045)">ME</text>
    <text id="MK-text" transform="matrix(1 0 0 1 519.3794 713.8167)">MK</text>
    <text id="ML-text" transform="matrix(1 0 0 1 353.2461 390.8772)">ML</text>
    <text id="N-text" transform="matrix(1 0 0 1 553.4421 752.2398)">N</text>
    <text id="NE-text" transform="matrix(1 0 0 1 439.375 432.8108)">NE</text>
    <text id="NG-text" transform="matrix(1 0 0 1 498.8408 629.0266)">NG</text>
    <text id="NN-text" transform="matrix(1 0 0 1 504.6709 697.4963)">NN</text>
    <text id="NP-text" transform="matrix(1 0 0 1 391.1123 739.7932)">NP</text>
    <text id="NR-text" transform="matrix(1 0 0 1 619.4365 659.8831)">NR</text>
    <text id="NW-text" transform="matrix(1 0 0 1 547.0261 755.3231)">NW</text>
    <text id="OL-text" transform="matrix(1 0 0 1 442.2389 574.3375)">OL</text>
    <text id="OX-text" transform="matrix(1 0 0 1 479.6196 731.8821)">OX</text>
    <text id="PA-text" transform="matrix(1 0 0 1 275.5117 325.0139)">PA</text>
    <text id="PE-text" transform="matrix(1 0 0 1 546.5176 660.6741)">PE</text>
    <text id="PH-text" transform="matrix(1 0 0 1 309.6191 276.1545)">PH</text>
    <text id="PL-text" transform="matrix(1 0 0 1 316.1543 845.8147)">PL</text>
    <text id="PO-text" transform="matrix(1 0 0 1 509.0018 815.5494)">PO</text>
    <text id="PR-text" transform="matrix(1 0 0 1 406.8174 561.0217)">PR</text>
    <text id="RG-text" transform="matrix(1 0 0 1 491.2251 770.6506)">RG</text>
    <text id="RH-text" transform="matrix(1 0 0 1 540.1201 797.0256)">RH</text>
    <text id="RM-text" transform="matrix(1 0 0 1 569.4753 758.9512)">RM</text>
    <text id="S-text" transform="matrix(1 0 0 1 476.1475 598.1702)">S</text>
    <text id="SA-text" transform="matrix(1 0 0 1 319.4443 723.97)">SA</text>
    <text id="SE-text" transform="matrix(1 0 0 1 557.1074 763.7398)">SE</text>
    <text id="SG-text" transform="matrix(1 0 0 1 546.9419 721.4338)">SG</text>
    <text id="SK-text" transform="matrix(1 0 0 1 445.6001 603.844)">SK</text>
    <text id="SL-text" transform="matrix(1 0 0 1 520.4639 759.7219)">SL</text>
    <text id="SM-text" transform="matrix(1 0 0 1 548.2751 772.1565)">SM</text>
    <text id="SN-text" transform="matrix(1 0 0 1 450.6094 764.3206)">SN</text>
    <text id="SO-text" transform="matrix(1 0 0 1 479.6196 804.7756)">SO</text>
    <text id="SP-text" transform="matrix(1 0 0 1 454.0366 799.9241)">SP</text>
    <text id="SR-text" transform="matrix(1 0 0 1 482.8783 457.8226)">SR</text>
    <text id="SS-text" transform="matrix(1 0 0 1 589.2952 754.0829)">SS</text>
    <text id="ST-text" transform="matrix(1 0 0 1 441.9487 637.428)">ST</text>
    <text id="SW-text" transform="matrix(1 0 0 1 547.6924 764.6565)">SW</text>
    <text id="SY-text" transform="matrix(1 0 0 1 378.0527 664.8948)">SY</text>
    <text id="TA-text" transform="matrix(1 0 0 1 385.7835 802.0087)">TA</text>
    <text id="TD-text" transform="matrix(1 0 0 1 414.708 397.2072)">TD</text>
    <text id="TF-text" transform="matrix(1 0 0 1 423.6294 654.9514)">TF</text>
    <text id="TQ-text" transform="matrix(1 0 0 1 354.8758 850.2268)">TQ</text>
    <text id="TN-text" transform="matrix(1 0 0 1 581.7266 802.0862)">TN</text>
    <text id="TR-text" transform="matrix(1 0 0 1 273.8434 874.7141)">TR</text>
    <text id="TS-text" transform="matrix(1 0 0 1 487.4009 496.1779)">TS</text>
    <text id="TW-text" transform="matrix(1 0 0 1 534.5823 765.8231)">TW</text>
    <text id="UB-text" transform="matrix(1 0 0 1 535.0801 758.1565)">UB</text>
    <text id="W-text" transform="matrix(1 0 0 1 545.5257 759.5731)">W</text>
    <text id="WA-text" transform="matrix(1 0 0 1 415.3896 595.6252)">WA</text>
    <text id="WD-text" transform="matrix(1 0 0 1 535.0264 746.8231)">WD</text>
    <text id="WF-text" transform="matrix(1 0 0 1 477.7962 571.0847)">WF</text>
    <text id="WN-text" transform="matrix(1 0 0 1 413.3551 581.137)">WN</text>
    <text id="WR-text" transform="matrix(1 0 0 1 434.0649 704.9817)">WR</text>
    <text id="WS-text" transform="matrix(1 0 0 1 453.3169 659.5809)">WS</text>
    <text id="WV-text" transform="matrix(1 0 0 1 426.5623 673.0113)">WV</text>
    <text id="YO-text" transform="matrix(1 0 0 1 505.501 530.9182)">YO</text>
    <text id="ZE-text" transform="matrix(1 0 0 1 535.0303 114.5962)">ZE</text>
  </g>

  <g id="Postcode_areas">
    <a (click)="SelectCode('AB')">
      <path
        [class.selected]="IsSelected('AB')"
        id="AB"
        d="
		M398,190.5c3.125,3.493-3.56,10.391-5.792,13.967c-3.474-1.172-1.015-5.951-6.02-2.918c-1.15,0.697-2.392,2.771-3.444,3.174
		c-1.047,0.4-2.125-0.753-3.245-0.484c-1.439,0.346-4.883,4.132-5.754,5.335c-1.84,2.541,1.72,3.39,3.53,5.432
		c0.613,0.692,1.627,2.108,1.912,2.994c0.65,2.023,0.529,1.161-0.743,2.426c-1.185,1.178-1.935,1.155-2.701,2.883
		c-0.579,1.308-1.06,3.049-1.431,4.442c-0.817,3.064,0.24,5.137,0.132,8.005c-0.082,2.186-1.641,4.998-1.144,7.194
		c0.26,1.147,1.866,1.235,1.455,3.056c-0.302,1.337-1.709,1.854-2.764,2.544c-2.455,1.608-5.961,3.67-7.736,5.993
		c-1.374,1.799-1.116,1.298,0.556,2.702c1.487,1.247,3.193,2.206,4.702,3.464c2.552,2.128,4.355,4.158,2.762,7.478
		c2.524,0.881,5.452,0.493,7.992,1.607c1.001,0.439,0.974,0.99,2.232,1.15l1.726-0.925c-0.056-0.161,0.463-3.069,0.525-3.519
		c0.19-1.378,0.117-2.279,1.238-3.243c0.627-0.539,2.899-1.608,3.76-1.712c1.827-0.22,2.352,0.875,3.8,1.474
		c3.584,1.483,4.32,0.366,6.407-2.048c2.365-2.737,4.038-2.712,7.044-2.97c1.295-0.111,2.931-0.78,4.208-0.512
		c1.424,0.299,2.349,1.717,3.541,2.449c1.839,1.129,4.767,1.804,5.318,4.263c0.416,1.857-1.053,4.008-0.38,6.3
		c0.522,1.775,1.879,3.336,2.069,5.006c0.091,0.802-0.835,1.368-0.711,2.189c0.145,0.965,1.613,0.728,1.286,2.073
		c1.394,0.026,1.876-1.365,2.913-1.465c0.954-0.092,1.999,1.239,2.751,1.099c3.697-0.691-2.072-6.148,2.962-4.862
		c0.398,3.712,4.298-1.926,5.232-3.026c0.653-0.769,1.372-3.039,1.863-3.462c0.92-0.792,2.345-0.865,3.412-1.28l0.201,0.199
		c0.134-0.37,0.267-0.739,0.397-1.106c1.754-4.933,3.508-9.866,5.262-14.799c0.774-2.176,1.551-4.365,1.944-6.641
		c0.589-3.411,0.305-6.951,1.147-10.309c2.594-10.341,15.214-17.003,14.892-27.659c-0.129-4.248-2.402-8.096-4.609-11.728
		c-0.917-1.51-1.86-3.05-3.223-4.174c-3.169-2.612-7.732-2.376-11.822-2.004c-5.228,0.476-10.455,0.951-15.683,1.427
		c-3.233,0.294-6.504,0.587-9.711,0.086c-5.559-0.868-11.334-3.038-16.371-0.531c-1.748,0.87-3.617,1.025-5.518,0.774L398,190.5z"
      />
    </a>

    <a (click)="SelectCode('AL')">
      <path
        [class.selected]="IsSelected('AL')"
        id="AL"
        d="
		M552.75,740c-0.794-1.666,0.618-2.512,0.505-4.001c-0.058-0.766-0.999-1.331-1.016-1.986c-0.018-0.691,0.724-1.648,0.698-2.076
		c-0.121-2.02-0.672-1.586-2.632-2.487c-0.691-0.318-0.264-1.873-1.574-1.273c-0.389,0.178-0.345,1.885-0.275,2.291
		c-0.811-0.33-1.7-1.087-2.664-1.187c-0.105,0.208-0.187,0.483-0.28,0.688c-2.106-0.732-4.388,0.01-6.763-0.469
		c-2.254-0.455-3.966-0.872-5.25,2l0.002-0.021c1.445,0.143,3.189,1.068,3.948,2.089c0.637,0.857,1.411,3.294,1.219,4.813
		l-0.144,0.771c1.014,0.357,0.988,2.496,1.969,3.097c1.478,0.906,3.38-1.648,5.468-1.212l0.288,0.212
		c0.171-1.692,4.097-1.207,6.497-1.139L552.75,740z"
      />
    </a>

    <a (click)="SelectCode('B')">
      <path
        [class.selected]="IsSelected('B')"
        id="B"
        d="
		M478.25,658c-0.493-2.36-3.015-2.673-4.956-3.294c0.116-1.762-2.85-3.426-2.831-0.994c-3.899-0.778-1.344,2.847-1.888,4.349
		c-0.499,1.379-4.471,3.773-5.574,4.189c-1.336,0.503-1.983-0.148-3.199,0.994c-0.711,0.668-0.751,1.946-1.613,2.694
		c-1.577,1.37-4.075,1.754-5.938,3.062l0.289-0.129c0.662,1.482-2.277,3.706-2.739,4.434c-1.013,1.599-1.085,3.258-0.739,4.883
		c0.281,1.323,2.206,3.338,1.638,4.762c-0.637,1.596-4.003,1.104-3.449,3.05l0.268-0.006c0.215,0.761-1.163,1.893-1.023,2.755
		c0.211,1.295,0.915,0.732,1.711,1.765c1.195,1.549,2.126,3.059,3.293,4.237c0.444,0.449,0.144,1.04,0.933,1.568
		c0.728,0.487,1.747-0.047,2.573,0.187c1.444,0.409,0.477-0.382,1.549,0.987c0.672,0.859,0.579,1.623,1.39,2.507
		c1.247,1.359,2.271,2.302,3.499,3.811c0.526,0.648,1.317,1.229,1.825,1.971l-0.018-0.283c0.365-1.041-0.166-2.033-0.013-3
		c0.195-1.233,1.004-2.19,1.581-3.439c1.025-2.216,2.604-4.491,3.187-6.556c0.34-1.203,0.26-2.623,0.751-4.012
		c0.338-0.956,0.969-1.892,1.25-2.488c0.834-1.774,0.243-4.689,1.725-6.243c-2.306-1.494-1.143-7.241,1.705-5.802
		c0.227-1.639,1.41-2.496,1.798-3.973c-4.922-1.233-3.284-2.538-1.942-6.201c2.888-0.339,4.941-4.227,4.295-6.805L478.25,658z"
      />
    </a>

    <a (click)="SelectCode('BA')">
      <path
        [class.selected]="IsSelected('BA')"
        id="BA"
        d="
		M409.45,785.886c0.023,0.043,0.045,0.085,0.067,0.127c0.049,0.095,0.028,1.054,0.233,1.493c0.29,0.62,1.274,0.837,1.461,1.494
		c0.374,1.311-1.215,2.851-0.498,3.818c0.72,0.97,3.007-0.053,3.992-0.03c0.047,1.779,0.621,1.893,2.062,1.661
		c0.411-0.066,0.585-1.217,1.03-1.398c0.677-0.274,0.777,0.484,1.402,0.411c2.631-0.308,2.295,0.533,4.017,2.738
		c-0.787,0.657-1.486,1.467-2.224,2.081c-2.332-2.856-2.792,0.116-4.164,1.537c-1.021,1.058-1.516,0.42-2.343,1.932
		c-0.487,0.89-0.729,2.407,0.02,3.03c2.032-2.011,1.738,0.673,0.992,1.97c-0.585,1.017-1.612,0.953-1.505,2.256
		c0.084,1.019,1.112,0.614,1.33,1.17c0.448,1.143,0.292,1.911-0.216,2.43L415,812.5c2.538,1.977,4.864-1.71,6.962-1.288
		c0.23-1.135-0.906-1.461-0.874-2.211c0.033-0.758,1.046-1.115,1.18-2.014c0.182-1.218-0.226-3.14,0.018-4.705
		c0.661,0.273,1.482,0.047,2.176,0.18c0.289-1.736,0.796-3.129,2.787-2.968c2.249,0.181,2.079,2.014,2.988,3.268
		c2.113,2.916,3.623,1.035,5.365-0.104L435.5,802.5c-0.889-0.581-1.712-1.215-2.724-1.544c0.344-1.537,1.908-1.364,2.543-2.444
		c0.638-1.085-0.276-2.489,0.232-3.268c1.114-1.706,4.814,0.27,6.198,1.029c0.651-0.535,1.345-2.357,1.751-3.024
		c0.427-0.703,0.979-0.094,1.255-1.249c0.201-0.84-1.078-1.17-0.767-2.007c0.608-1.629,5.954-0.785,6.055,1.212
		c0.194,0.068,0.583,0.146,0.706,0.263c1.39-2.367,3.334,0.223,5.213,0.242c-0.013-0.666-0.603-1.729-0.486-2.223
		c0.173-0.732,1.26-0.649,1.283-1.744c0.017-0.794-1.104-0.824-1.265-1.743c-0.104-0.594,0.485-1.723,0.729-2.27
		c-1.804-0.802-3.743-1.657-5.462-2.495c-3.085-1.505-1.103-1.806-0.765-4.236c0.294-2.112-2.702-5.425-4.316-6.441
		c-0.718-0.453-1.582-0.497-2.432-0.822c-0.427-0.163-1.026,0.203-1.449-0.038c-0.366-0.209-0.357-1.076-0.552-1.193
		c-1.585-0.947-2.964-1.822-4.572-3.439c-1.924-1.935-2.428-2.412-4.733-0.568c-1.801,1.441-3.71,3.667-4.95,5.493
		c-0.183,0.269-1.23,1.967-1.192,2.314c0.133,1.207,1.825,1.213,2.147,2.243c0.989,3.172-2.4,1.679-3.449,1.507
		c-2.35-0.385-2.356,0.577-4.186,1.756c-2.861,1.842-1.165-0.078-3.295-1.075c-2.475-1.158-3.411,1.179-1.488,2.518
		c-2.236,1.906-2.313,6.556-6.217,6.239c0.406-0.073,0.618,0.228,0.937,0.255"
      />
    </a>

    <a (click)="SelectCode('BB')">
      <path
        [class.selected]="IsSelected('BB')"
        id="BB"
        d="
		M440.75,569.75c2.31-0.734,0.413-3.208,0.513-4.75c0.094-1.455,1.409-4.833,2.737-2.214c0.956-1.108,0.733-2.372,2.311-2.724
		c0.277-0.062,0.503-0.091,0.687-0.092L447,560.5c0.081-0.857,0.172-1.614,0.294-2.456c1.139-0.819,0.898-2.641,2.913-2.587
		c1.752-2.07-0.419-3.685-1.207-5.706c-0.206-0.528-0.996-0.641-1.035-1.252c-0.045-0.713,1.465-1.049,1.308-1.748
		c-0.296-1.32-2.553-0.723-3.736-0.788c-0.229-3.012-2.598,0.181-4.023-0.777c-1.107-0.744-0.302-2.859-0.802-4.399
		c-2.284-0.107-6.533,2.52-7.522-0.232c-0.653-1.819,2.094-5.049-2.19-5.068c-1.736-0.008-1.597,1.013-3.006,1.581
		c-1.005,0.405-2.19-0.274-3.194,0.232c-1.339,0.675-3.566,5.611-4.3,6.95l-0.049,0.124c0.104,0.038,0.206,0.082,0.305,0.133
		c0.726,0.376,1.108,1.008,1.75,1.487c0.65,0.484,0.861,0.787,1.757,1.269c0.797,0.429,1.366-0.789,1.999,0.731
		c0.238,0.572-0.373,2.406-0.199,3.262c0.316,1.556,2.241,3.8,0.436,5.006c-1.726,1.154-4.592-0.431-4.005,2.682
		c0.123,0.652,1.119,1.561,1.256,2.556c0.182,1.317-0.374,1.739,0.244,2.95c0.501,0.982,2.561,3.181,3.256,4.05l0.002-0.029
		c0.081,0.004,0.164,0.012,0.249,0.024c1.619,0.233,1.092,2.003,2.694,1.441c1.132-0.397,1.356-2.315,1.842-3.149
		c1.431-0.216,3.204-0.258,3.001,1.674c1.265-0.283,2.119-0.887,3.474-0.529c0.862,0.228,1.441,1.369,2.462,1.61"
      />
    </a>

    <a (click)="SelectCode('BD')">
      <path
        [class.selected]="IsSelected('BD')"
        id="BD"
        d="
		M432.75,535.75c1.023-0.976,1.675-1.877,2.45-3c0.258-0.374-0.043-0.904,0.226-1.311c0.261-0.395,1.142-0.499,1.274-0.744
		c0.951-1.78,1.424-3.806-0.2-5.394c-1.721-1.682-4.33-1.014-2.176-3.981c1.282-1.766,3.121-1.095,3.944-3.057
		c0.545-1.299-0.882-1.514,0.476-2.573c0.422-0.329,2.695-0.494,3.255-0.426c1.505,0.183,1.022,0.406,2.238,0.986
		c1.396,0.666,1.727,0.623,3.268,1c3.829,0.936,5.058,4.5,8.594,6.006l0.367,0.246c-0.022,1.57,0.337,3.509,1.015,4.259
		c0.612,0.677,1.831,0.384,2.281,0.922c0.644,0.77,0.139,1.219,0.483,2.068c0.612,1.507,1.353,3.199,2.068,4.75
		c0.498,1.08,1.943,2.416,2.602,3.43l0.374,0.107c0.206,0.35,0.22,1.321,0.416,1.67c-1.944,0.177-3.477,0.244-5.205,1.567
		c-0.674-0.572-1.54-0.727-2.463-0.481c-0.83,1.435,0.875,4.05,1.95,5.025c0.747,0.678,2.346,0.932,3.249,1.432
		c1.1,0.609,1.576,1.327,2.513,1.944c2.134,1.407,3.363,1.075,3.931,3.75c0.622,2.931,0.006,4.076,3.287,4.856
		c-0.176,1.115-0.913,2.639,0.032,3.199l-0.729-0.286c-0.431-0.06-0.931-0.025-1.496,0.073c1.255,3.182-1.698,2.66-3.775,3.212
		l-1.538-0.037c0.597-2.836-1.064-3.128-2.711-3.769c-1.814-0.706-2.185-1.827-3.751-2.444c-1.023-0.403-1.625,0.232-2.681-0.313
		c-0.851-0.439-1.069-1.3-1.757-1.749c-1.205-0.788-2.711-0.619-3.968-1.161l-0.388-0.071c1.752-2.07-0.419-3.685-1.207-5.706
		c-0.206-0.528-0.996-0.641-1.035-1.252c-0.045-0.713,1.465-1.049,1.308-1.748c-0.296-1.32-2.553-0.723-3.736-0.788
		c-0.229-3.012-2.598,0.181-4.023-0.777c-1.107-0.744-0.302-2.859-0.802-4.399c-2.284-0.107-6.533,2.52-7.522-0.232
		c-0.532-1.481,1.191-3.899-0.465-4.755L432.75,535.75z"
      />
    </a>

    <a (click)="SelectCode('BH')">
      <path
        [class.selected]="IsSelected('BH')"
        id="BH"
        d="
		M473.195,824.496c0.644-2.407,0.308-2.809,0.098-5.203c2.101-0.832-0.283-1.934-0.543-3.032c-0.153-0.646,0.353-1.687,0.248-2.013
		c-0.358-1.115,0.116-0.411-0.749-1.248c-0.356-0.344-1.521,0.056-1.949-0.565c-0.751-1.088,0.598-1.267,0.467-1.935
		c-0.216-1.103-0.344-2.013-1.962-2.219c-2.032,4.713-4.765,0.488-7.506,1.694c-0.869-1.471-3.47-3.818-2.588-5.661
		c-0.089-0.091-0.177-0.183-0.263-0.277c-1.199,0.602-2.243,1.815-3.436,2.482c-0.972,0.544-1.979,0.203-2.514,1.73l0.717-0.294
		c-1.778,0.338-2.365,0.946-2.723,2.549c-0.121,0.541,0.601,1.186,0.532,1.744c-0.099,0.792-0.951,1.28-1.032,2
		c-0.229,2.047,1.222,1.533,1.323,3c0.133,1.938-1.777,0.314-3.035,0.288c0.293,0.622,0.425,1.589,0.679,2.175
		c-2.062-0.39-3.122,1.33-5.267,1.093c-3.097-0.344-3.047-1.077-3.132,2.139c-0.029,1.112-0.075,1.538-0.305,2.806
		c-0.079,0.436-0.531,1.109-0.519,1.486c0.026,0.811,0.798,0.834,0.835,1.515c0.134,2.499-2.132,3.284-2.073,5.499l-0.489-0.429
		c2.376,0.641,4.943,0.39,7.383,1.227c2.32,0.796,4.632,1.976,7.076,1.778c2.702-0.219,2.883-1.852,3.575-4.007
		c0.13-0.405,1.083-2.627,0.857-2.878c-1.136-1.264-3.451,2.432-5.032-0.955c3.598-1.446-0.81-2.209-2.332-2.022
		c-0.095-1.194,0.878-1.658,1.768-2.363c0.955,1.057,2.801,1.777,3.968,0.903c1.13,2.058,2.527,1.109,4.279,0.554
		c1.858-0.589,3.697-0.177,5.548-0.378C468.449,825.315,470.694,824.076,473.195,824.496z"
      />
    </a>

    <a (click)="SelectCode('BL')">
      <path
        [class.selected]="IsSelected('BL')"
        id="BL"
        d="
		M440.25,578.25c0-1.337-0.37-3.293,1.462-4.313c-0.505-0.384-0.619-0.828-1.419-0.981c-0.806-1.398-0.467-2.525,0.681-3.414
		c-1.021-0.241-1.601-1.383-2.462-1.61c-1.355-0.358-2.209,0.246-3.474,0.529c0.203-1.932-1.57-1.89-3.001-1.674
		c-0.487,0.835-0.711,2.753-1.842,3.149c-1.602,0.561-1.074-1.208-2.694-1.441c-2.668-0.384-3.737,3.342-3.789,5.223
		c-1.457-0.648-2.345,0.391-3.462,1.282l0.045-0.087c1.618,0.871,2.256,2.079,3.267,3.788c0.475,0.803,1.134,1.844,1.817,2.658
		l0.121-0.109c0.017,0.302-0.556,0.354-0.023,0.536c1.463-1.323,2.582-1.284,4.523-1.286c1.884-0.003,3.374,1.013,4.968,0.962
		c-0.122-0.909-0.796-1.636-1.504-2.212c0.995-0.803,2.259-1.579,1.556-2.949c0.493-0.158,1.432-0.15,1.943-0.013
		c-0.123,2.804,1.453,3.004,3.397,2.41L440.25,578.25z"
      />
    </a>

    <a (click)="SelectCode('BN')">
      <path
        [class.selected]="IsSelected('BN')"
        id="BN"
        d="
		M527.75,819.25c-0.166-0.286-0.99-1.161-1.074-1.432c-0.161-0.515,0.414-1.108,0.336-1.306c-0.502-1.289-1.428-2.166-1.981-3.462
		c0.86-0.828,1.04-2.245,0.191-2.826l0.278-0.473c-0.936,0.195,1.506-0.553,2.056-0.556c1.122-0.005,2.267,0.644,3.407,0.767
		c-0.48-2.101,1.418-2.53,2.611-1.216c0.68,0.749-0.511,1.597,0.227,2.204c0.429,0.353,1.897-0.01,2.449,0.045
		c2.01,0.198,3.381,0.742,4.276-1.751c0.281-0.784-0.555-1.359-0.036-2.306c0.413-0.754,1.694-1.403,2.474-1.399
		c0.019,0.454,0.266,0.773,0.338,1.18c0.562-0.121,2.28-0.491,2.711-0.969c0.874-0.97-0.136-1.496,1.001-2.242
		c1.696-1.113,0.729,0.342,1.488,0.742c1.058,0.557,0.522,0.932,2.254,0.507c0.373-0.092,0.063-1.228,0.476-1.217
		c1.392,0.037,0.372,0.59,1.024,1.419c0.544,0.691,0.078,2.037,1.481,2.305c1.598,0.305,4.399-2.845,3.795-4.274
		c2.806-1.021,4.875,0.103,5.724,2.762c0.502,1.572-0.585,1.806,1.244,2.25c1.434,0.348,2.24-0.336,2.294-1.706
		c1.517,0.648,2.542-0.034,4.163-0.007c0.323,1.356,1.111,2.492,1.076,3.93c1.281,0.069,2.252-1.584,3.73-1.98
		c1.025-0.275,3.196-0.301,3.937,0.256c0.741,0.557,0.768,2.936,0.731,3.7c-0.044,0.91-0.53,2.489-0.837,3.336
		c0.4-0.218,0.788-0.325,1.109-0.303l0.792,0.636c-0.892,0.447-1.734,0.963-2.494,1.515c-2.603,1.893-5.167,7.337-8.998,5.646
		c-5.364-2.368-10.22-5.294-16.255-5.714c-6.03-0.42-12.452,0.63-18.495,0.924c-2.569,0.125-5.158,0.253-7.654,0.876L527.75,819.25z
		"
      />
    </a>

    <a (click)="SelectCode('BR')">
      <path
        [class.selected]="IsSelected('BR')"
        id="BR"
        d="
		M569.5,771.25l-0.193-0.556c-0.195,0.208,1.027-1.47,0.943-1.244c0.436-1.17,0.966-1.659,0.707-3.168
		c-2.471,0.717-4.141-0.065-6.13-0.759l-0.077,0.227l-0.475-0.413c-0.312-0.101-0.633-0.196-0.969-0.281
		c-0.107-0.027-1.363,0.275-1.624,0.261c-0.45-0.024-0.544-0.857-1.176-0.823c-1.348,0.072-2.387,1.324-3.007,2.505l-0.373,0.312
		c0.392,0.156,0.698,0.27,0.623,0.22c1.161,0.765,2.291,2.079,3.019,3.218c0.594,0.928,0.784,1.948,0.838,3.006
		c0,0,0.143-0.006,0.143-0.006c0.174,0.229,2.035,0.649,2.232-0.975c1.167,0.57,1.721,1.047,2.967,0.73
		c-0.28,0.071,2.242-1.927,2.063-1.687c0.155-0.209,0.445-1.284,0.294-1.123L569.5,771.25z"
      />
    </a>

    <a (click)="SelectCode('BS')">
      <path
        [class.selected]="IsSelected('BS')"
        id="BS"
        d="
		M409.518,786.013c-0.512-0.984-1.3-2.034-1.774-3.007c-1.235-2.534-1.933-3.198-4.494-4.762c-1.618-0.987-1.284-0.859-2.319-2.244
		c-0.67-0.897-0.665-2.149-1.931-1.75l0.556-0.776c0.916-2.385,2.699-4.827,4.389-6.047c2.432-1.756,4.356-3.845,6.363-5.945
		c1.578-1.651,3.499-1.524,5.193-2.982c1.846-1.591,1.974-4.528,3.132-6.526c1.797-3.101,4.634-5.245,6.942-7.895L425,744.75
		c0.855-0.192,1.646,1.997,2.78,2.751c-0.403,0.506-1.566,2.025-1.486,2.693c0.199,1.668,0.889,0.668,2.225,1.105
		c1.714,0.561,2.807,1.032,4.731,1.2c5.409,0.474,3.036,2.51,2.186,6.212c-1.11-0.21-4.738-1.105-4.454,1.3
		c0.121,1.024,2.811,2.081,3.018,3.488l-0.021-0.146c-0.535,0.074-1.154,0.44-2.036,1.146c-1.801,1.441-3.71,3.667-4.95,5.493
		c-0.183,0.269-1.23,1.967-1.192,2.314c0.133,1.207,1.825,1.213,2.147,2.243c0.989,3.172-2.4,1.679-3.449,1.507
		c-2.35-0.385-2.356,0.577-4.186,1.756c-2.861,1.842-1.165-0.078-3.295-1.075c-2.475-1.158-3.411,1.179-1.488,2.518
		c-2.236,1.906-2.313,6.556-6.217,6.239c0.406-0.073,0.618,0.228,0.937,0.255L409.518,786.013z"
      />
    </a>

    <a (click)="SelectCode('BT')">
      <path
        [class.selected]="IsSelected('BT')"
        id="BT"
        d="
		M270.012,494.987c-0.253-3.469-1.981-9.831-3.375-12.985c-2.444-5.528-4.953-3.576-9.637-3.603
		c-3.031-0.017-2.035-1.167-4.978-0.02c-2.906,1.134-4.812,4.334-7.947,5.057c-1.008-7.496,4.609-8.525,9.41-12.45
		c2.956-2.417,5.234-12.094-1.398-8.05c1.14-4.74-6.317-12.513-11.523-13.535c2.068-4.263,1.742-6.379-3.014-8.029
		c1.082-2.589,0.929-9.72-0.174-11.76c-2.735-5.058-5.585-1.015-8.861-1.189c-1.068-0.056-3.267-2.133-4.405-2.534
		c-1.402-0.494-3.599-0.663-5.084-0.892c-5.196-0.801-6.098,0.708-11.026,2.513c-1.019,0.373-1.839-0.442-2.998-0.01
		c-1.001,0.373-1.077,1.582-1.99,2.024c-1.991,0.963-2.831,1.728-5.012,1.974c-4.788,0.541-6.206-2.481-8.998,0.502
		c-2.142,2.288-1.575,7.493-4.127,9.863c-3.566,3.311-5.903-2.365-8.874,1.183c-1.101-0.584-0.969-1.335-1-2.048l-1.25,0.5
		c-1.249,0.485-2.824,0.513-4,1c-1.835,0.759-1.428,1.432-2.313,3.25c-0.625,1.285-1.87,2.323-2.249,3.689
		c-0.176,0.634,0.065,1.655-0.133,2.256c-0.036,0.108,0.294,0.747,0.169,1.074c-0.184,0.485-1.184,0.041-1.431,0.538
		c-0.862,1.739-0.083,2.981-0.094,4.706c-0.013,1.979-0.764,2.931-1.938,4.482c-1.049,1.385-3.326,2.864-3.768,4.499
		c-0.437,1.62,0.659,3.116-0.038,4.712c-1.924,0.52-4.015-1.562-6.218-0.469c-2.114,1.049-2.801,4.758-5.744,2.961
		c-1.236-0.754-0.822-1.808-2.494-2.192c-1.897-0.436-1.928,0.047-3,1.561c-1.495,2.114-1.996,3.213-0.658,5.168
		c0.307,0.448,1.275,0.856,1.676,1.25c0.266,0.261-0.111,1.125,0.469,1.462c1.545,0.899,1.486-0.173,2.744-0.205
		c0.833-0.021,5.019,0.576,5.335,0.938c1.737,1.988-2.652,2.743-3.805,3.373c-0.673,0.368-2.343,1.316-2.83,1.932
		c-0.785,0.992,0.068,1.821-1.16,2.711c-1.837,1.332-5.45-0.012-7.284-0.268c-2.348-0.327-1.511-0.354-2.226,2.069
		c-1.147,3.887-4.082,4.174-7.726,4.538c-0.152,0.206-0.468,0.917-0.518,1.156c1.412,0.433,2.76,2.722,3.931,3.875
		c1.466,1.443,2.702,3.164,3.849,4.743c0.907,1.249,2.497,3.312,3.768,4.444c1.369,1.219,3.119,0.922,4.494,2.176
		c1.686,1.537,0.727,3.863,1.615,5.568c1.135,2.18,3.44,2.249,5.574,2.513c2.475,0.306,2.623,1.017,4.549,2.244
		c1.93,1.229,3.568,1.122,4.494,3.706c1.127,0.222,2.851,1.059,3.957,0.981c1.917-0.135,1.568-1.243,3.25-1.882
		c2.696-1.023,3.136,2.883,5.719,2.145c0.02-0.157-0.132-0.436-0.126-0.476c2.428,0.499,4.635,0.251,4.912-2.725
		c0.166-1.783-0.821-2.229,0.307-3.95c0.902-1.377,1.682-1.119,2.938-1.75c2.91-1.462,1.523-2.517-0.195-5.207
		c-1.057-1.656-1.514-1.192-0.748-3.105c0.483-1.207,1.624-1.218,1.232-2.95c3.406-0.651,5.911-3.819,7.255-6.999
		c2.179,0.225,4.086,1.398,5.469,3.219c0.672,0.884,0.712,2.579,1.275,3.249c0.687,0.818,1.893,0.365,2.656,1.282
		c0.424,0.51,0.623,2.534,0.561,3.212c-0.153,1.689-1.203,0.748-0.186,2.694c0.404,0.773,1.526,1.199,1.988,1.976
		c0.688,1.157,0.411,2.492,1.107,3.573c1.377,2.137,3.386,1.488,5.085,1.989c2.879,0.849,2.527,2.792,2.57,5.026
		c0.006,0.303,0.24,1.997,0.199,2.229c-0.144,0.814-1.138,1.323-1.03,2.258c0.169,1.454,2.567,3.945,3.969,3.712
		c0.072-0.935,0.503-0.44,1.043-0.713c1.486,0.45,3.296-0.762,5-1.487c1.977-0.841,3.99-0.418,6.468-0.551
		c-0.248-1.347-0.606-3.017-0.431-4.428c1.12,0.275,0.801,1.538,1.451,1.966c1.627,1.072,0.35-0.073,1.513-0.248
		c1.296-0.195,2.336-1.213,3.249,0.999l-0.049-0.45c3.697,2.873,9.124,6.66,12.688,4.339c1.962-1.278,4.114-4.322,5.248-6.361
		c1.434-2.578,0.71-6.302,1.939-8.528c3.843-6.959,9.993-0.863,14.301-3.625c5.909-3.789,1.144-14.237-3.31-10.05
		c1.555-2.488,3.721-7.445,2.958-10.823c-0.961-4.26-5.371-4.418-4.449-9.924c4.368,0.199,8.363,8.408,7.924,11.949
		c-0.538,4.347-3.302,7.937,2.924,9.91C267.121,502.598,270.364,499.818,270.012,494.987z M225.934,484.574
		c-1.595,2.313-4.132,6.135-4.371,9.351c-1.835,0.271-2.464-1.393-3.7-1.41c-0.12-0.001-3.276,0.189-3.863,0.121
		c-3.972-0.462-4.858,0.423-3.986-3.621c0.523-2.427,3.203-4.725,3.497-7.503c0.349-3.296-1.644-6.07-1.012-9.012
		c0,0,0.366-0.717,0.597-1.934c1.752,0.461,1.319,2.678,1.893,2.932c2.235,0.991,1.499,0.869,5.008,0.492
		c3.401-0.366,5.72-0.843,8.075,1.971C226.329,477.57,220.567,483.961,225.934,484.574z M226,418.5
		c0.82-0.656,4.067-1.268,4.811-0.573c0.87,0.812,0.934,5.365-0.816,5.078c-1.538-0.252-0.033-1.59-0.727-2.28
		c-0.792-0.787-1.749-0.258-2.767-0.481c-0.901-0.197-2.393,0.47-1.512-1.188c0.383-0.72,1.701-0.921,2.262-0.806"
      />
    </a>

    <a (click)="SelectCode('CA')">
      <path
        [class.selected]="IsSelected('CA')"
        id="CA"
        d="
		M438.204,505.034c-1.937,0.863-4.642,2.938-7.216,1.534c-1.239-0.676-1.363-2.707-2.682-3.397
		c-1.672-0.875-3.884,0.521-5.519,0.292c-0.815-0.114-2.755-0.843-3.293-1.456c-0.861-0.982-0.22-1.485-0.744-2.507
		c-1.027-2.003-4.217-3.104-6.514-4.313c-1.693-0.891-2.032-0.898-3.779-0.957c-1.78-0.06-1.594,0.05-3.264-0.487
		c-3.125-1.005-5.041,0.037-7.887,0.187c-1.588,0.084-1.524-0.457-3.039,0.565c-0.78,0.526-3.766,2.498-4.217,3.242
		c-1.024,1.689,0.121,3.835-1.363,5.999c-2.868,4.183-8.734,1.854-12.188,5.013l0.253-0.077c-1.133-3.688-3.439-7.015-6.526-9.333
		c-1.122-3.106-2.77-5.259-4.744-7.906c3.033-2.339,4.901-6.12,4.917-9.95c0.007-1.559-0.258-3.212,0.44-4.606
		c0.659-1.315,2.026-2.094,3.07-3.131c4.378-4.349,2.491-12.387,6.587-17.002c1.881,1.184,4.474,1.11,6.283-0.18
		c-2.164,1.543-5.589-3.315,0.12-4.128c2.233-0.318,2.661,0.405,4.656,1.053c1.8,0.585,3.606,0.175,5.562,0.103
		c-1.413-0.478-1.546-2.855-0.195-3.487L396,450.25c0.681-1.674,2.866-1.549,3.512-3.244c0.538-1.41-0.373-3.788-1.98-3.799
		c-0.975-2.93,2.054-1.392,2.774-1.506c1.292-0.205,3.016-1.485,3.944-0.164c0.471-0.58,0.759-1.418,0.788-2.243
		c0.872-0.427,2.201-0.885,2.907-1.599c0.915-0.927,0.803-2.24,2.056-2.888c3.553-1.836,1.004,2.776,3.218,3.432
		c1.476-0.974,2.148-3.522,4.088-3.68c1.811-0.147,1.919,1.509,3.382,2.004c2.947,0.996,8.229-4.295,9.011,1.908
		c0.296,2.348-0.832,1.838-1.51,3.518c-0.671,1.663,0.325,3.335,0.073,5.026c-0.143,0.963-1.155,2.749-1.825,3.424
		c-1.131,1.141-3.861,0.747-3.649,2.519c2.012,0.714,2.636,0.348,4.151,1.774c0.826,0.779,1.265,1.236,2.06,1.769
		c0.764,0.511,1.11,0.196,1.944,1.002c1.597,1.543,2.498,4.48,4.061,6.254c1.077,1.222,2.36,2.061,3.244,3.494l-0.159-0.43
		c-0.183,0.236-0.378,0.539-0.591,0.924c-0.717,1.298-0.896,2.631-1.319,4.018c-0.166,0.546-0.054,1.342-0.414,1.806
		c-0.732,0.942-1.462,0.565-2.157,1.182c-1.485,1.319-1.402,0.773-0.549,3.25c0.437,1.27,0.753,2.603,1.376,3.744
		c1.289,2.359,4.187,3.744,6.567,5.262c2.253,1.437,4.497,1.71,4.244,4.244c-0.246,2.467-2.694,4.069-4.001,5.938
		c-1.821,2.605-1.793,4.228-2.187,6.813c-0.057,0.372-0.123,0.755-0.196,1.146L438.204,505.034z"
      />
    </a>

    <a (click)="SelectCode('CB')">
      <path
        [class.selected]="IsSelected('CB')"
        id="CB"
        d="
		M584.5,714c-0.103-1.123,1.037-2.678,1.687-3.813c0.251-0.438,0.715-0.874,0.875-1.388c0.161-0.518-0.082-1.605-0.019-1.799
		c1.013-3.146,3.598-2.165,5.457-4.65l-0.25,0.65c0.28,0.076,0.464-0.005,0.55-0.244c-1.535-3.097-2.963-6.199-4.3-9.561
		c-0.992-2.493-1.183-1.95-3.3-3.127c-2.173-1.208-1.523-2.327-2.244-4.28c-2.298,0.421-2.755-3.185-2.212-4.794
		c0.609-1.803,2.091-2.44,2.468-4.712c-2.146,1.17-1.456-0.359-1.907-1.226c0.086,0.166,0.229-0.998,0.144-1.256
		c0.022,0.067-1.829-0.627-1.924-0.656c1.933-4.017-4.714-2.204-6.743-1.352c-0.138,1.559-1.146,2.871-2.757,3.252
		c0.861,1.743-0.811,2.7-2.269,2.968c-0.883,0.163-1.769-0.283-2.58-0.073c0.47-0.122-1.715,1.394-1.426,1.055
		c-1.442,1.694-0.783,0.851-0.225,3.269c0.18,0.779,0.46,3.578-0.013,4.212c-2.45-1.223-1.458,1.177-2.3,1.78
		c-0.995,0.713-2.372,0.675-3.213,1.245c-0.765,0.519-1.422,2.361-2.742,2.519c-1.233,0.147-1.767-1.287-3.219-0.725
		c-0.347,2.743,1.981,3.945,1.962,6.706l0.006,0.007c1.237,0.614,0.186,0.602,0.433,1.687c0.256,1.124-0.466,3.262,1.575,3.273
		c0.386,0.002,0.75-1.488,1.737-1.471c1.103,0.019,0.762,1.014,1.549,1.441c1.799,0.977,2.351,1.31,3.706,2.557
		c1.82,1.675,5.229,3.874,4.243,7.506c-0.541,1.994-2.44,1.42-2.948,2.807c-0.657,1.794,2.128,1.655,1.231,3.644
		c0.95,0.271,1.384,0.825,1.468,1.55l0.043-0.571c0.232-0.278,0.727-0.419,1.718-0.434c0.783-0.012,0.728,0.919,1.671,0.961
		c0.77,0.034,2.124-0.739,2.892-0.894c0.711-0.143,2.091-0.04,2.693-0.3c0.751-0.324,1.351-1.556,1.975-1.78
		c1.593-0.57,3.183,1.381,4.581,0.579c1.5-0.86,0.702-2.657-0.036-3.762c0.489-0.419,0.866-0.683,1.17-0.821L584.5,714z"
      />
    </a>

    <a (click)="SelectCode('CF')">
      <path
        [class.selected]="IsSelected('CF')"
        id="CF"
        d="
		M397.8,756.918c-2.774,1.118-5.219,3.166-5.598,6.046c-0.097,0.734-0.052,1.492-0.271,2.199c-0.368,1.193-1.42,2.044-2.508,2.656
		c-7.614,4.279-17.03-0.208-24.387-4.914c-1.56-0.998-3.137-2.031-4.328-3.45c-0.304-0.362-0.579-0.745-0.834-1.142l-0.625-0.062
		c0.225-2.146,1.98-1.537,3.181-2.55c0.869-0.732,1.668-2.237,2.036-3.151c-2.568-0.327-1.157-4.826,0.026-5.811
		c1.197-0.997,3.895-0.18,5.718-0.276c0.255-1.2-1.683-3.363-1.962-4.962c-0.484-2.771-0.199-2.649,1.507-4.438
		c1.52-1.595,1.781-2.615-0.257-4.074c-1.043-0.747-1.538,0.542-2.444-1.051c-0.683-1.2,0.03-2.67,0.23-3.898
		c2.443,0.364,3.95,0.332,6.408,0.198c0.79-0.043,1.911,0.457,2.556,0.28c0.959-0.264,1.464-1.515,2.499-1.717
		c4.987-0.975,4.508,5.807,5.556,8.395c0.695,1.715,1.625,3.336,2.699,4.818c1.411,1.946,1.769,2.29,2.05,4.475
		c0.218,1.697,0.667,4.1,2.258,5.206c0.818,0.569,4.703,0.772,2.212,2.807c1.573,1.032,5.026,2.102,4.724,4.5L397.8,756.918z"
      />
    </a>

    <a (click)="SelectCode('CH')">
      <path
        [class.selected]="IsSelected('CH')"
        id="CH"
        d="
		M410.75,604.25c-2.701,4.334,3.479,1.575,5.012,3.237c1.056,1.145-0.949,5.139-2.292,5.77c0.449,0.407,2.073,0.529,2.303,0.919
		c0.552,0.93-0.333,1.575-0.285,2.574c0.053,1.096,1.025,4.266,1.262,4.25l-0.958-0.067c-0.912-0.008-1.885,0.363-2.804,1.292
		c-1.307-0.336-3.071-3.334-4.519-1.786c-1.223,1.308,1.071,3.082-0.358,3.982l-0.441-0.126c-0.489-1.072-1.158-2.026-1.488-3.24
		c-0.555-2.039,0.654-2.653-1.682-3.798c-1.708-0.837-2.846-0.219-4.238-0.24c-2.025-0.03-2.095-0.612-3.962,0.801
		c-1.258,0.952-2.323,2.863-3.744,3.505c-0.561,0.253-3.538,0.638-4.319,0.439c-2.634-0.669-1.277-1.916-0.212-3.262
		c-1.237-1.385-0.576-3.088-1.326-4.445c-0.617-1.117-1.931-1.034-2.486-1.994c-0.438-0.758-0.554-2.703-0.726-3.574
		c-0.384-1.941-2.56-9.525-0.487-9.737l1.076-0.328c5.111,1.239,6.044,8.026,10.653,9.525c0.91-1.023,1.488-2.17,2.196-3.348
		c-2.217-1.783-1.659-3.88-2.889-5.598c-1.546-2.16-4.197-3.073-4.997-5.878c2.218-0.489,4.935-3.818,6.752-3.279
		c2.039,0.608,6.693,9.126,8.708,11.043c0.804,0.765,3.584,2.565,5.633,2.915L410.75,604.25z"
      />
    </a>

    <a (click)="SelectCode('CM')">
      <path
        [class.selected]="IsSelected('CM')"
        id="CM"
        d="
		M607.75,736.25c-1.39-1.589-3.955-4.349-6.206-3.476c-0.011,4.103-4.356-0.902-5.045-1.885c-0.759-1.083-1.998-2.583-1.96-3.89
		c0.037-1.294,1.676-1.444,0.929-3.211c-1.032,0.031-3.383-0.409-4.224-1.038c-1.289-0.964-0.951-2.613-2.177-3.993
		c-0.886-0.998-1.861-0.643-2.78-1.445c-1.03-0.898-0.28-1.317-0.774-2.068c-0.858-1.302-1.017-2.123-2.974-0.445
		c0.737,1.105,1.536,2.902,0.036,3.762c-1.398,0.802-2.988-1.149-4.581-0.579c-0.625,0.224-1.224,1.456-1.975,1.78
		c-0.603,0.26-1.983,0.157-2.693,0.3c-0.768,0.155-2.122,0.928-2.892,0.894c-0.943-0.042-0.889-0.973-1.671-0.961
		c-2.642,0.041-1.761,0.977-1.762,3.006c0,1.617,0.108,4.121-0.3,5.687c-0.989,3.798-2.751,5.418-6.355,6.049
		c0.576,0.767,0.793,1.75,0.693,2.725c0.871-0.001,1.608-0.054,2.43-0.174c-0.327,1.407-0.636,6.671,0.282,6.712l2.75,1.75
		c-0.258-0.152-0.525-0.262-0.73-0.436c0.72-0.43,1.563-0.726,2.436-0.856c0.603-2.928,5.949,0.19,3.519,2.044
		c0.778,2.467,4.213,7.045,6.775,7.768c0.554,0.156,1.065-0.362,1.622-0.527l0.628-0.242c1.671-3.144,2.796-3.196,5.956-3.288
		c0.175-1.217,0.453-2.351,0.831-3.424c1.002,0.026,2.139-0.038,2.706-0.038c1.17,0,1.449,0.12,2.739,0.5
		c1.485,0.437,3.355-0.002,4.89,0.047c1.975,0.063,3.29,0.727,5.183,1.147c1.978,0.439,4.263,0.056,6.444,0.056l0.177-0.227
		c-0.1-0.239-0.17-0.494-0.176-0.773c-0.051-2.423,2.481-3.619,0.338-6.047c-0.625-0.708,2.424-2.387-1.036-2.661
		c-1.617-0.128-4.91,1.239-6.721,1.528c1.577-1.741,3.5-3.16,5.615-4.18L607.75,736.25z"
      />
    </a>

    <a (click)="SelectCode('CO')">
      <path
        [class.selected]="IsSelected('CO')"
        id="CO"
        d="
		M607.75,736.25c-1.39-1.589-3.955-4.349-6.206-3.476c-0.011,4.103-4.356-0.902-5.045-1.885c-0.759-1.083-1.998-2.583-1.96-3.89
		c0.037-1.294,1.676-1.444,0.929-3.211c-1.032,0.031-3.383-0.409-4.224-1.038c-1.289-0.964-0.951-2.613-2.177-3.993
		c-0.886-0.998-1.861-0.643-2.78-1.445c-1.03-0.898-0.28-1.317-0.774-2.068c-0.429-0.651-0.683-1.182-1.075-1.34L584.5,714
		c-0.103-1.123,1.037-2.678,1.687-3.813c0.251-0.438,0.715-0.874,0.875-1.388c0.161-0.518-0.082-1.605-0.019-1.799
		c1.013-3.146,3.598-2.165,5.457-4.65c0.784,1.307,0.387,2.508,1.981,3.156c1.213,0.493,4.369,0.012,5.575-0.182
		c1.742-0.279,4.037-2.43,5.394-0.83c1.143,1.348-0.475,3.767-0.407,5.213c1.724,1.144,9.277,10.379,8.745,3.581
		c2.78-0.481,2.416,2.226,0.931,3.454c0.952,1.122,3.016,0.736,3.723,1.758c1.404,2.026-1.105,1.902-2.173,2.449
		c3.24,0.221,10.303-1.44,11.98,1.55l-1.129-0.51c-0.372,0.16-0.757,0.507-1.183,1.208c-0.458,0.752-1.447,0.715-0.631,2.002
		c0.452,0.713,1.634,0.174,1.956,0.539c3.525,3.981-11.223,12.409-12.246,10.886c-0.489-0.728-0.978-1.456-1.468-2.184
		c-2.029,0.23-4.013,0.814-5.852,1.7L607.75,736.25z"
      />
    </a>

    <a (click)="SelectCode('CR')">
      <path
        [class.selected]="IsSelected('CR')"
        id="CR"
        d="
		M561.75,778.25c-0.443-2.554,0.435-5.285-0.981-7.5c-0.728-1.139-1.858-2.453-3.019-3.218c0.197,0.13-2.212-0.856-1.937-0.794
		c-0.545-0.123-0.519-0.675-1.277-0.7c-0.066,0.236,0.008,0.443-0.073,0.675c-1.384,0.076-3.806-2.548-3.961,0.288
		c-0.106,1.945,3.305,2.261,3.46,3.798c0.143,1.419-2.642,2.362-3.211,3.702c-0.481,1.132-1.259,4.32-0.001,4.249l0.231-0.514
		c1.622-0.836,1.182-0.87,3.031-0.242c1.351,0.458,0.985,0.712,2.751,0.688c0.895-0.012,2.058-0.132,2.993-0.231
		c1.005-0.106,1.048-0.719,1.497-0.698L561.75,778.25z"
      />
    </a>

    <a (click)="SelectCode('CT')">
      <path
        [class.selected]="IsSelected('CT')"
        id="CT"
        d="
		M615.75,798c-0.393-1.251-1.893-2.109-3.199-1.538c-1.446-2.339,3.086-3.3,3.698-5.213c1.049-3.28-1.428-3.883-3.048-5.555
		c-0.581-0.599-0.738-1.502-1.434-2.007c-0.755-0.547-1.948-0.314-2.578-0.737c-1.154-0.774-2.107-1.515-0.877-2.901
		c1.07-1.206,5.914-1.601,5.899-3.756c-2.412-0.352-0.762-2.823-0.946-3.863l0.101-0.75c3.071-0.428,6.181-1.183,9.208-1.424
		c1.296-0.103,14.09-1.245,14.279-0.578c0.466,1.642,0.861,3.619-0.289,4.879c0.674,0.168,0.372-0.66-0.294-0.464
		c-2.068,0.61-2.909,3.144-2.789,5.296c0.121,2.153,0.872,4.276,0.636,6.419c-0.453,4.118-4.355,6.981-8.221,8.472
		c-3.204,1.235-6.674,1.936-9.691,3.505L615.75,798z"
      />
    </a>

    <a (click)="SelectCode('CV')">
      <path
        [class.selected]="IsSelected('CV')"
        id="CV"
        d="
		M475.5,718.5c0.142-2.619,4.508-3.774,4.448-6.725c-1.141,0.591-2.323,1.75-3.661,1.687c-0.184-1.172,0.4-3.612,1.158-4.462
		c1.658-1.863,0.645,0.377,2.754,0.718c0.756-2.125,1.02-3.932,2.819-4.987c1.585-0.929,4.903-1.304,3.819-4.193
		c0.558-0.066,1.566,0.061,2.12,0.255L489,701c0.736-1.673,2.61-1.658,3.512-3.001c1.298-1.931,0.194-1.393-0.505-2.561
		c-0.243-0.406-2.596-2.185-1.725-3.206c0.988-1.157,2.855,0.444,3.005,1.481c2.559,0.719,2.634-2.232,1.501-3.645
		c1.022-1.56,2.566-0.55,3.656,0.15c0.412-1.494,0.49-2.772,0.257-4.155c-0.103-0.613-1.029-0.468-0.969-1.563
		c0.043-0.784,1.129-1.288,1.336-1.932l0.182,0.182c-0.023-0.258,0.031-0.455-0.044-0.706c-1.947-0.479-2.72-0.831-4.013-2.525
		c-1.177-1.542-2.631-5.206-4.706-5.286c-1.05-0.041-3.566,3.009-4.513,0.268c-0.233-0.675,1.124-1.507,0.78-2.45
		c-0.297-0.813-1.755-0.84-2.022-1.8c-0.449-1.617,1.949-4.667,2.71-6.056c0.673-1.229,1.742-4.855,1.013-6.139
		c-0.999-1.759-8.75-1.026-10.869-1.073c0.646,2.578-1.407,6.466-4.295,6.805c-1.342,3.663-2.979,4.968,1.942,6.201
		c-0.388,1.477-1.571,2.333-1.798,3.973c-2.848-1.438-4.011,4.309-1.705,5.802c-1.482,1.554-0.891,4.47-1.725,6.243
		c-0.28,0.596-0.911,1.532-1.25,2.488c-0.491,1.388-0.411,2.808-0.751,4.012c-0.583,2.065-2.162,4.339-3.187,6.556
		c-0.578,1.249-1.386,2.205-1.581,3.439c-0.153,0.967,0.378,1.959,0.013,3l1.232,1.251c2.412-1.989,2.738,0.475,4.019,2.012
		c1.27,1.525,4.124,1.28,5.073,2.469c0.758,0.949-0.284,4.358-0.803,4.975c1.766,0.163,2.518,0.628,2.678,1.265L475.5,718.5z"
      />
    </a>

    <a (click)="SelectCode('CW')">
      <path
        [class.selected]="IsSelected('CW')"
        id="CW"
        d="M416,608
		c0.524-1.682,1.568-0.361,2.5-0.807c1.819-0.87,0.782-0.4,1.181-1.931c0.183-0.7-0.211-2.058,0.632-2.712
		c0.882-0.684,1.863,0.239,2.942-0.546c2.185-1.589,0.66-4.392,4.245-3.524c0.188,0.045,2.61,1.299,2.705,1.507
		c0.357,0.779-1.014,1.501-0.773,2.581c0.143,0.64,1.465,1.13,1.769,1.677c0.51,0.919,0.113,2.698,0.614,3.199
		c0.95,0.951,1.566,0.235,2.741-0.006c2.157-0.443,1.572-0.677,3.201,0.505c1.408,1.021,2.593,3.448,4.743,3.055
		c1.913-0.349,2.311-2.814,4.249-0.011c1.018,1.472,0.338,2.333-0.046,3.415l-1.146,0.654c-0.851,0.212-1.933,1.321-2.75,1.756
		c-1.913,1.019-4.361,0.419-6.251,1.743c-1.533,1.074-0.953,1.045-1.063,2.389c-0.033,0.408-0.093,3.311,0.002,4.054
		c0.159,1.244,3.184,5.731-0.457,5.789l0.712,0.463c-0.81-0.945-4.473-0.154-5.818-0.068c-1.072,0.068-1.566,0.387-2.938,0.123
		c-0.799-0.154-1.127-0.667-1.642-0.6l0.11-0.418c-1.611-0.034-2.686-1.967-3.725-2.988c-1.586-1.558-1.618-2.361-2.431-3.993
		c-0.515-1.033-1.482-1.923-2.626-2.244l0.07-0.061c-0.237,0.016-1.208-3.154-1.262-4.25c-0.048-0.999,0.837-1.644,0.285-2.574
		c-0.231-0.389-1.854-0.512-2.303-0.919c1.095-0.514,2.631-3.265,2.587-4.884L416,608z"
      />
    </a>

    <a (click)="SelectCode('DA')">
      <path
        [class.selected]="IsSelected('DA')"
        id="DA"
        d="
		M569.307,770.694c-0.195,0.208,1.027-1.47,0.943-1.244c0.436-1.17,0.966-1.659,0.707-3.168c-2.471,0.717-4.141-0.065-6.13-0.759
		l-0.077,0.227c-0.553-0.948-0.342-1.893,0.726-2.3c-0.324-0.408-0.24-0.871-0.689-1.263c0.387-1.307,1.692-1.369,2.919-1.231
		c0.045-0.538,0.517-1.191,0.538-1.681c2.613,1.874,11.156,7.502,14.256,4.474h1.25c2.066,3.498-1.987,7.044-3.818,9.932
		l0.568,0.068c-2.104,0.535-1.007-0.905-1.738-1.513c-1.272-1.058-1.048-0.777-2.518-0.924c-1.56-0.156-4.013-0.218-4.689,1.856
		c-0.407-0.879-1.194-1.475-2.056-1.919L569.307,770.694z"
      />
    </a>

    <a (click)="SelectCode('DD')">
      <path
        [class.selected]="IsSelected('DD')"
        id="DD"
        d="
		M441.595,267.16c-1.58,4.318-3.517,8.711-7.314,11.211c-1.257,0.828-2.695,1.427-3.725,2.523s-1.499,2.953-0.5,4.079
		c-1.192,0.013-2.384,0.026-3.576,0.039c0.567,0.973,1.536,1.703,2.627,1.981c-1.65,8.414-7.331,15.944-14.969,19.841
		c-7.096,0.334-14.086,2.413-20.263,5.917l-0.126-0.501c-0.208-0.938-1.034-1.476-1.323-2.251c-0.101-0.27,0.676-0.938,0.536-1.499
		c-0.142-0.568-1.091-0.965-1.281-1.482c-0.697-1.9-1.724-5.057,0.319-6.017c1.628-0.765,4.878,1.172,4.567-2.439
		c-0.108-1.258-1.297-1.282-1.823-2.25c-0.553-1.017,0.14-1.548-0.233-2.325c-0.382-0.797-1.368-0.786-1.836-1.475
		c-0.635-0.937-0.935-2.03-1.607-3.024c-1.295-1.916-2.054-3.003-1.373-5.488c0.526-1.919,3.15-2.908,2.06-4.749
		c-0.34-0.574-1.911-1.173-2.442-1.758c-0.754-0.83-1.043-1.777-1.493-2.744c-0.364-0.781-0.514-1.639-1.001-2.306
		c-0.636-0.872-2.27-1.488-2.593-2.425c-0.056-0.161,0.463-3.069,0.525-3.519c0.19-1.378,0.117-2.279,1.238-3.243
		c0.627-0.539,2.899-1.608,3.76-1.712c1.827-0.22,2.352,0.875,3.8,1.474c3.584,1.483,4.32,0.366,6.407-2.048
		c2.365-2.737,4.038-2.712,7.044-2.97c1.295-0.111,2.931-0.78,4.208-0.512c1.424,0.299,2.349,1.717,3.541,2.449
		c1.839,1.129,4.767,1.804,5.318,4.263c0.416,1.857-1.053,4.008-0.38,6.3c0.522,1.775,1.879,3.336,2.069,5.006
		c0.091,0.802-0.835,1.368-0.711,2.189c0.145,0.965,1.613,0.728,1.286,2.073c1.394,0.026,1.876-1.365,2.913-1.465
		c0.954-0.092,1.999,1.239,2.751,1.099c3.697-0.691-2.072-6.148,2.962-4.862c0.398,3.712,4.298-1.926,5.232-3.026
		c0.653-0.769,1.372-3.039,1.863-3.462c0.92-0.792,2.345-0.865,3.412-1.28L441.595,267.16z"
      />
    </a>

    <a (click)="SelectCode('DE')">
      <path
        [class.selected]="IsSelected('DE')"
        id="DE"
        d="
		M461.25,641c0.798,0.003,3.386,0.529,3.944,0.212c1.993-1.131,0.678-2.57-0.444-3.218c-1.824-1.054-2.197,0.926-2.494-2.007
		c-0.158-1.561,0.025-2.796,1.957-2.026c0.471-1.808-2.249-3.348-2.525-5.456c-0.262-1.999,0.558-4.08,0.554-5.443
		c-0.002-0.569-0.346-2.604-0.857-3.918L461,618.5c0.43-2.233,3.198,0.136,4.944-0.306c1.728-0.437,2.138-1.99,3.024-3.152
		c-1.915-0.067-2.223-1.098-3.199-2.299c-1.412-1.737-2.123-1.339-0.019-2.987c0.738-0.579,1.316-0.359,2.005-1.258
		c0.525-0.685,0.293-2.125,0.794-2.754c1.254-1.574,3.182-0.895,4.951-0.746c2.288,0.193,2.757-0.236,3.556,1.995
		c0.872,2.436,1.413,4.002,2.876,6.244c0.364,0.557,1.164,2.816,1.75,3.029c1.526,0.557,0.872-0.825,2.013-1.049
		c0.818-0.161,1.686,0.56,2.368,0.488c1.274-0.136,2.398-1.044,3.45-1.736c0.468,0.427,1.51,3.089,1.438,3.58
		c-0.222,1.525-1.58,2.222-2.194,3.7c-1.463,3.519-0.744,4.605,1.426,7.7c0.996,1.422,2.193,2.444,1.623,4.049
		c-0.634,1.788-1.553,1.06-1.604,3.25c-0.068,2.96,1.57,5.151,3.799,7.251l-0.214,0.436c-1.679,1.257-4.999,1.492-6.541,1.801
		c-1.739,0.348-4.14,0.157-5.069,1.069c-0.998,0.981-1.923,4.167-2.657,5.449c0.976,0.638,2.004,1.296,2.955,1.981
		c-0.64,0.863-1.326,1.821-0.474,2.763l-4.161-0.032c-0.09-0.141-0.189-0.27-0.298-0.391c-1.008-1.113-2.79-1.406-4.247-1.871
		c0.102-1.542-2.157-3.008-2.71-1.722L471.5,653c-1.755-1.482-2.153-0.355-3.987-0.182c-1.43,0.135-4.122-0.128-5.486-0.874
		c0.381-1.835,1.951-2.635,1.796-4.702c-0.041-0.551-0.459-2.08-0.56-2.742c-0.122-0.801-0.079-1.261-0.457-2
		c-0.287-0.561-0.521-0.896-0.742-1.078L461.25,641z"
      />
    </a>

    <a (click)="SelectCode('DG')">
      <path
        [class.selected]="IsSelected('DG')"
        id="DG"
        d="
		M408.845,436.145c-0.243,0.525-0.444,1.085-0.901,1.549c-0.705,0.714-2.035,1.172-2.907,1.599
		c-0.028,0.825-0.317,1.663-0.788,2.243c-0.928-1.321-2.651-0.041-3.944,0.164c-0.72,0.114-3.75-1.424-2.774,1.506
		c1.608,0.011,2.518,2.389,1.98,3.799c-0.553,1.451-2.234,1.568-3.133,2.622l-0.364,0.408c-9.124-0.658-18.311-0.432-27.391,0.676
		c1.249,2.825,1.922,7.124-1.001,8.121c-0.732,0.25-1.528,0.186-2.302,0.167c-4.025-0.097-8.07,1.163-11.327,3.528
		c0.657,0.873,1.314,1.746,1.971,2.619c-1.869-0.284-3.571,1.005-5.043,2.19c-1.472,1.185-3.254,2.411-5.095,1.981
		c-1.841-0.43-2.583-3.58-0.761-4.081c-1.013-0.076-2.025-0.151-3.038-0.226c-0.466,1.139-0.931,2.279-1.397,3.419
		c-3.037-1.843-5.335-4.87-6.295-8.291c-3.157,2.269-8.257,0.883-9.831-2.672c0.02,3.754,1.873,7.455,4.867,9.72
		c-1.117,3.227-2.234,6.454-3.352,9.681c-2.686-1.384-5.371-2.767-8.057-4.151c-0.718-0.37-1.457-0.757-1.965-1.385
		c-0.423-0.524-0.651-1.174-0.972-1.766c-2.554-4.707-9.898-4.471-13.153-8.725c-2.721-0.065-4.668,2.939-4.602,5.66
		c0.066,2.72,1.503,5.186,2.73,7.615c1.228,2.429,2.302,5.187,1.594,7.815c-2.937,0.01-5.021-2.897-5.972-5.676
		c-0.951-2.779-1.387-5.885-3.356-8.065c-1.1-1.219-2.582-2.022-3.802-3.12c-5.252-4.726-4.314-13.086-2.708-19.967
		c4.068,1.377,6.537,6.303,5.205,10.386c1.07-0.024,2.139-0.048,3.209-0.072c-1.358-2.762-1.996-5.841-1.949-8.915l-0.003-0.011
		c1.092-0.382,2.628,0.271,3.474-0.46c1.436-1.239-0.275-3.776,1.075-5.043c0.922-0.865,4.635-0.708,5.737-0.245
		c1.812,0.762,1.534,2.762,3.046,3.58c1.276,0.691,6.543-0.364,7.478-1.518c1.476-1.82-0.377-1.635-1.084-3.35
		c-1.159-2.813,2.036-3.165,2.308-5.206c0.204-1.534-1.387-3.501-1.216-5.467c1.917-0.047,4.79-0.489,6.4,0.519
		c1.411,0.883,1.406,2.601,3.506,2.955c1.259,0.212,2.292-0.547,3.55-0.012c1.044-1.074,2.276-3.131,2.694-4.462
		c0.685-2.186-0.743-3.445-0.149-5.457c0.582-1.969,2.163-3.23,3.98-3.581c1.346-0.26,2.254,0.642,3.213,0.531
		c3.585-0.414,4.188-3.847,4.825-6.514c0.98-4.1,4.295-6.54,5.23-10.721c2.626-0.083,3.397,2.204,6.514,1.411
		c2.749-0.7,2.169-1.387,3.449,0.861c0.635,1.115,0.51,1.952,1.78,2.677c-1.479,2.121-2.458,2.901-0.543,5.01
		c1.679,1.849,2.872,1.285,4.95,0.277c0.662,1.648,2.712,5.366,5.063,4.743c3.677-0.974,1.459-5.257,1.995-7.462
		c1.543-6.352,11.708,1.432,13.148-4.592l0.802-0.409c0.894,0.919,1.932,1.337,2.312,3.001c0.327,1.433-0.368,2.419-0.325,3.749
		c0.129,3.968,1.645,1.208,3.813,1.496c1.101,0.146,2.553,1.749,3.506,2.186c1.163,0.533,2.125,0.349,3.011,1.265
		c1.369,1.414,0.935,4.257,3.177,5.311c1.944,0.914,4.431-0.923,6.28,0.427c-1.685,4.261,2.444,2.974,2.593,5.762
		c0.1,1.875-2.528,3.578-2.335,5.462c0.162,1.578,1.905,2.046,3.524,2.788L408.845,436.145z"
      />
    </a>

    <a (click)="SelectCode('DH')">
      <path
        [class.selected]="IsSelected('DH')"
        id="DH"
        d="
		M486.5,470.25c0.436,0.135,0.795,0.058,1.075-0.231c-0.018-0.783-0.078-3.707-0.321-4.025c-1.126-1.473-2.362-0.072-3.009-2
		c-0.249-0.74,0.706-2.049,0.204-3.238c-0.397-0.94-2.176-2.875-2.949-3.536c-0.93,0.398-2.077,2.259-3,2.298
		c-1.738,0.075-0.772-0.713-1.068-1.586c-0.253-0.746,1.138-2.535-1.194-2.692c-0.756-0.051-1.388,1.263-2.225,1.497
		c-1.8,0.503-2.044-0.977-3.526-0.948c-0.873,0.017-1.868,1.426-2.787,1.656c-2.408,0.603-4.852-0.108-5.244-2.655
		c-1.879,0.325-3.934,0.04-5.762,0.649c-1.191,0.396-1.469,0.962-2.444,1.506c-1.288,0.719-2.019,0.653-3.438,1.051
		c-2.857,0.802-1.172,1.022-2.251,3.262c-0.745,1.547-2.763,1.744-3.311,3.494l0.755-0.211c0.857,0.036,1.703,1.626,2.733,1.729
		c1.225,0.122,2.808-1.48,4.005-1.273c1.418,0.246,1.37,1.706,2.319,2.448c1.623,1.269,0.358,0.548,1.688,0.051
		c0.891-0.333,1.723-1.945,3.006-0.513c0.093-0.464,0.517-0.908,0.568-1.437c3.641-1.155,4.427,1.98,3.965,4.918
		c1.16-0.117,2.359-0.82,3.46-1.181c0.667,1.268,5.064,0.486,2.739,3.75c1.553,0.579,3.357-0.135,4.775,0.165
		c0.988,0.208,1.944,1.098,2.986,1.373c1.181,0.312,2.425-0.316,3.251-0.136l0.974-0.317c0.297-0.84,0.82-1.624,1.478-2.164
		c0.115-0.094,2.211-1.444,2.298-1.464L486.5,470.25z"
      />
    </a>

    <a (click)="SelectCode('DL')">
      <path
        [class.selected]="IsSelected('DL')"
        id="DL"
        d="
		M456.469,523.377c0.018-0.655,0.104-1.236,0.262-1.627c0.768-1.894,3.578-3.675,5.286-4.7c1.399-0.839,3.332-0.416,4.05-1.04
		c1.973-1.715-0.411-4.26,3.182-3.453c1.721,0.386,2.454,1.344,4.456,1.231c1.445,2.889-1.788,3.19,1.732,5.269
		c1.591,0.939,4.312,2.627,6.043,0.951c0.029,0.273-0.048,0.52-0.232,0.743l0.676-0.772c-0.756-1.615-1.489-3.153-1.388-5.441
		c0.41-0.021,0.95-0.32,1.186-0.339c-1.435-1.805-0.978-3.273,1.732-2.656c1.892,5.263,5.971-2.31,6.788-3.3
		c2.195-2.663,2.779,0.365,4.819,0.944c1.834,0.521,1.497-1.306,2.525-1.681l0.163-0.006c0.092-0.272-1.011-3.442-1.439-4.25
		c-0.598-1.129-1.62-1.715-2.561-2.487c-1.573-1.29-0.964-0.988-2.94-1.513c-1.056-0.28-1.601-0.346-2.51-0.764
		c-0.331-0.152-0.448-0.809-0.857-0.93c-1.259-0.372-2.594,0.776-3.525,0.21c-2.431-1.476,1.208-3.864,1.343-5.517
		c0.064-0.782-0.681-2.642-1.011-3.306c-0.265-0.533,0.284-1.085-0.233-1.516c-0.63-0.526-1.086,0.395-1.657,0.133
		c-2.71-1.244-2.798-1.915-2.599-5.012c0.113-1.751-0.309-1.865,0.557-3.494c0.566-1.065,1.54-1.769,1.919-2.943
		c0.517-1.604,1.13-1.271-0.737-1.679c-0.826-0.18-2.07,0.448-3.251,0.136c-1.043-0.276-1.998-1.165-2.986-1.373
		c-1.418-0.299-3.221,0.415-4.775-0.165c2.325-3.264-2.072-2.482-2.739-3.75c-1.101,0.36-2.3,1.064-3.46,1.181
		c0.462-2.937-0.324-6.073-3.965-4.918c-0.05,0.529-0.474,0.973-0.568,1.437c-1.283-1.431-2.115,0.18-3.006,0.513
		c-1.329,0.497-0.065,1.219-1.688-0.051c-0.949-0.743-0.901-2.202-2.319-2.448c-1.197-0.208-2.78,1.395-4.005,1.273
		c-1.031-0.103-1.877-1.693-2.733-1.729c-1.463-0.061-1.917,1.85-3.255,2.161c-2.861,0.664-3.362-2.374-5.25,1.045
		c-0.717,1.298-0.896,2.631-1.319,4.018c-0.166,0.546-0.054,1.342-0.414,1.806c-0.732,0.942-1.462,0.565-2.157,1.182
		c-1.485,1.319-1.402,0.773-0.549,3.25c0.437,1.27,0.753,2.603,1.376,3.744c1.289,2.359,4.187,3.744,6.567,5.262
		c2.253,1.437,4.497,1.71,4.244,4.244c-0.246,2.467-2.694,4.069-4.001,5.938c-1.821,2.605-1.793,4.228-2.187,6.813
		c-0.301,1.973-0.874,4.282-1.368,6.249c-0.263,1.046-1.164,2.201-1.15,3.256c0.013,0.943,1.382,1.495,1.205,2.744l0.392,0.253
		c0.023-0.227,0.174-0.478,0.603-0.813c0.422-0.329,2.695-0.494,3.255-0.426c1.505,0.183,1.022,0.406,2.238,0.986
		c1.396,0.666,1.727,0.623,3.268,1c4.055,0.991,5.194,4.929,9.244,6.25L456.469,523.377z"
      />
    </a>

    <a (click)="SelectCode('DN')">
      <path
        [class.selected]="IsSelected('DN')"
        id="DN"
        d="
		M519.75,604.75c-1.493-7.72,10.821-5.567,12-9.5c0.467-1.558-0.539-2.31,0.556-3.994c1.499-2.305,2.293-0.305,3.882-1.569
		c2.305-1.835-0.825-2.506-1.149-3.7c-0.47-1.727,1.739-2.356,2.686-3.736c-0.979-0.448-3.253-2.74-0.724-2.262
		c1.653,0.312,1.409,1.893,3.25,2.262c2.078,0.416,2.302-1.046,3.587-1.451c1.694-0.534,4.881,0.533,6.386,1.507
		c-0.786,1.466-1.675,2.42-1.223,4.144c0.462,1.765,2.312,2.616,3.817,1.076c1.088,0.539,1.99,1.686,1.971,2.936
		c0.723,0.071,3.596-0.167,4.175-0.719c0.969-0.924,0.394-1.05-0.194-2.511c1.724-0.588,2.986,0.577,4.232,0.473
		c1.256-0.104,2.933-1.764,3.249-1.456l0.042-1.075c-2.397-1.882-5.117-3.354-7.702-4.989c-5.157-3.263-9.858-7.245-13.923-11.796
		c-0.724-0.811-1.481-1.675-2.513-2.017c-1.409-0.467-2.916,0.157-4.324,0.625c-4.692,1.561-9.932,1.385-14.523-0.439L523,565.5
		c-0.558-1.733-0.836-1.834-2.001-2.939c-1.019-0.967-2.347-1.278-2.212-3.024c0.477-0.029,0.735-0.295,1.182-0.343
		c-0.669-1.813-3.627-2.905-5.474-3.131c-3.341-0.41-1.636,1.225-2.994,3.438c-1.04,1.694-0.741,0.24-1.806,0.806
		c-0.907,0.482-1.802-0.309-1.444,1.193c0.391,1.639,3.387,0.937,2.2,3.719c-1.21-0.38-3.105-1.211-4.505-0.967
		c-1.312,0.229-1.803,1.464-2.695,1.448c-0.501-0.009-6.401-3.159-6-2.198l0.086,0.197c-0.314,0.136-0.745,0.185-1.303,0.09
		c0.49,1.154,1.656,1.978,1.942,3.419c-2.129,0.336-2.776,1.418-3.193,3.25c0.484-0.105,1.184,0.16,1.68,0.081
		c-0.012,2.137-1.53,3.32-2.699,4.225c-1.136,0.879-4.607,2.418-5.013,3.237l0.738,0.461c0.402,0.374,1.322-0.278,1.761,0.215
		c1.887,2.121-0.17,2.859,2.981,4.547c-0.085,0.349-4.928,2.295-2.017,3.068c0.038,0.171-0.05,0.538,0.074,0.665
		c1.827,1.277,2.078-0.644,3.519-0.532c1.128,0.088,2.82,2.14,3.194,2.825c0.877,1.607-0.249,1.985,1.806,2.986
		c1.372,0.668,2.795-0.154,4.1,0.743c-0.285,0.373-0.338,1.119-0.624,1.478c0.691,0.225,1.264,0.837,1.748,1.298
		c-1.022,1.148-1.993,0.292-2.523,1.738c-0.558,1.521,0.077,2.298,1.705,2.299c0.172,1.085-0.263,2.15-0.423,3.169
		c0.621-0.084,1.161,0.332,1.686,0.351c0.254,0.783-0.104,0.451,0.75,1.248c-0.708,1.105-2.146,0.938-2.591,1.923l0.417,0.435
		c0.371,0.237,0.693,0.815,1.4,0.849c1.153,0.055,0.735,0.138,1.988-0.282c1.567-0.525,4.143-1.904,4.363-3.71
		c0.774,0.228,1.692,0.828,2.46,0.974c0.801,0.152,1.156-0.031,2.001,0.05c0.85,0.081,1.806-0.275,2.415,0.079L519.75,604.75z"
      />
    </a>

    <a (click)="SelectCode('DT')">
      <path
        [class.selected]="IsSelected('DT')"
        id="DT"
        d="
		M438.5,834.25c-0.06-2.215,2.207-3,2.073-5.499c-0.037-0.68-0.809-0.704-0.835-1.515c-0.012-0.377,0.44-1.05,0.519-1.486
		c0.231-1.267,0.276-1.694,0.305-2.806c0.085-3.216,0.035-2.482,3.132-2.139c2.144,0.238,3.204-1.483,5.267-1.093
		c-0.254-0.586-0.387-1.554-0.679-2.175c1.258,0.026,3.168,1.65,3.035-0.288c-0.101-1.467-1.551-0.953-1.323-3
		c0.081-0.72,0.933-1.208,1.032-2c0.07-0.558-0.652-1.203-0.532-1.744c0.358-1.604,0.945-2.212,2.723-2.549
		c-0.464-2.695-2.487-1.874-4.466-1.657c-1.216,0.133-1.23,0.195-2.195-0.05c-0.522-0.133-1.01-1.016-2.061-1.017
		c-0.893-0.001-2.922,2.369-4.506,1.024c-1.049-0.891,0.503-2.98-1.288-3.956c-3.406-1.856-5.226,4.926-8.462,0.461
		c-0.909-1.254-0.739-3.086-2.988-3.268c-1.991-0.161-2.498,1.232-2.787,2.968c-0.695-0.133-1.515,0.092-2.176-0.18
		c-0.244,1.565,0.164,3.487-0.018,4.705c-0.135,0.899-1.148,1.255-1.18,2.014c-0.032,0.751,1.103,1.076,0.874,2.211
		c-2.098-0.422-4.424,3.265-6.962,1.288l0.253-0.061c-1.04,1.371-4.258,1.241-6.209,1.355c-0.747,1.28-1.867,3.735-2.794,4.706
		l-0.051-0.193c0.408,1.691-1.158,1.052-1.962,1.686c-1.26,0.994-3.607,2.423-2.769,4.206c-1.535,0.503-3.16,1.697-3.218,3.301
		l0.894-0.013c2.964-0.966,5.412-3.694,8.527-3.567c1.667,0.068,3.171,0.968,4.593,1.842c2.519,1.548,5.038,3.097,7.558,4.645
		c2.55,1.567,5.187,3.219,6.799,5.741c1.238,1.937,1.508,4.052,1.642,6.276c-0.035-0.576,2.936-1.758,2.415-4
		c-0.471-2.015-1.329-2.142-0.72-4.269c0.448-1.564,0.966-2.593,2.793-2.599c2.04-0.005,3.433,1.771,5.261,2.264L438.5,834.25z"
      />
    </a>

    <a (click)="SelectCode('DY')">
      <path
        [class.selected]="IsSelected('DY')"
        id="DY"
        d="
		M447.275,685.196c0.488-1.034,2.895-0.921,3.424-2.245c0.568-1.424-1.356-3.439-1.638-4.762c-0.346-1.625-0.274-3.284,0.739-4.883
		c0.528-0.833,4.29-3.618,2.217-5.018c-0.972-0.656-1.74,0.741-2.518,0.724c-0.781-0.017-1.798-1.044-2.5-1.017
		c-2.197,0.082-0.35,0.78-1.995,1.774c-1.255,0.758-1.35,0.113-2.512,0.045c-1.255-0.074-1.857-1.033-3.316,0.007
		c-1.278,0.911-0.587,0.963-0.908,2.418c-0.449,2.036-0.212,3.567-0.307,5.719c-1.584,0.269-3.302,1.487-4.962,1
		c-1.154-0.338-2.381-1.53-3.474-1.964c-4.548-1.806-3.839,1.361-7.526,3.007l0.001,0.499c0.247,1.341,1.514,4.518,2.249,5.501
		l-0.017-0.406c1.981,0.182,3.168,1.299,5.254,1.35c1.857,0.045,3.698-0.279,5.331,0.994c1.596,1.244,1.38,2.323,3.627,2.511
		c1.675,0.14,2.828-1.103,4.044,0.83c2.551-1.203-0.585-3.906,0.3-5.542c0.628-1.162,2.713-1.361,3.912-0.695L447.275,685.196z"
      />
    </a>

    <a (click)="SelectCode('E')">
      <path
        [class.selected]="IsSelected('E')"
        id="E"
        d="
		M555.508,758.548c0.753-0.123,1.588-0.039,2.242,0.191c1.239,0.434,1.172,0.831,2.243,0.948c0.464,0.051,2.4-0.355,3.02-0.425
		c0.781-0.088,1.678-0.378,2.571-0.511l0.332-0.584c-2.184-0.715-2.306-5.806-3.217-7.366c-0.388-0.665-1.321-0.014-1.698-1.3
		c-0.211-0.72,0.555-1.276,0.56-1.94c0.009-1.31-0.069-2.732-1.769-2.767c-0.425,0.93-0.621,1.827-1.043,2.706l0.274,0.249
		c-0.997,1.3-0.488,2.631-0.831,4.195c-0.295,1.348-1.075,2.753-1.467,4.081l-2.03,0.789c0.365,0.519,0.666,1.233,0.804,1.686
		L555.508,758.548z"
      />
    </a>

    <a (click)="SelectCode('EH')">
      <path
        [class.selected]="IsSelected('EH')"
        id="EH"
        d="
		M356.616,363.896c0.536-1.901,2.315-1.135,3.634-1.878c0.798-0.45,1.062-1.167,1.694-1.762c0.492-0.463,1.63-1.071,2.061-1.499
		c1.653-1.641,0.763-1.805,0.746-4.006c-0.006-0.732,0.467-1.411,0.573-2.008c0.06-0.34-0.069-0.647-0.128-0.984l0.228-1.001
		c3.842,1.609,8.141,2.353,12.292,3.03c5.843,0.953,11.686,1.906,17.529,2.859c3.022,0.493,6.454,0.887,8.845-1.027
		c2.253-1.803,2.777-5.064,4.752-7.168c2.331-2.484,6.656-2.719,9.243-0.503c4.121,3.531,8.485,6.904,13.217,9.463L431.25,358
		c-1.33,0.035-1.131,1.705-2.051,2.486c-1.275,1.083-2.059,0.315-3.699,0.257c-3.692-0.131-5.516,2.251-6.81,5.457
		c-0.836,2.069,0.476,2.435-2.146,2.237c-1.552-0.117-2.645-1.337-4.562-0.437c-1.033,0.485-2.329,1.953-3.287,2.694
		c-1.284,0.992-2.946,1.836-1.795,3.874c-1.934,1.793-4.667,2.747-5.402,5.164c-0.416,1.367-1.579,5.296-0.768,6.343
		c0.626,0.809,3.484,0.353,3.812,1.677c0.354,1.429-1.661,1.779-2.568,2.506c-2.246,1.802-2.774,3.944-5.72,3.987
		c-1.422,0.021-3.234-0.811-4.512-0.694c-1.737,0.158-1.658,1.145-2.482,1.962c-1.057,1.048-2.02,1.614-3.419,1.973
		c-1.324,0.34-2.163-0.024-2.869,0.557l0.012-0.412c-0.296-1.757-0.158-3.633-0.737-5.393c-0.171-0.52-0.926-0.941-1.023-1.455
		c-0.122-0.645,0.687-1.218,0.535-1.832c-0.246-0.989-1.159-2.338-1.993-3c-2.625-2.085-3.731-1.465-4.018-4.702
		c-0.293-3.307-0.679-6.938-5.211-3.769c-0.207-1.651-0.779-3.495-1.977-4.799c-2.405-2.617-5.142-0.847-8.048,0.742
		c-0.032-2.173,0.448-2.852,1.222-4.668c1.227-2.878,0.705-2.483-1.75-3.256c-1.006-0.316-2.258-0.867-3.413-1.615L356.616,363.896z
		"
      />
    </a>

    <a (click)="SelectCode('EN')">
      <path
        [class.selected]="IsSelected('EN')"
        id="EN"
        d="
		M546.25,741.25c0.217-2.148,6.485-0.787,8-1.226c2.726-0.788,2.988-5.874,6.25-4.774l-0.155-0.513
		c0.576,0.767,0.793,1.75,0.693,2.725c0.871-0.001,1.608-0.054,2.43-0.174c-0.327,1.407-0.636,6.671,0.282,6.712l-0.083,0.667
		c-0.815-0.073-1.659,0.023-2.58-0.114l-1.295,0.241c-0.425,0.93-0.621,1.827-1.043,2.706l-0.218-0.288
		c-2.258-1.781-8.78-0.849-11.032-0.212c-0.706-1.464,0.446-2.456,0.206-3.956c-0.513-0.029-0.843-0.376-1.419-0.331
		c0.023-0.619-0.385-1.024-0.325-1.675L546.25,741.25z"
      />
    </a>

    <a (click)="SelectCode('EX')">
      <path
        [class.selected]="IsSelected('EX')"
        id="EX"
        d="
		M398.25,827.5c0.058-1.604,1.683-2.798,3.218-3.301c-0.838-1.784,1.509-3.212,2.769-4.206c0.804-0.634,2.37,0.005,1.962-1.686
		c-0.216-0.894-1.646-0.842-2.186-1.307c-0.741-0.639-1.115-1.586-1.827-2.242c-0.919-0.847-1.249-0.46-2.193-1.001
		c-2.152-1.235-2.063-2.539-3.501-4.231c-2.142,1.082-3.633,0.762-5.705-0.574c0.429-0.852,1.325-3.059-0.094-3.656
		c-0.817-0.344-3.924,1.381-5.4,1.161c-0.941-2.398-3.281-0.421-5.038-1.463c-2.022-1.2-0.251-2.857-0.799-5.2
		c-1.122-0.646-1.965-0.063-2.962-0.275c-0.899-0.191-1.846-0.79-2.701-0.987c0.111,0.662-0.191,1.522-0.081,2.186
		c-3.421,0.463-4.926-1.922-7.456-3.662c-0.666-0.458-1.782-0.533-2.275-1.243c-0.464-0.668,0.021-1.099-0.225-1.557
		c-0.93-1.732-0.463-1.578-2.756-2.055c-0.903-0.188-3.587-0.173-4.199-0.752c0.036,0.034-1.325-3.882-1.312-3.949
		c0.479-2.443,6.658-1.43,8.724-1.538c0.034-0.882-0.162-1.89-0.443-2.712c-0.114-0.333-1.157-2.357-0.77-1.25l0.03-0.245
		c-2.408-0.306-4.816-0.292-7.229,0.282c-1.602,0.381-3.148,1.003-4.776,1.251c-4.932,0.751-10.479,0.66-15.057,2.644
		c-0.54,0.234-1.22,0.092-1.621-0.339c0.658,1.26,0.262,2.974-0.883,3.817c-0.31,0.228-0.681,0.416-0.847,0.763
		c-0.256,0.535,0.095,1.149,0.432,1.637c1.279,1.851,2.558,3.702,3.837,5.553c-1.993,0.145-3.92,1.064-5.287,2.521
		c-0.842,0.898-1.531,2.029-2.666,2.506c-3.556,1.496-6.894-4.569-10.551-3.339c1.699,2.101-0.421,5.018-1.203,7.604
		c-1.078,3.566,0.655,7.223-0.081,10.797c-0.581,2.823-2.418,3.159-4.037,5.287c-0.505,0.663-0.747,1.329-1.069,2.008L312,824.75
		c1.059,1.33,4.243,0.67,5.7,0.744c0.621,0.032,1.546,0.628,2.55,0.274c1.038-0.365,1.399-1.591,2.3-1.969
		c0.588-0.247,2.295-0.189,2.895,0.006c0.956,0.311,1.317,1.263,1.987,1.513c0.972,0.363,1.616,0.18,2.581,0.419
		c1.061,0.263,1.23,1.559,2.693,0.718c-0.109-0.62,0.307-1.2,0.344-1.669c1.387,0.191,1.796,1.462,1.949,2.712
		c0.157,1.277-0.832,2.041-0.762,2.987c0.128,1.725,4.291,3.902,4.549,1.801c0.871,0.174,1.344,0.311,1.694,1.25
		c1.499-1.171,5.651-2.974,7.475-3.005l-0.456,0.218c0.973-1.817,2.548-3.666,4.5-3.95c0.414-0.06,0.877,0.756,1.237,0.711
		c0.612-0.076,1.32-0.724,1.713-0.768c0.356-0.039,0.475-0.757,1.043-0.762c0.818-0.007,0.663,0.939,1.195,1.086
		c2.589,0.711,3.667,0.249,5.05,2.444c0.429,0.68,0.945,1.886,1.507,2.45c0.703,0.705,1.714,0.035,2.298,1.511
		c1.803-1.001,1.012-2.55,3.262-1.735c0.952,0.345,2.335,2.311,2.638,2.957c0.478,1.019-0.481,1.279,1.049,2.617
		c0.797,0.697,2.108,0.717,1.757,1.188l0.535-0.024c0.769-1.535,1.272-3.139,0.625-4.657c-0.309-0.725-0.872-1.367-0.931-2.153
		s0.864-1.642,1.465-1.132c0.17,1.308,0.34,2.616,0.509,3.924c2.741-1.032,5.571-0.44,8.493-0.644
		c-0.826-2.767,2.235-5.25,5.091-5.678c2.415-0.362,4.938,0.065,7.32-0.337L398.25,827.5z"
      />
    </a>

    <a (click)="SelectCode('FK')">
      <path
        [class.selected]="IsSelected('FK')"
        id="FK"
        d="
		M304.75,317.5c0.175-1.347-1.943-3.472-2-5.486c-0.023-0.798-0.081-2.818,0.195-3.508c0.692-1.729,0.278-1.076,2.305-0.574
		c3.019,0.747,4.328,0.356,7.494-0.194c3.83-0.665,2.439-1.283,1.257-4.449c3.222-0.192,6.523,0.223,9.687-0.301
		c1.372-0.227,2.611-0.844,4.001-0.985c0.904-0.092,4.899-0.586,5.592-0.27c2.898,1.323-0.102,4.728,4.402,3.204
		c2.425-0.821,2.402-1.51,4.505-0.179c1.291,0.817,2.81,2.201,3.797,3.193c-1.708,0.486-2.827,1.183-4.304,1.981
		c-1.053,0.568-2.792,0.88-3.744,1.751c-1.635,1.494-0.871,4.687-0.687,6.59c0.243,2.522,1.338,3.339,2.749,5.421
		c1.168,1.723,1.281,3.449,3.494,4.006c3.228,0.813,2.647-1.736,4.452-3.161c0.712-0.562,1.354-0.858,2.36-0.789
		c1.197,0.082,1.275,0.846,2.127,1.073c1.715,0.459,4.167-0.588,5.103,1.44c-2.683,2.019-0.626,4.495-1.247,7.198
		c1.546,0.326,4.505-0.449,4.755-2.182c3.018-1.039,5.284-2.031,7.902-3.941c0.668,0.885,1.6,1.483,2.461,2.168
		c-0.842,0.4-3.342,4.618-3.412,5.762c-0.166,2.707,2.579,1.357,3.411,3.556c-4.964-0.425-5.579,5.715-6.601,9.441l-0.239,0.772
		c-1.597-0.496-3.177-1.047-4.736-1.652c1.636,1.404,3.476,2.471,5.439,3.307l0.231,0.557c-0.001-0.231-0.053,0.804-0.176,1.493
		c-0.106,0.597-0.579,1.276-0.573,2.008c0.018,2.201,0.908,2.366-0.746,4.006c-0.431,0.428-1.569,1.036-2.061,1.499
		c-0.632,0.595-0.897,1.312-1.694,1.762c-1.315,0.741-3.087-0.017-3.629,1.86l-0.102-0.029c-1.942-1.271-3.593-3.101-3.307-5.311
		L352.5,359c0.454-1.939-2.158-4.404-3.962-4.038c-0.399-3.552-4.829-2.266-7.263-3.693c1.086-3.701-0.049-4.913-3.038-5.957
		c-0.593-0.207-1.825-0.971-2.499-1.142c-0.821-0.209-1.653,0.172-2.25,0.037c-1.31-0.298-2.409-1.156-3.963-0.994
		c0.047-0.352-0.118-0.835-0.064-1.18c-2.24,0.194-3.564,1.759-5.712,1.042c-2.205-0.735-4.773-3.036-6.506-4.573
		c-1.575-1.397-3.673-2.633-4.555-4.501c-0.392-0.831-0.268-1.757-0.628-2.563c-0.352-0.787-1.39-1.335-1.63-2.193
		c-1.172-4.183,5.519-7.026,0.344-11.237c-2.068-1.684-3.753-1.23-6.013-0.244L304.75,317.5z"
      />
    </a>

    <a (click)="SelectCode('FY')">
      <path
        [class.selected]="IsSelected('FY')"
        id="FY"
        d="
		M403.5,543.5c-0.192,1.347,0.342,1.937,0.618,2.938c0.098,0.356,0.595,0.614,0.686,1.263c0.122,0.864-0.444,0.551-0.518,1.099
		c-0.042,0.314-0.564,1.161-0.562,1.187c0.108,1.227,1.222,0.751,1.506,1.77c0.457,1.64-0.162,2.875-1.949,2.586
		c0.034,0.65-0.378,1.21-0.319,1.87c-3.189,0.474,0.196,2.418,0.524,2.818c1.173,1.428,1.771,2.915,1.013,4.719l0.008,0.349
		c-5.068-0.292-8.03-5.474-8.136-10.181c-0.067-2.993,0.583-6.165,2.628-8.352c1.152-1.232,2.829-2.02,4.496-2.143L403.5,543.5z"
      />
    </a>

    <a (click)="SelectCode('G')">
      <path
        [class.selected]="IsSelected('G')"
        id="G"
        d="
		M321.334,360.491c-7.929-1.354-15.367-6.038-19.435-12.975c1.261,2.464,2.523,4.927,3.784,7.391
		c-1.294-0.016-2.589-0.031-3.883-0.047c-1.458-3.446-2.94-7.247-1.857-10.829l-0.192,0.719c-0.186-0.738,1.078-4.944,1.481-5.7
		c0.588-1.102,1.806-0.398,1.787-2.3c-0.007-0.681-1.081-2.193-1.275-3c-0.182-0.762-0.485-2.205-0.244-3
		c0.477-1.572,1.174-0.642,1.769-1.538c1.129-1.701,1.221-4.534,0.723-6.461c-0.271-1.051-1.382-2.004-1.248-3.251
		c0.223-2.071,0.558-1.1,2.019-1.737c2.26-0.987,3.945-1.44,6.013,0.244c5.174,4.211-1.516,7.054-0.344,11.237
		c0.24,0.858,1.279,1.406,1.63,2.193c0.36,0.806,0.235,1.732,0.628,2.563c0.882,1.868,2.98,3.104,4.555,4.501
		c1.733,1.537,4.301,3.838,6.506,4.573c2.148,0.716,3.472-0.848,5.712-1.042c-0.054,0.346,0.111,0.828,0.064,1.18
		c1.553-0.163,2.653,0.695,3.963,0.994c0.596,0.136,1.429-0.245,2.25-0.037c0.674,0.171,1.906,0.935,2.499,1.142
		c2.989,1.044,4.124,2.256,3.038,5.957c2.434,1.427,6.863,0.141,7.263,3.693c1.578-0.32,3.776,1.527,3.996,3.293l-0.161,0.238
		c-1.27,0.246-1.769,1.878-3.323,0.545c-1.583,1.896-2.134,3.054-4.513,1.995c-0.124,0.983-0.767,2.126-0.855,2.954
		c-0.141,1.315,0.193,1.294,0.312,2.325c0.186,1.606,0.292,3.589,1.231,5.133c-1.077,0.848-2.95,1.791-3.505,3.068
		c-0.241,0.554,0.344,1.887-0.144,2.794c-0.68,1.263-1.968,1.451-2.519,2.949c-0.449,1.224,0.073,2.182-0.093,3.456
		c-1.651-0.211-5.332-1.873-5.463,1.539l-0.25-0.431c-0.732-0.692-2.086-1.277-2.95-1.886c-1.896-1.336-3.743-2.387-5.799-3.494
		c-1.67-0.899-3.4-1.625-4.995-2.445c-0.639-0.328-1.311-1.01-2.008-1.489l0.002-0.004c1.287-2.488,2.867-3.423,5.25-4.25
		c1.891-0.657,3.855-0.893,4.699-3.057c-0.142,0.363,0.455-3.4,0.563-2.888c-0.278-1.316-0.67-0.915-2.026-1.806
		c-1.997-1.311-2.661-2.527-5.104-2.71c0.211,0.147,0.417,0.3,0.618,0.461L321.334,360.491z"
      />
    </a>

    <a (click)="SelectCode('GL')">
      <path
        [class.selected]="IsSelected('GL')"
        id="GL"
        d="
		M422,743.25c-1.341-0.975-3.763-1.649-4.255-3.5c-0.357-1.345,0.6-1.96,0.753-3.513c0.111-1.124-0.514-2.296-0.498-3.486
		c0.027-2.045-0.185-1.642,1.531-3.213c0.737-0.675,1.659-1.462,2.457-2.037c2.042-1.47,4.538-0.663,6.323-2.432
		c3.718-3.683-4.246-6.616-0.311-9.513c2.234-1.644,2.951,1.333,4.944,1.192c1.024-0.073,2.464-1.174,3.495-1.492
		c1.409-0.434,2.644-0.533,4.023-0.294c-0.925-4.126,4.427-0.324,3.802-3.661c4.72-1.766,6.722,2.148,10.541,3.136
		c3.324,0.861,9.941,2.763,9.262-2.881c-0.095-0.793-1.125-1.224-1.036-2.044c-0.03,0.278,1.705-2.973,1.45-2.762
		c2.412-1.989,2.738,0.475,4.019,2.012c1.27,1.525,4.124,1.28,5.073,2.469c0.758,0.949-0.284,4.358-0.803,4.975
		c4.71,0.436,2.202,3.013,0.531,5.293c-0.944,1.287-1.879,4.643-4,3.025c-0.188,2.417,1.361,2.854-0.032,4.907
		c-0.414,0.611-1.37,0.846-1.775,1.563c-0.292,0.518-0.274,1.867-0.462,2.455c2.669,0.048,0.841,2.565,2.786,3.513
		c0.859-1.241,3.462-0.733,4.125,0.77c0.721,1.636-1.113,2.706-0.194,4.518l-0.494,0.029c-0.846-0.052-1.727-0.227-2.506-0.041
		c-1.18,0.281-1.934,1.385-3.006,1.718c-1.872,0.583-1.728-0.324-3.3-0.393c-1.49-0.065-1.442,0.493-2.939,0.942
		c-1.176,0.353-2.615-0.1-3.768,0.301c-1.233,0.429-1.071,0.985-2.225,1.181c-3.318,0.562-5.07-2.457-7.525,1
		c-0.78,1.098-0.267,2.038-1.906,3.068c-1.084,0.681-2.243,0.585-3.332,0.995c-4.006,1.51-1.873,2.346-1.789,5.162
		c-1.827,0.196-4.599,3.581-5.711,2.538l0.186-0.038c0.849-3.702,3.223-5.739-2.186-6.212c-1.924-0.169-3.018-0.639-4.731-1.2
		c-1.336-0.438-2.026,0.563-2.225-1.105c-0.08-0.668,1.083-2.187,1.486-2.693c-1.134-0.754-1.925-2.943-2.78-2.751l0.574-0.672
		c1.204-1.383,1.891-3.215,3.35-4.378c1.773-1.413,2.944-1.279,3.617-3.918c-4.276,1.04-7.329,4.195-10.229,7.666L422,743.25z"
      />
    </a>

    <a (click)="SelectCode('GU')">
      <path
        [class.selected]="IsSelected('GU')"
        id="GU"
        d="
		M522.648,768.99c1.428,0.249,3.02-0.048,4.175-0.728c0.796-0.469-0.162-2.075,1.677-1.335c2.02,0.812-0.075,1.712,0.539,2.823
		c0.409,0.739,3.654,3.37,4.448,3.756c2.671,1.298,3.429,0.029,2.581,3.55c-0.227,0.943-0.695,1.31-0.568,2.445
		c0.163,1.451,0.87,1.245,1.249,1.988c1.055,2.067-0.032,3.49,0.232,6.012c0.309,2.954,1.326,2.994-1.481,4.938
		c-0.811,0.562-2.221,1.939-3.013,2.255c-1.108,0.442-1.734-0.115-3.199-0.155c-0.227,2.923,0.645,5.491,0.225,8.461
		c-0.377,2.665-4.611,4.833-3.513,7.25l-0.67,0.056c-0.241-0.208-0.586-0.338-1.044-0.343c-0.19-3.652-10.562-5.811-10.324-3.245
		c-1.197-0.541-2.71-0.218-3.907-0.774c-1.466-0.681-1.747-2.185-3.763-1.657c-0.648,1.485-2.632-0.666-4.043-0.787l-0.137-0.629
		c-0.049-1.243-0.343-2.501-0.587-3.584c1.158,0.138,2.944-1.261,3.412-2.344c1.027-2.378-0.651-2.981-1.687-4.638
		c-1.172-1.874-0.44-1.518-0.181-3.543c0.114-0.893,0.152-1.63-0.158-2.115l0.369-0.514c0.695-0.567,1.896-1.294,2.52-1.333
		c2.09-0.132,3.036,1.214,5.194-0.052c3.408-1.998,2.317-7.103,3.506-10.761c0.692-2.13,3.133-2.149,5.318-3.176
		c1.688-0.793,2.216-1.151,2.5-1.911L522.648,768.99z"
      />
    </a>

    <a (click)="SelectCode('HA')">
      <path
        [class.selected]="IsSelected('HA')"
        id="HA"
        d="
		M535.949,749.315c0.396,0.613,0.466,1.833,1.55,3.435c1.135,1.678,1.091,1.308,2.946,1.445c1.301,0.096,3.294-0.534,3.461,1.511
		L545.75,756c1.342-1.226,0.243-2.252,0.182-3.751c-0.067-1.655,0.268-2.295,1.043-3.736c-1.572-2.079-3.182-1.469-5.213-0.713
		c-1.565,0.583-1.396,0.816-2.964,0.651c-0.708-0.074-0.691-1.226-2.006-0.658c-0.142,0.504-0.537,0.646-0.787,1.106
		L535.949,749.315z"
      />
    </a>

    <a (click)="SelectCode('HD')">
      <path
        [class.selected]="IsSelected('HD')"
        id="HD"
        d="
		M464.171,582.918c-0.803-0.678-1.839-0.974-3.171-0.918c-0.969,0.041-1.696,0.506-2.437,0.877l-0.063-0.127
		c-0.504-1.117-0.557-2.367-1.063-3.487c-0.74-1.64-1.985-2.439-2.936-3.825c-0.462-0.674-0.655-1.243-0.771-1.813L453.5,574
		c1.602-1.711,4.471-3.421,6.763-4.438c1.4-0.621,2.291-1.047,3.043-2.062c0.837-1.13,0.075-2.658,2.157-2.537l-0.212-0.463
		c2.407-0.532,2.442,1.812,3.306,3.487c0.807,1.564,2.108,3.338,2.231,5.225c2.1,0.175,4.228-1.082,5.212,1.538l-0.007-0.002
		c-0.152,0.446-0.014,1.039-0.487,1.758c-1.41,2.138-3.982,2.096-6.067,3.184c-0.791,0.413-1.581,1.134-2.377,1.623
		c-0.824,0.506-3.027,1.04-2.311,1.438L464.171,582.918z"
      />
    </a>

    <a (click)="SelectCode('HG')">
      <path
        [class.selected]="IsSelected('HG')"
        id="HG"
        d="
		M481.25,520.75c0.184-0.223,0.261-0.47,0.232-0.743c-1.732,1.677-4.452-0.011-6.043-0.951c-3.52-2.079-0.287-2.38-1.732-5.269
		c-2.002,0.113-2.735-0.845-4.456-1.231c-3.593-0.806-1.209,1.738-3.182,3.453c-0.718,0.624-2.651,0.201-4.05,1.04
		c-1.709,1.025-4.518,2.807-5.286,4.7c-0.544,1.342-0.231,4.924,0.75,6.011c0.612,0.677,1.831,0.384,2.281,0.922
		c0.644,0.77,0.139,1.219,0.483,2.068c0.612,1.507,1.353,3.199,2.068,4.75c0.493,1.07,1.915,2.39,2.583,3.401l0.394,0.136
		c1.483,0.286,2.344-1.784,3.661-0.986c1.075,0.651,0.583,2.373-0.168,2.998c0.927,1.4,3.063,0.448,4.418,1.195
		c0.546,0.301,0.874,1.315,1.507,1.518c0.888,0.286,1.593-0.588,2.111-0.474c2.04,0.447,0.919,1.809,2.494,2.649
		c1.466,0.781,2.246-0.828,1.726-2.154c2.095,0.533,3.108,0.43,3.648-1.276c0.156-0.491-0.584-1.183-0.205-2.025
		c0.288-0.639,1.639-0.372,2.06-1.449c0.322,0.026,0.614,0.116,0.883,0.256l0.074-0.039c4.382-3.176-2.714-7.988-5.963-7.289
		c-0.381-1.396,0.588-2.707,1.962-1.987c0.586-0.758,1.375-3.206,0.963-4.168c-0.258-0.604-1.672-0.685-1.924-1.294
		c-0.304-0.733,0.562-1.557,0.418-2.019c-0.286-0.921-0.661-1.727-1.03-2.516L481.25,520.75z"
      />
    </a>

    <a (click)="SelectCode('HP')">
      <path
        [class.selected]="IsSelected('HP')"
        id="HP"
        d="
		M510.25,747.5c-1.565-2.537,0.233-3.667,2.956-3.544c1.81-2.731-0.275-3.958-2.018-5.895c-2.786-3.096-2.536-0.92-6.188-0.556
		c-1.628,0.162-5.116-2.007-5.211-3.206c0.016,0.203,1.185-1.034,1.266-1.245c0.184-0.481,0.075-1.023,0.251-1.542
		c0.459-1.351,0.142-2.508,2.151-2.051c0.562-1.598,1.055-3.217,1.794-4.662c0.183-0.358,0.782-1.134,1.012-1.694l-0.013,0.144
		c0.674,0.23,1.872-0.083,3.277,0.689c1.672,0.919,2.019,2.336,4.222,1.505c0.583-0.22,1.018-1.284,1.57-1.38
		c1.28-0.222,0.437,0.485,1.419,0.698c1.589,0.346,3.164,0.675,4.811,1.032c-0.412,1.511,2.436,4.78,3.951,5.267
		c3.038,0.978,3.593-3.169,6.467-1.255c-0.309,0.675,0.026,1.241,0.021,1.925c1.399-0.838,4.398,0.406,5.462,1.838
		c0.829,1.115,1.891,4.91,0.751,5.869c-1.361,1.145-2.062-0.489-3.451-0.381c-2.064,0.161-1.099,0.43-1.794,1.943
		c-1.229,2.677-1.231,4.341-0.456,7l-0.751-0.011c-1.063-0.266-2.361,1.684-2.931,2.33c-1.248,1.417-1.341,2.144-3.318,2.181
		c-2.38,0.044-1.652-0.886-3.238-2c-0.747-0.525-2.914-1.253-3.749-1.264c-1.318-0.018-2.31,1.055-3.263,0.764l0.296,0.255
		c-0.183-0.358-0.506-0.747-1.046-1.218c-0.118-0.103-1.209,0.202-1.568-0.006c-0.427-0.247-0.516-1.37-1.182-1.731
		c-1.068-0.579-1.367-0.551-1.533-0.274L510.25,747.5z"
      />
    </a>

    <a (click)="SelectCode('HR')">
      <path
        [class.selected]="IsSelected('HR')"
        id="HR"
        d="
		M405.75,692.75c-0.126-1.084-0.096-3.338,0.5-4.276c0.704-1.109,1.71-1.827,1.968,0.263c3.124-2.533,2.672,0.72,4.726,1.781
		c0.623,0.322,2.586,0.332,3.367,0.531c1.51,0.385,2.099,1.667,3.176-0.585c2.011,0.777,0.597,2.826,1.952,3.845
		c0.968,0.729,4.396,0.168,5.565,0.148c1.558-0.027,2.708-0.637,2.743,1.786c0.02,1.361-1.352,3.446-1.734,4.999
		c-0.568,2.307-1.358,2.609,0.236,3.958c0.564,0.477,1.616,0.269,2.311,0.986c0.67,0.693,0.373,1.653,0.908,2.318
		c2.177,2.705,4.597,2.768,4.243,6.957c-0.248,0.065-0.467-0.006-0.712,0.038l0.75,0.04c-0.923,0.448-1.994,1.151-2.806,1.208
		c-1.993,0.141-2.71-2.836-4.944-1.192c-3.936,2.897,4.029,5.83,0.311,9.513c-1.785,1.768-4.281,0.961-6.323,2.432
		c-0.798,0.574-1.72,1.362-2.457,2.037l-1.105-0.201c-1.535-2.721-4.368-1.71-7.174-3.525c-1.365-0.883-1.416-3.011-3.002-3.586
		c-1.343-0.486-4.702,1.016-5.698,1.748c-2.459-1.589-3.6-4.923-6.001-6.717c-1.125-0.84-1.653-2.266-2.792-0.707l-0.399-0.227
		c-0.519-0.923-0.978-2.06-1.596-2.571c-1.255-1.039-2.209-0.115-3.718-0.795c0.229-1.937-1.807-2.847-1.505-4.669
		c1.978-0.054,5.572-0.757,3.411-3.481c-0.761-0.959-2.511-0.117-2.411-1.807c-0.013,0.218,1.785-2.608,1.706-2.514
		c1.868-2.212,4.365-1.207,6.512-2.735c1.971-1.403,2.925-2.699,5.706-2.789c-0.079-2.65,4.156,0.267,4.494-2.468L405.75,692.75z"
      />
    </a>

    <a (click)="SelectCode('HS')">
      <path
        [class.selected]="IsSelected('HS')"
        id="HS"
        d="
		M152,273.75c0.644-0.3,1.482-0.409,2.211-0.463c-0.279,1.401,0.282,3.626-0.961,4.682c-1.716-1.207-1.958-3.521,0-4.719
		 M156.25,270c-0.606,0.211-1.038,0.486-1.212,1.187c0.836,0.679,1.87,0.689,2.924,0.525c0.078-0.372,0.081-0.802,0-1.174
		c-0.744-0.248-1.537-0.295-2.212-0.038 M158.5,266.5c-1.383,1.924,2.488,3.934,3.073,1.999c0.531-1.755-2.334-2.105-3.323-1.249
		 M157.75,265.25c0.642-0.289,1.499-0.182,2.201,0.212c0.473-0.756,1.584-0.356,1.811-0.7c0.682-1.033-0.426-1.043-0.225-1.762
		c0.826-2.952,1.118-0.775,3.93-1.544c-0.473-2.625,1.844-2.282,2.875-3.962c1.513-2.465-0.575-1.454-1.842-2.489
		c-1.048-0.855-4.076-7.206-3.787-1.097c-1.17,0.311-2.547,0.417-3.681,1.148c1.416,2.032-3.536,6.009-2.075,7.487
		c-0.199,2.168,1.078,3.096,3.043,2.707 M170.5,248.5c-2.72,3.699,4.699,4.048,1.694-0.468c-0.979,0.18-1.815,0.749-2.194,1.718
		 M173.25,246.75c2.098,1.814,1.967-0.257,1.243-1.756c-1.246-2.577-1.872-0.65-4.217-1.794c0.245-2.006,3.608-0.723,3.974-3.437
		c0.432-3.2-3.057-4.145-3.461-6.226c2.726-0.485,2.813-1.318,4.53-3.605c1.753-2.336,1.694-2.842,0.67-5.127
		c-1.104-2.46-5.635-8.16-9.5-7.553c-2.658,0.417-1.768,2.544-1.252,4.513c0.811,3.089,0.143,3.567-0.473,6.418
		c-0.576,2.662-1.098,4.915-0.694,7.554c0.36,2.35,1.236,4.382,1.695,6.709c0.52,2.639,0.617,4.385,3.736,4.555
		c1.221,0.066,2.117-0.506,3.25-0.505c1.04,0.001,1.878,0.623,3,0.505 M175,218.256c2.652-0.143,2.367-0.291,1.482-2.257
		c-0.406-0.901-0.822-1.155-1.253-1.95c-0.372-0.686-1.028-0.194-1.191-1.262c2.445,0.352,2.058-1.123,0.961-2.099
		c-0.929-0.828-2.705-1.063-3.75-1.75c-1.99-1.309-2.541-5.955-4.962-6.155c-0.22,2.176,1.702,3.592,0.649,5.972
		c-0.547,1.236-1.748,0.51-1.63,2.508c0.071,1.208,1.354,1.936,1.443,3.237C168.922,215.977,172.336,218.4,175,218.256z
		 M163.25,200.5c0.307-0.009,0.299,0.396,0.706,0.211c1.062-3.291,5.217,1.645,5.806,2.789c0.461,0.893-0.448,0.963,0.743,1.943
		c0.493,0.406,1.27,0.091,1.743,0.502c1.208,1.048,0.602,1.275,1.045,3.011c1.575,0.455,3.312,0.885,4.918,1.006
		c-0.008-0.359,0.115-0.817,0.081-1.169c2.363-0.983-0.592-1.881-1.016-2.757c0.797,0.134,3.205-1.613,3.004-2.523
		c-0.416-1.88-2.959-0.307-2.986-2.22c1.194-0.482,2.863,0.152,3.761-0.794c1.199-1.262,0.113-2.31-1.512-2.044
		c-3.506-5.23,2.298-0.389,3.774-2.889c0.518-0.877-0.596-3.423-1.555-3.836c-1.534-0.661-2.165,0.708-3.476,0.98
		c-0.175-1.032,0.473-1.882,1.237-2.461c-0.85-0.95-1.562-2.023-1.742-3.201c2.542-0.541,2.625-3.564-0.295-2.812
		c-2.371,0.61-1.243,2.492-1.032,3.971c-1.068,0.496-1.499,1.472-2.456,2.054c-1.059,0.644-2.534,0.068-2.786,1.714
		c-1.215-0.382-2.642-0.255-3.925-0.188c0.483,2.653-1.503,1.908-2.782,1.225c-0.999-0.533-1.345-1.844-2.755-1.512
		c-1.601,0.378-0.36,0.716-1.057,1.956c-1.176,2.089-2.998,2.361-1.693,3.848c1.164,1.326,3.045,0.73,2.537,3.408
		c0.833-0.054,1.679,0.042,2.462,0.288 M151.5,204.25c-0.398,1.132,4.518,2.221,4.461,0.044c-1.413-0.507-3.317-0.447-4.67-0.001
		c-0.029,0.493-0.295,0.367-0.542,0.707 M100.75,175c1.076,1.053,0.19,3.301,2.45,2.726c0.804-1.486,1.529-1.936,0.049-2.975
		c-1.107-0.778-3.377-0.893-2.499,0.999 M174,178.75c-1.888,1.597,0.507,3.848,2.063,2.063c1.706-1.958-1.413-2.589-2.813-1.563
		 M182.5,181c-0.512,1.065-0.458,2.469,0.742,3.03c0.926-0.796,0.369-2.301,0.22-3.492c-1.022-0.141-1.453,0.443-1.462,1.462
		 M188.75,184.25c1.448-0.793,3.738-1.68,2.843-3.811c2.222-1.27,2.422-0.333,3.656-2.944c0.41-0.868,1.9-3.636,1.783-0.528
		c1.048-0.049,1.692-0.877,1.755-1.924c2.543-0.036,1.734-1.312,1.019-2.613c-0.943-1.715-1.806-2.217-1.518-4.405
		c1.559,0.516,3.3,2.159,4.93,1.505c-0.859,1.205,0.053,2.86,1.781,2.473c2.659-0.594-0.796-2.16-1.479-2.692
		c2.442-0.804,0.181-1.639-0.22-2.612c-0.401-0.975-0.436-2.408-0.793-3.463c-0.652-1.928-2.019-4.946-1.214-6.943
		c1.823-0.068,1.712,3.473,2.255,4.887c0.671,1.747,1.435,3.155,2.945,4.348c1.372-0.818,0.203-2.278-0.469-3.229
		c2.079-0.304,1.552,2.01,2.787,2.887c1.865,1.325,3.127-0.595,1.964-2.455c1.008-0.34,1.717,0.329,1.755,1.484
		c1.309-0.129,2.16-1.319,3.192-1.279c0.854-0.634,1.284-4.765,0.532-5.455c-1.176-1.079-4.454,1.736-4.977-0.69
		c4.171-1.314,9.354,2.482,10.447-3.061c-0.908-0.219-1.977-0.277-2.942-0.513c-0.065-1.676,2.279-1.82,2.497-3.494
		c0.081-0.621-1.004-1.85-1.067-2.686c-1.972,0.4-8.352,2.515-9.693,1.266c2.301-1.476,6.412-0.898,7.274-4.012
		c0.982-0.311,2.12-0.65,3.17-0.58c0.746-1.109,0.288-5.192-0.743-5.955c0.686-0.814,1.622-0.58,2.073,0.448
		c2.944-0.561,4.893,1.952,7.665-0.255c1.072-0.854,4.213-4.756,3.061-6.214c-1.748-2.213-5.124,2.974-6.83,3.721
		c-1.709,0.749-4.056,0.035-5.469-0.951c1.261-1.881,3.312-1.091,1.814-3.714c1.94-0.604,4.192-0.048,2.743-2.731
		c0.695-0.416,1.896-0.804,2.441-1.373c0.348-0.363,0.053-1.133,0.326-1.439c0.96-1.074,1.681-1.825,3.166-2.036
		c-0.464-1.356-1.446-2.216-1.405-3.964c0.056-2.361,1.603-3.79,0.83-6.006c-0.487-1.397-1.324-0.397-1.214-1.989
		c0.153-2.203,1.864-0.815,0.316-2.955c-0.869-1.201-2.936-2.903-4.45-2.512c0.437,3.1-2.141,2.652-4.038,3.644
		c-2.045,1.069-3.326,3.397-5.244,4.818c-1.207,0.894-2.706,1.644-3.707,2.764c-0.677,0.757-0.859,1.986-1.293,2.492
		c-0.917,1.069-3.352,2.383-5.006,3.012c-1.138,0.433-1.454-0.011-2.75,0.732c-0.936,0.537-1.596,1.684-2.568,2.214
		c-1.226,0.668-2.445,0.485-3.449,1.799c-1.09,1.426-0.322,1.484-0.274,2.743c0.086,2.256,0.483,3.663,2.086,5.501
		c1.128,1.293,3.869,2.702,3.936,4.462c-3.729,0.187-7.466-7.051-9.667-9.448c-1.897,1.797,1.125,4.006,1.426,5.712
		c0.818,4.623-2.888,3.222-5.282,1.031c0.826-0.972,2.556-1.081,2.458-2.476c-1.524-0.091-2.605-0.016-3.915-0.524
		c-1.11-0.43-0.629-1.699-2.007-1.28c-2.624,0.798-1.03,4.637-0.532,5.729c-0.986,0.021-2.928-0.842-3.717-0.175
		c-0.883,0.747-0.083,1.23-0.264,2.219c-0.077,0.421,0.623,0.575,0.55,0.994c-0.097,0.559-0.738,0.785-0.848,1.263
		c-0.117,0.51-0.937,0.8-0.956,1.475c-0.026,0.951,1.233,1.521,1.537,2.262c0.673,1.638,0.286,3.4,1.294,4.989
		c0.26-0.057,0.45-0.157,0.713-0.216c0.451,0.757,0.703,1.556,0.768,2.439c0.795-0.042,1.472,0.023,2.161-0.437
		c0.285,1.607-1.523,1.767-2.23,2.7c-0.721-0.238-1.502-0.506-2.182-0.762c0.288-2.831-3.58-2.977-4.817-0.975
		c0.56,1.624,1.445,0.96,2.524,1.568c1.838,1.035,0.854,0.106,1.562,1.676c0.988,2.19,1.619,3.271,4.449,4.086
		c2.601,0.748,4.382-0.922,7.02,1.072c1.739,1.314,2.481,2.726,3.148,4.567c-2.719,0.085-9.781-0.546-3.7,2.344
		c-1.148,1.616-3.909-0.049-5.423,1.438c-0.746,0.733-0.338,1.814-1.052,2.512c-0.578,0.565-1.669,0.825-2.448,0.976
		c-0.47-2.025-3.71-1.53-3.555,0.275c0.131,1.519,3.409,3.429,4.454,4.263c0.977,0.779,2.161,1.572,2.855,2.481
		c0.992,1.3,0.811,4.219,3.444,2.256 M182.25,168c0.216,1.204,0.984,1.313,2.012,1.517c-0.645-0.128,2.075-0.951,1.677-0.706
		c0.24-0.148,2.788-1.844,2.085-3.074c-1.125-1.97-2.375,1.097-3.33,1.474c-0.383,0.151-5.293-0.103-2.194,1.789 M169.75,187.75
		c-0.471,0.182-0.802,0.231-1.03,0.743c1.669,1.812,3.888-1.397,3.742-3.204c-2.055-0.133-2.225,2.337-3.962,2.961"
      />
    </a>

    <a (click)="SelectCode('HU')">
      <path
        [class.selected]="IsSelected('HU')"
        id="HU"
        d="
		M548.5,545.75c0.292-0.3,0.567-0.614,0.825-0.943c-0.258,0.302-0.796,0.592-1.124,0.905c-0.321-0.279-1.068-0.375-1.388-0.687
		c-0.692,1.032-0.417,2.013-0.351,3.199c-1.259-0.233-2.603-0.186-3.925-0.262c-0.18-2.46-1.762-0.472-2.286,0.039
		c-1.047,1.019,0.412,1.854-2.001,1.762c-0.905-0.034-2.966-0.884-3.707-1.206c-0.323-0.14-0.864,0.556-1.505,0.142
		c-0.351-0.227,0.244-1.467-0.02-1.71c-2.81-2.59-3.44,0.89-2.768,3.012c0.651,2.057,1.519,3.833,1.212,6.212
		c-0.329-0.034-0.794,0.115-1.113,0.076c0.053,0.626-0.332,0.846-0.399,1.43c-0.894-0.267-1.469-0.849-2.192-1.498
		c-0.599,1.008-3.207,2.566-4.457,2.491c-0.536-0.032-0.377-1.542-1.557-1.411c-0.805,0.089-1.53,1.297-1.743,1.949l-0.031-0.057
		c-0.447,0.049-0.704,0.314-1.182,0.343c-0.134,1.746,1.193,2.058,2.212,3.024c0.956,0.906,1.315,1.137,1.721,2.147l-0.119-0.195
		c1.616-0.985,4.623-0.098,6.877,0.341c4.351,0.849,8.65-1.459,13.055-1.959c4.405-0.499,10.553,2.203,9.364,6.473
		c0.717,2.163,3.306,3.5,5.485,2.833c0.919-0.281,1.723-0.855,2.628-1.178c2.677-0.958,5.988,0.785,6.713,3.534
		c-0.415,0.845-0.829,1.69-1.244,2.534c2.013-0.406,3.24-2.681,3.042-4.724c-0.198-2.044-1.49-3.825-2.976-5.243
		c-1.485-1.418-3.203-2.584-4.623-4.066c-1.69-1.763-2.906-3.916-4.104-6.044c-1.687-2.996-3.374-5.992-5.061-8.989
		c-0.648-1.15-1.299-2.309-1.869-3.5"
      />
    </a>

    <a (click)="SelectCode('HX')">
      <path
        [class.selected]="IsSelected('HX')"
        id="HX"
        d="
		M453.5,574c1.602-1.711,4.471-3.421,6.763-4.438c1.4-0.621,2.291-1.047,3.043-2.062c0.837-1.13,0.075-2.658,2.157-2.537
		c0.597-2.836-1.064-3.128-2.711-3.769c-1.814-0.706-2.185-1.827-3.751-2.444c-1.023-0.403-1.625,0.232-2.681-0.313
		c-0.851-0.439-1.069-1.3-1.757-1.749c-1.491-0.974-3.44-0.485-4.812-1.688l0.456,0.456c-2.015-0.054-1.774,1.768-2.913,2.587
		l-0.156,1.93c1.1,0.084,0.466,1.332,1.413,1.976c1.424,0.968,2.569-0.422,3.198,1.552c0.379,1.189-0.563,2.857-0.241,4.248
		c0.28,1.21,1.28,2.066,1.688,3.252c0.315,0.915,0.367,1.625,0.478,2.306L453.5,574z"
      />
    </a>

    <a (click)="SelectCode('IG')">
      <path
        [class.selected]="IsSelected('IG')"
        id="IG"
        d="
		M566.25,758.25c1.867-0.856-0.044-2.849-0.269-4.244c-0.002-0.012,0.131-2.734,0.075-2.561c0.614-1.894,0.616-0.386,1.693-1.444
		c1.018-1,1.408,0.377,0.513-1.574c-0.048-0.106-1.719-2.125-1.994-2.432c-1.84-2.052-5.605-1.589-5.519-1.744l-0.957,0.544
		c1.7,0.035,1.778,1.456,1.769,2.767c-0.005,0.664-0.771,1.219-0.56,1.94c0.377,1.286,1.309,0.635,1.698,1.3
		c0.986,1.688,1.048,7.514,3.801,7.449"
      />
    </a>

    <a (click)="SelectCode('IM')">
      <path
        [class.selected]="IsSelected('IM')"
        id="IM"
        d="M309,518
		c3.77-0.516,6.298-6.981,8.012-10c1.478-2.603,0.914-3.049,4.014-4.863c2.051-1.2,3.379-2.24,5.887-2.05
		c1.33,2.607-0.896,4.349-0.423,6.4c0.545,2.363,3.901,3.259,4.046,4.999c0.162,1.953-6.683,11.519-7.962,11.588
		c0.009,4.245-5.803,5.671-8.496,7.512c0.15,0.553,0.198,1.239,0.373,1.813c-1.794,0.292-3.488-0.209-4.839-1.362
		c-1.208,1.955-3.182,3.531-5.537,3.388c-0.194-0.413-0.494-1.496-0.55-1.897c1.195-0.443,2.086-1.948,3.026-2.529
		c-0.967-2.338,0.595-12.727,2.95-11.998"
      />
    </a>

    <a (click)="SelectCode('IP')">
      <path
        [class.selected]="IsSelected('IP')"
        id="IP"
        d="
		M583,676.5c-0.079-0.976,1.487-1.023,2.468-1.557c-1.22-1.578-2.171-1.673-1.46-3.693c0.22-0.624,1.827-3.758,2.23-4.011
		c0.568-0.357,1.652,0.586,2.306,0.467c1.367-0.248,1.978-1.485,3.151-1.912c1.624-0.592,3.694,0.28,4.098-1.999
		c1.091,0.167,3.486,0.909,4.525,0.279c1.455-0.882,1.066-2.897-0.048-3.755c0.397-0.365,1.169-0.708,1.686-0.788
		c0.029,0.025,0.25,0.465,0.281,0.507L603.25,659c1.226-2.505,5.696-0.393,7.013,0.75c0.268,0.233,1.778,2.914,1.736,3.5
		c-0.134,1.876-2.008,1.415-3.456,1.294c-0.626,0.76,0.054,1.613-0.099,1.969c-0.124,0.289-0.542,0.969-0.762,1.419
		c-0.746,1.523-2.812,2.504-3.149,4.031c1.577-0.126,3.927,0.38,3.479,2.537c-0.32,1.543-3.474,1.987-4.973,2.039
		c-0.016,1.662,2.308,1.904,3.518,2.637c0.596,0.361,1.268,1.496,1.931,1.586c1.244,0.169,1.654-1.262,2.574-1.474
		c3.09-0.712,7.83,2.264,6.221-3.493c2.196-0.328,2.002,3.868,4.468,1.932c1.072,0.83,2.049,2.759,3.443,0.968
		c0.625-0.803-0.433-1.813,0.039-2.443c1.117-1.491,0.966-0.15,2.086-0.064c0.652,0.05,0.982,0.334,1.932,0.264
		c1.022-0.075,1.692-1.228,2.763-0.768c1.363,0.586,1.679,2.85,2.012,4.023c1.986-0.429,3.372,1.712,5.225,2.238
		c1.871,0.531,4.397,0.66,5.025,2.805c-0.243,0.15-0.574,0.591-0.812,0.745c0.776,0.891,1.796,1.11,2.086,2.231
		c0.754-0.984,1.799-1.196,2.414-2.157c-0.154-0.232-0.305-0.584-0.437-0.782c1.073-0.053,2.174-0.035,3.26-0.042
		c0.337-0.044-0.225,0.156-0.286,0.255l0.525-0.164c-2.358,6.202-6.077,12.03-6.344,18.624c-0.078,1.919,0.066,4.077-1.232,5.493
		c-1.104,1.204-2.889,1.444-4.315,2.241c-3.019,1.688-3.945,5.261-5.904,7.87c-0.994,1.324-2.018,2.403-3.64,2.839
		c-0.692,0.186-1.269-0.037-1.84-0.036l0.5,0.632c-1.677-2.99-8.74-1.329-11.98-1.55c1.068-0.547,3.577-0.424,2.173-2.449
		c-0.708-1.022-2.771-0.636-3.723-1.758c1.484-1.228,1.848-3.936-0.931-3.454c0.532,6.797-7.022-2.438-8.745-3.581
		c-0.067-1.446,1.551-3.865,0.407-5.213c-1.357-1.6-3.652,0.551-5.394,0.83c-1.206,0.193-4.362,0.675-5.575,0.182
		c-1.594-0.648-1.197-1.85-1.981-3.156l-0.035-0.275c-1.408-2.872-2.725-5.764-3.965-8.881c-0.992-2.493-1.183-1.95-3.3-3.127
		c-2.173-1.208-1.523-2.327-2.244-4.28c-2.298,0.421-2.755-3.185-2.212-4.794c0.609-1.803,2.091-2.44,2.468-4.712L583,676.5z"
      />
    </a>

    <a (click)="SelectCode('IV')">
      <path
        [class.selected]="IsSelected('IV')"
        id="IV"
        d="
		M218,192.75c0.656-3.305,4.369-1.529,3.282-5.762c2.275-0.925,5.575,1.816,6.481,3.762c0.645,1.385,0.44,2.206,1.482,3.298
		c1.072,1.124,2.062,1.272,2.755,2.683c1.497,3.047,0.93,5.704,0.737,8.844c-0.211,3.442,0.451,6.348-0.53,9.631
		c-0.439,0.04-0.696,0.317-1.165,0.336c-0.276,0.516-0.384,1.071-0.255,1.67c2.794-0.836,2.408,1.449,2.907,3.343
		c0.514,1.952,1.859,3.378,0.581,5.407c1.394-0.148,2.805,0.428,3.749,1.289c-2.438,2.754,0.072,2.198,1.786,2.499
		c1.822,0.32,3.574,1.664,5.432,2.007c2.168,0.4,4.144-0.132,6.257-0.757c1.501-0.444,4.345-2.901,5.044-0.544
		c3.781-0.211,1.536,4.083,0.706,5.556c-0.81,1.437-0.863,1.746-2.556,2.75c-0.751,0.446-1.887,0.74-2.455,1.424
		c-0.616,0.742-0.186,1.133-0.54,2.002c-0.66,1.621-1.382,2.93-2.436,4.268c-0.271,0.343-1.155,0.349-1.526,0.836
		c-0.374,0.491-0.452,1.873-0.913,2.524c-0.753,1.063-2.527,2.686-3.506,3.494c-1.4,1.155-3.002,0.87-4.518,1.912
		c-0.363-2.187-1.25-2.816-0.312-4.724c0.368-0.749,1.159-1.035,1.505-1.75c0.413-0.855,0.345-2.065,0.511-3.003
		c0.162-0.919-0.728-0.293-0.089-1.476c0.509-0.944,2.509-2.347,3.354-3.044c1.614-1.331,2.609-1.758,4.704-1.503
		c0.015-0.527-0.236-1.462-0.516-1.939c-1.36,0.208-5.568,3.124-6.711,2.678c-1.64-0.641-1.086-4.511-3.444-5.436
		c-0.321,1.922,1.791,4.19-0.77,5.012c0.16,0.948,1.441,3.352-0.27,3.919c-1.67,0.553-1.574-1.667-1.761-2.651
		c-0.299-1.576,0.207-2.731-1.557-3.561c-1.483-0.698-2.57-0.22-1.724,1.449c-1.354,0.29-2.703-0.611-4.22-0.387
		c-1.426,0.211-3.505,1.165-4.711,1.905c0.432-0.902,0.782-1.954,1.132-2.934c-3.528,0.974-5.515-4.011-1.958-3.815
		c0.1-2.311-1.697-0.523-2.863-0.652c-2.035-0.224-1.834-1.669-2.655-3.311c-1.382-2.762-2.661-5.138,1.361-5.907
		c1.026,1.138,3.003,3.571,4.669,3.131c0.376-2.533-3.754-2.98-3.512-5.686c-0.942-0.057-4.869,2.625-3.487-0.481
		c-1.61-0.66-0.618-2.437-1.462-3.593c-0.747,0.996-1.755,2.798-2.569,0.637c-1.352,0.638-1.516,4.823-1.163,6.069
		c-2.531-0.55-2.46-2.806-5.724-1.951c-1.2-1.65-3.182-2.641-3.819-4.518c-0.951-2.8-0.174-2.774-2.949-4.238
		c0.262-3.351,2.416-2.327,4.424-1.231c0.062-1.806-1.971-2.01-1.011-4.231c1.142-2.643,1.469-0.715,2.35,0.98
		c0.758,1.459,1.779,3.567,3.387,4.332c1.292,0.615,2.568,0.661,2.018-1.519c-2.74-0.994-1.081-2.959-2.375-4.617
		c1.844-0.557,3.315,1.28,2.924-1.177c-0.211-1.327-2.495-3.58-3.681-4.087c1.158-1.616-1.283-6.248,2.119-4.662
		c1.622,0.756,2.827,4.331,2.594,5.956c1.532,0.493,2.262,0.344,3.53,1.294c1.03,0.772,1.646,3.306,3.237,1.075
		c0.054,0.411,0.465,0.859,0.482,1.391c1.021-0.043,1.414-0.672,1.264-1.691c1.771,1.229,1.351,2.982,3.948,3.455
		c0.343-0.422,0.419-0.729,0.426-1.257c-1.066-0.246-2.394-2.338-2.944-3.169c-0.635-0.96-1.146-1.926-1.705-2.986
		c0.952-0.685,1.792-1.272,2.391-2.227C218.496,197.818,217.573,194.902,218,192.75z M236.75,219.25
		c-0.83-0.738-0.788,1.772-0.506,2.557c0.849,2.359,1.91,2.146,3.311,1.193c2.065-1.404,1.376-1.901,0.877-3.758
		c-0.46-1.712-0.264-4.327-1.181-5.741c2.78-1.198,2.917-2.579,1.993-5.507c-0.88-2.787-1.755-0.405-3.212,1.501
		c-0.029,0.038-0.481,1.457-0.594,1.693c-0.325,0.675-0.87,1.042-1.132,2.049C235.789,215.222,236.861,217.296,236.75,219.25z
		 M240.5,202c-0.22,1.663,0.138,1.738,0.802,3.716c1.929-0.701,2.275-5.217,0.712-6.44c-1.093,0.499-1.757,3.042-1.764,3.974
		 M239.5,225.25c-0.518,2.28-0.164,3.276,2.013,3.986c0.863,0.282,2.802,0.74,3.437-0.286c1.637-2.642-4.851-5.609-5.7-2.7
		 M227,242.25c-0.327,0.051-0.492,0.222-0.494,0.512c0.854,0.684,1.899,0.673,2.957,0.451c0.134-0.136,0.019-0.494,0.074-0.676
		c0.253-0.005,0.689,0.035,0.92-0.08c1.515-2.716-3.262-1.377-3.956,0.544 M234.511,262.292 M271.5,246
		c2.037-1.371,2.283-3.614,5.249-3.499c3.074,0.119,2.414,2.429,4.488,3.698c2.097,1.284,6,0.536,8.026-0.393
		c2.285-1.048,3.714-3.659,6.23-3.374c2.627,0.297,3.253,2.867,6.008,2.818c1.359-0.024,2.724-0.486,3.819-1.3
		c1.65-1.227,1.266-2.671,2.23-3.962c1.295-1.735,4.458-1.986,6.327-0.744c1.924,1.279,2.674,4.574,3.873,6.512
		c1.911,3.088,2.997,2.264,6,0.807c2.896-1.405,6.702-2.231,8.244-4.618c1.155-1.788,0.016-1.68,2.5-2.189
		c1.754-0.359,3.606-0.445,5.401-0.706c2.079-0.303,4.406-0.423,6.36-1.301c1.041-0.468,1.662-1.426,2.975-1.8
		c-2.086-2.919-1.998-6.169,0.494-8.743c3.125-3.228,4.77-2.868,5.064-7.662c2.42-0.513,3.188-1.788,4.511-3.739
		c0.954-1.407,1.623-5.313,3.464-5.568c0.811-0.112,4.432,1.175,5.486,1.456c0.623,0.166,2.059,1.247,2.494,1.254
		c0.817,0.013,2.782-1.258,2.256-1.198l0.266-0.542c-0.103-0.469,0.019-0.998,0.479-1.633c0.871-1.203,4.315-4.99,5.754-5.335
		c1.12-0.269,2.198,0.884,3.245,0.484c1.053-0.402,2.295-2.477,3.444-3.174c5.005-3.033,2.545,1.746,6.02,2.918
		c2.232-3.576,8.916-10.475,5.792-13.967l0.037-0.241c-2.811-0.438-5.682-1.722-8.329-2.86c-4.545-1.954-10.518-3.218-13.875,0.415
		c-0.831,0.9-1.559,2.856-2.662,3.41c-0.393,0.198-4.629,0.083-4.634,0.064c0.732,3.179-2.579-0.246-3.288-0.294
		c-1.239-0.085-4.098,2.597-5.232,3.332c-1.922,1.245-3.566,2.897-5.766,3.673c-2.687,0.947-6.915-1.678-9.233,0.692
		c-0.545,0.557-0.286,1.839-0.82,2.513c-0.281,0.355-1.655,0.512-2.149,1.04c-1.765,1.885-0.718,3.28-3.428,4.607
		c-2.16,1.058-4.693,1.471-7.066,1.696c-2.22,0.21-4.44,0.42-6.659,0.63c-1.11-2.141,1.996-4.116,4.405-4.001
		c2.409,0.114,5.223,0.865,6.943-0.826c0.804-0.791,1.124-1.935,1.656-2.929c1.112-2.077,3.136-3.476,4.757-5.185
		c1.621-1.709,2.91-4.175,2.042-6.365c-4.739,0.675-9.797,1.497-13.298,4.761c-2.721,2.537-5.632,6.749-9.007,5.184
		c3.141-4.517,6.865-9.417,12.296-10.294c1.311-0.212,2.693-0.178,3.895-0.741c2.89-1.354,4.466-5.895,7.577-5.183
		c-1.053,0.829-1.746,2.237-1.389,3.528c0.358,1.291,2.009,2.16,3.147,1.453c2.672-6.277,6.837-11.913,12.053-16.311
		c0.293-2.049-3.166-2.156-4.644-0.707c-1.477,1.45-2.826,3.678-4.878,3.411c-0.303-1.371-1.911-2.073-3.314-2
		c-1.402,0.074-2.714,0.688-4.086,0.985c-2.603,0.563-5.441-0.086-7.54-1.725c3.003-0.338,6.006-0.677,9.009-1.015
		c0.808-0.091,1.825-0.383,1.898-1.192c0.073-0.81-0.994-1.475-0.371-0.952c1.014-1.087,0.033-2.805-0.023-4.291
		c-0.024-0.646,0.137-1.251,0.427-1.806L346.25,164c-0.622-1.554-2.558-2.296-4.212-2.288c-0.477-2.372,1.743-3.649,2.705-5.449
		c1.211-2.265,0.621-4.918,0.744-7.458c0.104-2.152,1.31-6.01,0.475-8.049c-2.282-5.574-10.336-1.402-13.461-3.751
		c-5.523-4.15-2.264-11.031-1.551-16.823c0.313-2.545,0.689-16.65-2.95-16.932l0.344,0.309c-0.997,1.108-2.59,2.71-3.221,3.452
		c-1.458,1.714-2.03,3.471-4.559,3.4c1.277-4.407,4.634-2.99,1.547-7.937c-1.913-3.065-4.278-4.008-7.534-2.389
		c1.161,2.784-4.118,9.428-7,9.339c-0.138-3.16,4.126-5.097,3.857-7.46c0.04,0.351-3.504-1.745-3.807-2.077
		c-0.924-1.014-1.161-3.101-2.042-4.236c-0.02,2.595,0.477,8.39-1.472,9.309c-2.532-2.862,0.306-5.34-2.989-8.084
		c-2.484-2.068-5.84-1.058-8.163-3.336c-1.566,2.724-0.354,5.92-1.81,8.61c-0.522,0.963-2.565,0.862-3.299,1.826
		c-0.845,1.109-1.309,3.419-1.786,4.437c2.704-0.453,4.658,0.829,3.434,3.087c-0.762,0.429-1.292,1.588-2.297,2.002
		c2.978,2.415-1.187,3.201-3.042,4.623c0.508,0.418,0.986,0.98,1.41,1.387c-0.513,0.155-1.629,1.245-2.144,1.464
		c1.738,2.07,2.435,4.761,0.585,6.924c3.778,1.295,9.775,3.806,11.936,7.034c-1.4-2.237-5.199-2.744-8.46-2.934
		c-3.148-0.183-5.747-1.777-8.897-1.926c-0.163,0.192-0.335,0.376-0.514,0.553c0.453,0.417,0.998,1.374,1.482,1.858
		c-0.979,1.073-1.792,1.286-3.484,0.939c0.079-2.028-0.994-3.231-2.998-3.362c0.147,2.606,2.994,4.898,3.942,7.447
		c0.648,1.743-2.722,4.27,1.892,4.576c0.059-0.111,0.065,1.445,0,1.329c-0.011,0.017-1.19,0.617-1.334,0.711
		c-0.063,0.506,0.737,0.779,0.86,1.263c-0.756,0.345-1.211,0.418-1.774,1.111c0.481,0.251,1.283,0.745,1.788,1.1
		c-0.456,1.809-1.822,3.743-3.962,3.41c-1.986-0.309-0.951-3.419-2.963-3.532c-4.641-0.262,0.569,6.686,3.899,7.109
		c-0.332,4.346,4.891,4.819,7.01,7.813c-0.462,0.241-0.896,0.474-1.371,0.711c2.318,2.414,11.811,7.975,9.811,11.337
		c-3.015-1.771-4.834-5.809-7.988-7.335c-1.281-0.62-4.32-1.195-5.526-1.613c-1.905-0.661-2.485-3.523-4.932-1
		c2.261,1.35,9.83,6.323,9.484,8.436c-2.031-1.109-11.259-5.729-12.853-4.851c0.65,2.303-1.063,3.189-3.438,2.608
		c-1.469-0.36-0.67-2.686-1.336-4.044c-0.681-1.388-2.648-1.333-4.172-1.068c-0.289,2.046-0.546,4.271,0.497,6.055
		c0.312,0.534,0.728,1,1.069,1.517c1.518,2.297,1.309,5.592-0.486,7.679c-1.781-3.577-3.439-7.214-4.972-10.904
		c-2.004,0.475-4.074,0.671-6.132,0.579c-0.149,4.16,0.518,7.889,0.369,12.049c2.232,1.663,4.463,3.326,6.695,4.989
		c-1.929-1.706-5.3-0.001-5.95,2.491c-0.65,2.492,0.61,5.092,2.198,7.119c3.071,3.922,8.095,6.82,12.95,5.705
		c-2.812,2.434-7.243,2.765-10.386,0.775c-2.406-1.523-4.983-4.348-7.48-2.98c-0.874,3.657-0.789,7.538,0.243,11.153
		c1.016,3.558,2.952,7.127,2.162,10.742c3.668-2.144,7.336-4.288,11.005-6.432c-1.126,1.609-1.555,3.687-1.159,5.61
		c2.69-1.957,5.381-3.913,8.071-5.87c1.814,2.991-2.281,6.173-5.73,6.761c-3.449,0.587-7.865,1.122-8.8,4.493
		c3.924,1.634,8.357,2.019,12.504,1.085c0.219,3.002,2.578,5.722,5.519,6.362c-3.411-0.993-6.823-1.986-10.234-2.979
		c-1.623,3.227-3.245,6.453-4.868,9.68c4.469,2.832,9.623,4.577,14.894,5.04"
      />
    </a>

    <a (click)="SelectCode('KA')">
      <path
        [class.selected]="IsSelected('KA')"
        id="KA"
        d="
		M278,381.5c0.882-3.549,5.432-0.456,6.744,1.001c1.027,1.14,2.085,2.386,2.317,3.986c0.23,1.587-1.153,3.19-0.823,4.526
		c0.276,1.116,1.672,1.49,2.073,2.487c0.611,1.522-0.455,1.551-0.385,2.75c0.112,1.908,1.939,3.914,1.773,6.237
		c-0.433,6.061-8.69,4.869-11.65,1.5c-1.469-1.672-2.638-3.402-2.536-5.487c0.123-2.52,0.391-4.038-0.695-6.5
		c-0.93-2.109-3.899-4.544-2.018-7.012c0.692-0.908,2.623-1.331,3.456-2.037c0.947-0.802,1.669-2.035,2.493-2.951 M297.25,375
		c-0.515,0.985-2.438,6.213-0.488,5.28c1.504-0.719,2.764-5.21,0.289-5.498c-0.215,0.491-0.54,1.181-0.551,1.718 M298.378,369.875
		c0.144,1.62,0.59,3.182,1.456,4.634c0.383,0.642,0.854,1.282,0.893,2.028c0.064,1.231-1.039,2.178-1.506,3.319
		c-1.448,3.539,3.152,6.222,6.287,8.411c4.746,3.314,7.442,9.347,6.744,15.093c1.042,0.617,1.508,2.052,1.026,3.163
		c-3.326-1.772-7.831,2.478-6.256,5.902c-2.431-0.865-4.798,1.768-5.242,4.31c-0.444,2.542,0.171,5.209-0.481,7.706
		c-1.05,4.021-4.794,5.708-4.793,9.864c-2.729,3.395-4.189,7.724-4.281,12.073l-0.475,0.373c1.07-0.876,2.967,0.124,3.944-0.719
		c1.436-1.239-0.275-3.776,1.075-5.043c0.922-0.865,4.635-0.708,5.737-0.245c1.812,0.762,1.534,2.762,3.046,3.58
		c1.276,0.691,6.543-0.364,7.478-1.518c1.476-1.82-0.377-1.635-1.084-3.35c-1.159-2.813,2.036-3.165,2.308-5.206
		c0.204-1.534-1.387-3.501-1.216-5.467c1.917-0.047,4.79-0.489,6.4,0.519c1.411,0.883,1.406,2.601,3.506,2.955
		c1.259,0.212,2.292-0.547,3.55-0.012c1.044-1.074,2.276-3.131,2.694-4.462c0.685-2.186-0.743-3.445-0.149-5.457
		c0.582-1.969,2.163-3.23,3.98-3.581c1.346-0.26,2.254,0.642,3.213,0.531c3.585-0.414,4.188-3.847,4.825-6.514
		c0.98-4.1,4.295-6.54,5.23-10.721c0.163-0.005,0.319-0.001,0.469,0.011L346,402.5c0.901-1.107,2.548-2.051,3.318-3.194
		c0.922-1.371,0.257-3.147,1.712-4.055c-1.007-1.243-3.053-2.51-4.531-3.182c-2.662-1.211-3.19,0.694-5.694,1.743
		c-2.749,1.151-3.011,0.869-3.743-1.873c-0.209-0.781-0.265-2.4-0.557-2.944c-0.385-0.716-1.315-0.88-1.754-1.545
		c-0.864-1.307-0.292-1.489-1.501-2.631c-0.732-0.692-2.086-1.277-2.95-1.886c-1.896-1.336-3.743-2.387-5.799-3.494
		c-1.67-0.899-3.4-1.625-4.995-2.445c-1.448-0.744-3.063-3.299-4.763-1.213c-1.081-0.749-2.196-0.212-3.066-1.225
		c-0.53-0.617-0.149-1.994-0.677-2.804c-0.581-0.888-1.925-0.948-2.448-1.752c-0.598-0.918,0.008-2.042-0.483-3.012
		c-0.829-1.637-4.172-3.136-5.828-1.992c-0.98,0.677-0.726,2.273-1.558,3.205c-0.693,0.776-1.653,1.191-2.63,1.5
		c0.223,0.092,0.456,0.108,0.699,0.05L298.378,369.875z"
      />
    </a>

    <a (click)="SelectCode('KT')">
      <path
        [class.selected]="IsSelected('KT')"
        id="KT"
        d="M548,768
		c-2.062-1.125-1.265-3.539-4.206-3.212c-0.427,1.963-4.987,2.952-6.794,3.462c-2.246,0.634-1.454-0.066-3.237-0.811
		c-1.248-0.522-3.12-1.267-2.801,1.024c-0.578-0.025-1.307,0.183-1.887,0.025c0.216,0.134,0.446,0.174,0.674,0.263l-0.703,0.019
		c-0.128,0.309-0.2,0.634-0.008,0.98c0.409,0.739,3.654,3.37,4.448,3.756c2.671,1.298,3.429,0.029,2.581,3.55
		c-0.227,0.943-0.695,1.31-0.568,2.445c0.163,1.451,0.87,1.245,1.249,1.988L536.75,782c1.368-1.147,3.136-2.515,4.805-3.188
		c1.279-0.516,4.132-0.639,1.796,1.187c1.591,0.626,4.292-0.036,5.899-0.505c0.644-0.188,0.797,0.381,1.456,0.017l0.044-0.761
		c-1.021,0.058-0.701-2.033-0.286-3.427L550.25,775c-0.946-0.103-1.766-0.31-2.711-0.536c0.333-1.843-0.381-4.818,0.409-6.243
		L548,768z"
      />
    </a>

    <a (click)="SelectCode('KW')">
      <path
        [class.selected]="IsSelected('KW')"
        id="KW"
        d="
		M384.5,77.5c-1.404-0.188-0.893-0.933-1.506-1.75c-0.203-0.27-0.984-1.395-1.188-1.744c-0.998-1.707-1.69-2.635-1.081-4.775
		c-2.247-0.983-4.67-1.31-2.926-4.549c1.368-2.543,3.981-2.43,5.638-0.669c0.37,0.393,0.071,0.947,0.308,1.236
		c0.568,0.694,0.842,0.538,1.712,1.196c1.1,0.833,2.39,1.384,3.243,2.568c1.182,1.64,1.004,3.614,2.33,5.237
		c-0.49,0.492-2.988,1.12-3.047,1.737c-0.157,1.657,2.486,0.215,3.211,0.208c5.249-0.053-1.738,1.793-1.988,2.767
		c-2.251,0.384-4.075-0.732-5.956-1.712 M396.25,71.25c-1.371-0.159-3.627-0.007-3.81,1.75c-0.158,1.514,1.967,2.439,3.267,1.456
		c-0.025-0.329,0.119-0.79,0.081-1.114c1.025,0.082,0.97-0.179,1.425-1.03c-0.444-0.592-0.874-0.585-1.213-0.563 M400.75,80.25
		c-1.004,1.947,2.731,4.974,4.323,3.012c1.226-1.51-0.766-4.67,0.176-6.763c0.936-2.079,3.029-2.747-0.494-3.249
		c-0.97-0.138-7.976-1.562-5.037,1.056c-1.254,1.369,1.139,5.041,1.282,6.694 M405.5,68.75c-1.388,1.191-4.171,0.196-4.711,1.7
		c1.127,0.742,3.654,1.441,5.017,1.3c3.817-0.396,0.107-1.085,0.913-2.963C406.068,68.531,405.997,68.324,405.5,68.75z M407.75,68.5
		c4.021-0.112,2.729-2.768,5.812-3.994c2.136-0.848,2.612-1.327,2.883-3.756c0.429-3.837-0.23-2.666-2.932-1.306
		c-0.761,0.383-2.034,0.396-2.587,0.981c-0.866,0.917,0.373,2.231-1.438,2.799c-2.71-3.626,2.534-4.115,2.218-6.431
		c-1.515-0.403-2.848,0.939-4.456-0.013c-0.514,1.149-1.594,3.168-2.775,1.468c1.093-0.942,1.596-4.651-0.739-4.011
		c-1.044,0.286-0.44,1.83-1.163,2.085c-1.297,0.458-1.193-0.773-2.137-1.011c-1.211-0.304-1.155-0.192-2.438-0.118
		c-0.8,0.046-2.242,0.879-2.816-0.127c-0.386-0.675,2.504-2.425,2.106-4.274c0.859-0.119,1.434-0.303,2.229,0.182
		c1.26-1.855-0.782-4.85-2.987-5.019c1.591-3.589-6.93-6.845-9.532-6.193c-2.755,0.691-3.349,1.473-4.488,3.735
		c-0.7,1.391-1.148,0.959-1.206,2.738c-0.041,1.266,0.409,2.433,0.263,3.763c-0.303,2.763-0.754,4.824,0.181,7.72
		c0.272,0.843,0.607,2.196,1.494,2.549c1.234,0.49,2.146-1.14,2.944-1.093c2.423,0.144,1.151,4.39,3.673,5.274
		c2.928,1.026,4.538-1.419,6.438-2.404c0.575-0.298,1.97-0.16,2.895-0.594c0.875-0.411,1.23-1.295,2.317-1.432
		c0.456,2.362,0.523,4.911,3.226,6.244c0.464,0.229,1.291-0.242,1.763-0.025c0.753,0.347,0.841,0.989,1.438,1.33
		c1.106,0.63,1.475,1.427,2.812,0.932 M405.5,48.5c-0.746,0.295-2.296,2.342-1.518,3.505c0.831,1.243,3.01,0.218,4.268,0.289
		c0.794,0.045,1.064,1.486,1.949,0.723c1.066-0.917-0.557-1.495-0.467-2.011c0.264-1.523,1.381-2.98,1.736-4.911
		c-1.638-0.115-3.564,2.136-4.456,3.387c-0.679-0.651-1.18-0.372-1.762-0.481 M397.5,34.75c-1.252,0.006-3.087,0.677-3.444,2.057
		c-0.497,1.924,2.381,3.841,3.888,4.706c0.952,0.546,3.315,1.503,4.311,0.199c0.681-0.892-0.289-3.881-0.049-5.169
		c-1.041-0.454-2.054,0.193-2.943-0.032c-1.217-0.308-1.801-1.121-2.763-1.012 M401,46c-2.493,0.419,1.188,2.933,2.53,0.994
		c-0.781-1.076-2.224-1.331-3.28-0.494 M403.25,38.75c-0.362-0.438-0.199,0.886,0.05,1.494c0.425,1.038,0.744,1.848,1.912,1.973
		c0.485-2.087,0.716-3.253-1.712-4.217 M402.5,27.75c-0.49-1.704,0.734-1.221,1.736-0.694c1.245,0.654,1.005,1.531,1.514,2.444
		c0.781,1.404-0.531,1.688,1.194,1.249c0.293-0.074,1.857-1.715,2.031-2.011c-1.636-1.141-1.421-2.758-2.523-3.938
		c-1.183-1.266-3.344-0.559-4.475-2.05c1.208-0.992,0.374-2.563,1.81-3.487c-1.048-2.576-2.403,0.269-3.03,0.738
		c-0.851,0.636-0.37,0.698-1.446,1.067c-0.795,0.273-1.95-0.389-3.039,0.245c2.069,1.948,2.389,4.186,4.022,6.394
		c0.819,0.158,1.686,0.069,2.443-0.256c-0.451-0.361-0.418-1.096-0.486-1.2 M405.25,16.25c0.285,1.66-0.306,9.096,1.749,4
		c0.211-0.522,1-3.507,0.763-3.999c-0.841-1.743-2.547-0.385-2.262,1.249 M412.5,29.75c-2.438,0.79-0.662,3.675-0.282,5.463
		c-0.984,0.371-2.253,0.357-3.18,0.075c0.094,1.417,1.216,2.986,1.961,4.212c1.305,2.146,0.675,1.918,3.463,1.206
		c0.252-1.696-1.302-2.807-1.023-4.711c0.191-1.302,2.117-2.922,0.149-3.758c3.675,0.073-0.338-4.917-2.089-2.236 M417.25,44.75
		c-0.228,0.85-0.37,1.809-0.212,2.712c1.434,0.433,2.738-0.167,2.056-1.73c0.297,0.013,0.58,0.006,0.87,0.055
		c0.77,4.512,2.252,0.531,4.737,2.175c0.771-1.068,1.072-3.673-0.662-4.005c-0.043-1.547-1.523-1.097-2.749-0.995
		c-0.091-0.949,0.494-1.757,1.246-2.201c-0.551-1.192-3.23-2.51-4.491-2.218c-0.561,1.417,1.546,2.084,1.15,3.901
		c-0.34,1.559-2.047,1.531-1.944,3.306 M418.5,31.25c-1.455,0.546-1.74,2.215-2.275,3.498c1.588,2.556,3.424-3.773,4.982-4.217
		c0.459,0.953,0.269,1.074,1.505,0.744c0.02,0.304,0.069,0.634,0.076,0.936c0.913,0.05,1.553-0.501,1.755-1.424
		c0.431,0.142,1-0.044,1.475,0.193c-0.059-0.491,0.286-1.014,0.007-1.68c0.998-0.386,1.57-1.238,1.769-2.257
		c1.147-0.098,3.291,0.624,3.887,0.143c1.222-0.987-0.036-2.648,0.257-3.94c-2.076-1.711-4.818,3.576-6.949,4.204
		c-3.923,1.157,0.636-2.276,0.473-3.657c-1.07-0.451-2.694,0.209-3.455,0.963c-1.154,1.144-0.061,1.032-0.751,2.749
		c-0.809,2.014-4.281,2.368-4.256,5.244 M430.25,15.75c-0.963,1.012-1.196,2.664,0.493,3.005c2.071,0.418,1.599-1.373,2.001-2.455
		c0.335-0.901,2.621-1.365-0.244-1.8c-2.407-0.365-2.462,1.191-2.75,3.25 M346.286,163.34c0.547-1.357,1.872-2.449,3.211-3.174
		c1.786-0.966,3.818-1.648,5.139-3.191c0.898-1.049,1.374-2.4,2.234-3.479c0.557-0.699,1.259-1.264,1.955-1.824
		c4.003-3.219,8.006-6.438,12.01-9.657c0.884-0.711,1.799-1.46,2.265-2.494c0.404-0.895,0.43-1.917,0.761-2.841
		s0.196-0.805,1.166-0.65c3.827-4.305,8.891-7.277,13.368-10.902c4.476-3.624,8.591-8.348,9.254-14.07
		c-2.019-1.254-4.276-2.91-4.301-5.286c-0.013-1.26,0.634-2.42,1.261-3.512c1.957-3.403,3.914-6.807,5.871-10.21
		c-3.475,0.673-7.091,0.614-10.542-0.172c-2.493-0.568-5.741-1.224-7.072,0.959c-0.35-0.737-0.699-1.474-1.049-2.21
		c-1.525-0.57-3.435,0.38-3.901,1.94c1.671,0.041,3.233,1.317,3.606,2.946c-3.452,0.829-7.111,0.783-10.541-0.132
		c-1.786-0.477-3.688-1.184-5.42-0.536c-1.286,0.481-2.189,1.615-3.198,2.546c-4.668,4.304-12.808,4.022-17.167-0.594
		c-0.834-0.026-1.654,0.531-1.938,1.315c-0.25,0.688-0.111,1.48-0.41,2.149c-1.303,2.92-7.819-0.337-8.249,2.831
		c-1.553-1.24-3.827-1.501-5.62-0.643c0.446-0.21,0.168,0.2-0.412,0.862l-0.048,0.086c3.083,1.527,2.729,14.371,2.431,16.788
		c-0.713,5.791-3.972,12.672,1.551,16.823c3.125,2.349,11.179-1.823,13.461,3.751c0.835,2.039-0.371,5.896-0.475,8.049
		c-0.122,2.54,0.467,5.193-0.744,7.458c-0.962,1.8-3.183,3.077-2.705,5.449c1.655-0.008,3.59,0.734,4.212,2.288L346.286,163.34z"
      />
    </a>

    <a (click)="SelectCode('KY')">
      <path
        [class.selected]="IsSelected('KY')"
        id="KY"
        d="
		M364.566,349.037c4.522,1.404,9.182,2.367,13.891,2.867c1.229,0.13,2.552,0.21,3.619-0.413c1.073-0.627,1.676-1.849,2.708-2.543
		c1.164-0.783,2.682-0.776,3.977-1.315c1.562-0.651,2.676-2.035,3.722-3.365c2.417-3.076,4.834-6.152,7.251-9.227
		c0.727-0.926,1.58-1.924,2.75-2.056c1.969-0.222,3.332,2.076,5.27,2.49c1.052,0.224,2.135-0.14,3.125-0.563
		c4.449-1.9,8.327-5.114,11.019-9.133c-3.447-2.555-7.184-4.718-11.116-6.435c2.353-3.305-1.3-8.164-5.345-8.475
		c-4.046-0.311-7.707,2.211-10.933,4.672c-2.701,2.06-5.609,4.246-8.865,4.892L386,321c-0.084-0.068-0.299-0.619-0.255-0.286
		c0.652,2.633-1.887,1.517-3.013,2.281c0.387-0.262-1.26,2.293-1.169,2.068c-0.258,0.637-0.101,1.343-0.369,1.882
		c-1.322,2.654-1.551,1.508-3.944,1.244c-2.208-0.244-3.927,1.117-6.25,1.562l0.407-0.244c-0.842,0.4-3.342,4.618-3.412,5.762
		c-0.166,2.707,2.579,1.357,3.411,3.556c-5.434-0.466-5.657,6.935-6.906,10.426L364.566,349.037z"
      />
    </a>

    <a (click)="SelectCode('L')">
      <path
        [class.selected]="IsSelected('L')"
        id="L"
        d="
		M415.053,584.885c-0.151-0.111-0.328-0.223-0.548-0.334c-1.639-0.826-4.395-2.111-4.511,0.199
		c-0.043,0.866,0.969,3.976,1.431,4.812c1.298,2.346,3.001,1.51,1.324,3.875c-1.032,1.455-2.394,1.648-1.769,3.874
		c0.137,0.486,1.067,1.029,1.28,1.689c0.331,1.027-1.218,0.916-0.261,1.75l-0.548-0.263c-1.979-1.468-6.302-2.029-7.452-3.598
		c-2.007-2.742-3.388-7.144-4.999-10.116c-2.415-4.456-2.723-7.685-1.889-10.563L397,576.75c-0.257-0.22,2.168-2.258,3.757-3.268
		c1.219-0.775,3.539-0.841,4.743-1.427c0.167-0.081,0.74,0.13,1.068-0.038c0.311-0.159,0.249-1.08,0.489-1.211
		c0.91-0.498,1.031-0.778,2.194-0.807c1.692-0.041,2.72,1.144,4.462,0.788c-0.031,0.915,0.438,1.739,1.2,2.274
		c-1.627,0.897-6.069,1.746-3.506,4.139c-0.559,0.186-1.884,0.706-2.107,1.349c-0.66,1.906,0.816,1.382,1.699,2.007
		c1.542,1.09,4.649,1.997,3.751,4.193L415.053,584.885z"
      />
    </a>

    <a (click)="SelectCode('LA')">
      <path
        [class.selected]="IsSelected('LA')"
        id="LA"
        d="
		M407.25,544.5c1.119,0.134,3.86,1.46,3.787-2.211c0.528,0.069,1.759,0.783,2.2,0.724c0.883-0.117,1.631-1.111,2.257-1.037
		c1.049,0.124,1.36,1.368,2.061,1.732c0.911,0.472,1.977,0.332,2.895,0.667l0.049-0.124c0.733-1.339,2.961-6.275,4.3-6.95
		c1.004-0.506,2.189,0.173,3.194-0.232c1.409-0.568,1.27-1.589,3.006-1.581c0.795,0.004,1.347,0.118,1.725,0.313l0.025-0.05
		c1.023-0.976,1.675-1.877,2.45-3c0.258-0.374-0.043-0.904,0.226-1.311c0.261-0.395,1.142-0.499,1.274-0.744
		c0.951-1.78,1.424-3.806-0.2-5.394c-1.721-1.682-4.33-1.014-2.176-3.981c1.282-1.766,3.121-1.095,3.944-3.057
		c0.341-0.814-0.091-1.202-0.128-1.639l-0.391-0.374c0.177-1.249-1.192-1.802-1.205-2.744c-0.014-1.054,0.887-2.21,1.15-3.256
		c0.391-1.558,0.832-3.331,1.148-4.982l-0.639-0.234c-1.937,0.863-4.642,2.938-7.216,1.534c-1.239-0.676-1.363-2.707-2.682-3.397
		c-1.672-0.875-3.884,0.521-5.519,0.292c-0.815-0.114-2.755-0.843-3.293-1.456c-0.861-0.982-0.22-1.485-0.744-2.507
		c-1.027-2.003-4.217-3.104-6.514-4.313c-1.693-0.891-2.032-0.898-3.779-0.957c-1.78-0.06-1.594,0.05-3.264-0.487
		c-3.125-1.005-5.041,0.037-7.887,0.187c-1.588,0.084-1.524-0.457-3.039,0.565c-0.78,0.526-3.766,2.498-4.217,3.242
		c-1.024,1.689,0.121,3.835-1.363,5.999c-2.739,3.993-8.208,2.051-11.704,4.616l-0.231,0.319c0.236,0.768,0.421,1.551,0.551,2.345
		c0.501,3.046,1.081,5.39,3.297,7.642c1.17,1.189,6.855,2.489,6.532,2.067c-0.923-1.211,0.268-3.301,1.78-3.125
		c-1.336,3.192-2.692,6.471-2.823,9.929c-0.131,3.458,1.222,7.189,4.204,8.947c-0.53-1.609-0.814-3.3-0.839-4.994
		c0.918-0.019,1.824,0.527,2.237,1.347c2.492-4.267,4.984-8.534,7.475-12.801c1.199,1.378,1.784,3.271,1.571,5.084
		c2.838-1.812,5.676-3.623,8.513-5.435c-0.451,1.725-0.902,3.45-1.353,5.175c1.006,0.679,2.012,1.359,3.018,2.038
		c0.073,2.467-2.055,4.344-3.793,6.096c-1.739,1.751-3.314,4.438-2.023,6.542c1.059,1.727,3.713,3.837,1.997,4.913L407.25,544.5z"
      />
    </a>

    <a (click)="SelectCode('LD')">
      <path
        [class.selected]="IsSelected('LD')"
        id="LD"
        d="
		M360.75,704.5c0.408-2.802,2.1-6.562,1.506-9.256c-0.141-0.64-0.853-1.055-0.943-1.757c-0.135-1.052,0.247-1.361,0.443-2.487
		c0.497-2.851,1.023-3.297,3.494-5.032c0.655,0.29,2.272,0.591,3,0.476c2.059-0.327,1.4-0.389,2.487-2.077
		c0.674-1.048,0.971-2.118,2.207-2.622c1.112-0.453,2.218,0.42,3.556-0.295c1.046-0.559,1.438-2.319,2.251-2.949
		c1.342-1.041,2.006-0.064,3.499-0.476c2.463-0.68,2.685-1.869,5.569-0.842c2.332,0.83,3.858,2.221,5.925,3.318
		c1.008,0.535,2.505,0.659,3.4,1.313c0.964,0.705,1.172,1.815,2.149,2.381c0.932,0.539,1.896,0.036,2.895,0.868
		c0.849,0.707,1.146,1.896,1.372,2.932c0.351,1.612-0.321,1.458,0.635,3.024c0.379,0.621,1.905,0.302,1.76,1.476
		c-0.337,2.735-4.573-0.182-4.494,2.468c-2.78,0.089-3.734,1.385-5.706,2.789c-2.147,1.528-4.643,0.523-6.512,2.735
		c0.08-0.094-1.718,2.732-1.706,2.514c-0.1,1.69,1.651,0.848,2.411,1.807c2.161,2.724-1.434,3.427-3.411,3.481
		c-0.302,1.821,1.733,2.732,1.505,4.669c1.51,0.68,2.463-0.244,3.718,0.795c0.857,0.709,1.41,2.624,2.238,3.498l-0.243-0.7
		c-1.084,1.483,0.763,3.108,0.048,4.505c-0.953,1.862-1.978,0.162-3.56,0.69c-1.765,0.589-1.311,1.706-2.182,3.255
		c-0.841,1.495-2.004,1.062-2.761,2.052c-0.766,1.001-0.766,2.702-1.801,3.949l-0.177-0.205c-0.569-2.4-1.6-4.576-4.573-3.995
		c-1.035,0.202-1.54,1.453-2.499,1.717c-0.645,0.177-1.767-0.323-2.556-0.28c-2.458,0.134-3.965,0.167-6.408-0.198l0.213,0.461
		c-1.358-1.371-3.447-1.51-4.457-2.993c-0.74-1.087-1.237-5.015-0.81-6.201c0.644-1.792,2.86-2.694,3.968-4.056
		c1.778-2.184,0.643-2.65-0.762-4.238c-0.654-0.74-1.031-1.547-1.725-2.256c-0.459-0.469-1.406-0.636-1.736-1.243
		c-0.438-0.805,0.353-1.318-0.008-2.013c-0.288-0.553-0.594-0.986-0.933-1.305L360.75,704.5z"
      />
    </a>

    <a (click)="SelectCode('LE')">
      <path
        [class.selected]="IsSelected('LE')"
        id="LE"
        d="
		M499.068,682.568c0.626-1.948-0.076-2.528,2.438-3.505c1.081-0.42,3.132-0.371,4.013-1.232c1.355,4.422,10.481,1.895,10.268-2.544
		c3.335-0.619,4.333-1.038,6.007-3.58c1.751-2.658,3.752-5.325,6.138-7.176c0.303,0.388,0.629,0.565,0.971,0.628l0.597,0.091
		c0.191,0.264-0.617-3.455-0.75-4.263c-0.253-1.535-0.294-2.334,1.962-2.025c0.78-1.822-0.88-1.63-1.225-2.712
		c-0.331-1.037,0.009-1.591,0.045-2.975c1.895,0.953,1.529-0.906,2.655-1.538l-0.799-0.159c-2.471-2.119-7.825-0.346-9.105-3.565
		c-0.662-1.666,3.316-6.126-0.79-6.086c-1.062,0.01-1.809,1.318-2.938,1.267c-0.906-0.041-2.065-0.85-2.78-1.499
		c0.26-0.764,0.53-2.236-0.075-2.95c-1.261-1.488-1.376-0.052-2.719,0.269c-1.763,0.422-5.371-0.113-4.769,2.694
		c-3.355,1.117-6.411,3.335-8.657,0.487c-0.724-0.918-0.023-2.614-2.255-2.156c-0.879,0.18-0.455,2.11-2.513,1.749
		c0.351,3.225-5.366,3.513-7.544,3.949c-1.739,0.348-4.14,0.157-5.069,1.069c-0.998,0.981-1.923,4.167-2.657,5.449
		c0.976,0.638,2.004,1.296,2.955,1.981c-0.64,0.863-1.326,1.821-0.474,2.763l-0.002-0.125c2.798-0.034,5.856,0.12,6.458,1.181
		c0.729,1.284-0.339,4.91-1.013,6.139c-0.761,1.388-3.159,4.439-2.71,6.056c0.266,0.96,1.725,0.987,2.022,1.8
		c0.344,0.943-1.013,1.776-0.78,2.45c0.947,2.741,3.463-0.308,4.513-0.268c2.074,0.08,3.885,3.528,4.706,5.287
		c0.841,1.803,4.034,2.974,4.056,3.231L499.068,682.568z"
      />
    </a>

    <a (click)="SelectCode('LL')">
      <path
        [class.selected]="IsSelected('LL')"
        id="LL"
        d="
		M383,598.75c-2.073,0.212,0.103,7.796,0.487,9.737c0.172,0.872,0.289,2.816,0.726,3.574c0.554,0.96,1.869,0.877,2.486,1.994
		c0.75,1.357,0.088,3.06,1.326,4.445c-1.065,1.346-2.422,2.593,0.212,3.262c0.781,0.198,3.758-0.186,4.319-0.439
		c1.422-0.642,2.486-2.553,3.744-3.505c1.867-1.412,1.937-0.831,3.962-0.801c1.392,0.021,2.53-0.596,4.238,0.24
		c2.337,1.144,1.127,1.758,1.682,3.798c0.533,1.956,1.942,3.237,2.067,5.426c0.104,1.827-1.667,4.631,0.72,5.568
		c-0.191,2.718-4.195,0.246-5.719-0.062c-3.858-0.78-3.335,0.978-5.306,3.23c-3.968-1.446-4.814,0.623-7.444,3.038
		c-1.188,1.091-3.584,2.366-5.255,2c-1.212-0.265-1.748-1.661-3.245-1.774c-1.924-0.146-4.958,1.233-6.755,1.836
		c-2.466,0.828-3.5,0.876-5.434,2.683c-2.111,1.972-4.335,3.445-6.569,5.251c-2.536,2.049-2.62,4.549-5.486,4.992
		c-1.435,0.221-1.952-0.192-3.057,0.919c-1.518,1.526-0.477,1.818-0.998,3.337c-0.308,0.897-1.164,2.022-1.757,2.731
		c-1.289,1.542-2.033,1.065-3.456,2.069c-3.996,2.819,1.587,2.668,0.462,4.893c-0.59,1.167-4.646,1.365-5.794,2.797l-0.651-2.817
		c-0.718-1.634-2.217-2.943-2.459-4.712c-0.469-3.427,3.995-6.262,3.125-9.609c-0.279-1.071-1.068-1.918-1.716-2.815
		c-2.267-3.135-2.924-7.375-1.711-11.049c1.388,0.028,2.582-1.474,2.243-2.821c-7.242-1.201-14.886,0.189-21.241,3.864
		c0.206,1.83,0.385,3.801-0.527,5.401c-0.912,1.599-3.387,2.397-4.619,1.029c-0.219-0.244-0.389-0.542-0.665-0.72
		c-0.507-0.327-1.174-0.141-1.745,0.054c-2.641,0.904-5.282,1.808-7.923,2.711c1.474-7.217,6.957-13.479,13.916-15.893
		c2.83-0.982,4.372-3.973,6.761-5.78c1.576-1.192,3.313-2.711,3.216-4.685c-0.062-1.25-0.87-2.323-1.65-3.302
		c-2.291-2.874-4.645-5.698-7.057-8.471c-1.686-1.938-4.276-4.03-6.523-2.785c0.381-2.833-1.992-5.731-4.845-5.915
		c-0.715-1.304,0.911-2.894,2.387-2.717c1.477,0.177,2.587,1.395,3.491,2.576c1.035-0.436,2.15-0.683,3.273-0.723
		c-1.318-2.088-2.685-4.602-1.771-6.896c1.135-2.849,4.882-3.358,7.948-3.404c2.194-0.033,4.6,0.016,6.268,1.442
		c1.02,0.872,1.604,2.136,2.157,3.359c1.014,2.242,2.027,4.483,3.041,6.725c2.772-0.596,5.543-1.193,8.315-1.789
		c-1.632,3.15-3.88,5.98-6.576,8.284c4.591,1.29,12.718-3.365,16.99-5.228c-0.762-0.853-1.158-2.021-1.072-3.162
		c0.214-2.825,10.246,1.956,10.994,2.43c5.103-1.131,9.145-2.669,14.247-3.8c1.17-0.259,2.373-0.519,3.562-0.535L383,598.75z"
      />
    </a>

    <a (click)="SelectCode('LN')">
      <path
        [class.selected]="IsSelected('LN')"
        id="LN"
        d="
		M577.156,604.421c-2.077-6.46-4.331-13.209-9.262-17.871c-0.16-0.152-0.323-0.3-0.488-0.446l-1.157,0.146
		c-0.316-0.309-1.993,1.352-3.249,1.456c-1.246,0.103-2.508-1.061-4.232-0.473c0.588,1.46,1.163,1.587,0.194,2.511
		c-0.58,0.552-3.452,0.791-4.175,0.719c0.019-1.249-0.883-2.397-1.971-2.936c-1.505,1.54-3.355,0.689-3.817-1.076
		c-0.451-1.724,0.437-2.678,1.223-4.144c-1.505-0.975-4.692-2.041-6.386-1.507c-1.285,0.405-1.509,1.867-3.587,1.451
		c-1.841-0.369-1.597-1.95-3.25-2.262c-2.529-0.478-0.255,1.814,0.724,2.262c-0.947,1.38-3.156,2.009-2.686,3.736
		c0.325,1.195,3.454,1.865,1.149,3.7c-1.589,1.265-2.382-0.736-3.882,1.569c-1.095,1.684-0.089,2.436-0.556,3.994
		c-1.179,3.933-13.493,1.78-12,9.5l0.537,1.463c1.915-0.173,4.435-0.239,5.442,1.782c-2.362,1.703-5.467,1.906-5.953,5.206
		c2.007,0.289,1.76,2.502,1.974,4.049c0.277,2.001,0.002,2.518,1.724,4.06c-0.771,2.612,0.009,2.713,2.276,2.745
		c2.359,0.034,4.916,0.246,7.205-0.055c2.135-0.28,3.324-0.931,5.307-0.751c1.916,0.174,2.798-0.195,4.694-0.456
		c0.579,1.908,4.082,4.544,5.724,5.544l0.539-0.125c-0.096-1.018-0.452-1.969-1.119-2.769c1.562-3.126,2.325,0.718,2.95,1.006
		c2.201,1.012,1.873-1.092,2.883-2.012c1.428-1.301,3.104-0.097,2.061-2.682c-0.685-1.696-2.359-1.577-3.243-3.263
		c-1.11-2.115-0.226-2.175,1.5-3.726c0.821-0.737,1.618-2.276,2.556-2.781c0.776-0.418,1.788-0.131,2.444-0.489
		c2.229-1.214,0.571-2.309,1.732-4.048c1.387-2.078,3.179-0.317,3.5,1.523c2.394-1.612,3.151,0.039,5.268,0.72
		c0.988,0.318,1.778,0.061,2.742,0.55c1.002,0.508,0.222,1.715,1.97,1.468c0.195-1.188-0.103-2.518-0.017-3.461
		c0.092-1.007,1.427-1.293,0.343-2.439c0.504-0.419,1.467-0.805,1.711-0.812L577.156,604.421z"
      />
    </a>

    <a (click)="SelectCode('LS')">
      <path
        [class.selected]="IsSelected('LS')"
        id="LS"
        d="
		M497.35,561.629c0.036-0.721-0.586-1.602-0.424-2.452c0.039-0.205,1.296-0.455,1.529-0.982c0.201-0.454-0.212-1.305-0.011-1.944
		c1.392-4.413-0.721-3.371-3.911-5.963c1.367,0.395,3.342-0.476,4.441-1.544c-0.357-0.962-1.87-2.111-2.46-2.757
		c-1.691-1.847-1.149-1.029-3.989-1.723c-2.764-0.675-3.407-5.025-5.982-5.23c-0.422,1.077-1.773,0.81-2.06,1.449
		c-0.379,0.842,0.361,1.534,0.205,2.025c-0.54,1.706-1.554,1.809-3.648,1.276c0.52,1.325-0.26,2.935-1.726,2.154
		c-1.575-0.839-0.454-2.201-2.494-2.649c-0.518-0.113-1.223,0.76-2.111,0.474c-0.633-0.203-0.961-1.217-1.507-1.518
		c-1.355-0.748-3.491,0.205-4.418-1.195c0.751-0.625,1.243-2.347,0.168-2.998c-1.317-0.798-2.178,1.272-3.661,0.986
		c0.206,0.35,0.22,1.321,0.416,1.67c-1.944,0.177-3.477,0.244-5.205,1.567c-0.674-0.572-1.54-0.727-2.463-0.481
		c-0.83,1.435,0.875,4.05,1.95,5.025c0.747,0.678,2.346,0.932,3.249,1.432c1.1,0.609,1.576,1.327,2.513,1.944
		c2.134,1.407,3.363,1.075,3.931,3.75c0.622,2.931,0.006,4.076,3.287,4.856c-0.176,1.115-0.913,2.639,0.032,3.199l-0.598-0.264
		c0.855,0.163,1.415,0.737,1.649,1.982c0.517-0.126,1.347-1.136,1.493-1.162c1.086-0.198,1.529-0.017,2.456-0.05
		c1.878-0.067,2.423,0.093,4.187,0.793c1.794,0.712,8.066,0.472,4.089-2.549c1.027-0.734,4.294-0.123,5.411,0.314
		c1.271,0.497,3.06,3.563,4.106,0.48c0.563-0.131,1.028-0.08,1.383,0.077L497.35,561.629z"
      />
    </a>

    <a (click)="SelectCode('LU')">
      <path
        [class.selected]="IsSelected('LU')"
        id="LU"
        d="
		M543,729.5c0.245-0.657,0.227-1.351,0.712-1.937c-2.083-0.997-0.4-2.229-1.018-3.763c-0.308-0.766-2.392-2.688-3.139-3.118
		c-0.724-0.417-1.5-0.354-2.111-0.682c0.003,0.001-1.875-1.156-1.432-1.014c-0.244-0.079-0.348-0.665-0.725-0.773
		c-0.654-0.186-1.302,0.799-1.813,0.749c-0.902-0.089-1.861-0.896-2.743-0.674c-1.345,0.339-0.747,2.198-3.05,1.786
		c-0.475-0.085-0.815-1.199-1.426-1.274c-0.902-0.11-1.296,0.637-2,0.692c-1.28,0.101-2.211-0.344-3.318-0.061
		c-0.284,0.073-2.878,2.184-3.219,2.574c0.257,0.141,0.553,0.58,0.806,0.744c-0.238,0.793-0.63,1.408-1.275,1.999l0.41,0.211
		c1.28,0.275,2.561,0.545,3.889,0.832c-0.412,1.511,2.436,4.78,3.951,5.267c3.038,0.978,3.593-3.169,6.467-1.255
		c-0.309,0.675,0.026,1.241,0.021,1.925c0.401-0.24,0.933-0.309,1.514-0.252L533.5,731.5c1.284-2.872,2.996-2.455,5.25-2
		c1.325,0.267,2.621,0.155,3.873,0.13L543,729.5z"
      />
    </a>

    <a (click)="SelectCode('M')">
      <path
        [class.selected]="IsSelected('M')"
        id="M"
        d="
		M448.25,586.75c-1.557-0.524-0.78-1.594-1.494-2.506c-0.429-0.547-1.732-1.19-2.025-1.732c-1.356-2.512,1.843-4.007,1.481-6.23
		c-2.517,0.486-9.504,5.794-9.25,0.006c-0.511-0.137-1.451-0.145-1.943,0.013c0.703,1.37-0.561,2.146-1.556,2.949
		c0.708,0.576,1.382,1.304,1.504,2.212c-1.594,0.05-3.084-0.965-4.968-0.962c-1.941,0.003-3.06-0.036-4.523,1.286
		c-0.534-0.182,0.04-0.234,0.023-0.536l0.132,0.398c0.31,0.34,0.621,0.621,0.918,0.802c0.52,0.316,1.871,0.045,2.149,0.601
		c0.329,0.658-0.787,2.005-0.698,2.949l0.118-0.161c0.132,0.094,0.277,0.226,0.442,0.405c0.402,0.438,0.7,2.367,0.89,3.006
		c0.926,3.112,1.897,2.388,5.037,3c2.081,0.405,4.322,0.966,4.776,3.237c0.084,0.42,0.114,0.942,0.111,1.514L439.25,597
		c0.035,0.011,1.162-0.122,1.712-0.294c-0.29-2.709-0.378-4.212,1.538-6.194c0.542-0.56,1.927-2.13,2.75-2.219
		c0.931-0.1,1.811,1.204,2.75,0.954c1.523-0.405,1.032-1.529,0.677-2.639L448.25,586.75z"
      />
    </a>

    <a (click)="SelectCode('ME')">
      <path
        [class.selected]="IsSelected('ME')"
        id="ME"
        d="
		M612.25,772c2.75-0.414-1.255,3.823,1.961,4.293c0.015,2.155-4.829,2.55-5.899,3.756c-0.471,0.531-0.622,0.967-0.564,1.346
		L607.5,781.5c-2.105,0.743-3.749,0.006-5.694,0.744c-0.869,0.33-1.503,0.915-2.55,1.243c-1.169,0.367-2.352,0.92-3.512,1.213
		c-2.942,0.744-4.706,0.004-7.494-0.394c-2.304-0.329-3.947,0.866-5.75-0.543c-0.533-0.417-1.525-1.811-2-2.258
		c-0.961-0.903-1.547-1.031-1.817-2.25c-0.075-0.336,0.222-2.858,0.318-3.31c0.23-1.08,0.349-1.347,0.931-2.264
		c1.832-2.888,5.884-6.433,3.818-9.932l0.062-0.621c4.088-2.121,9.053-2.529,13.418-1.042c0.72,2.396-1.863,5.082-4.285,4.456
		c1.102,2.805,6.326,1.748,6.251-1.265c2.103-0.714,5.34-0.029,7.329,0.804c0.587,0.246,4.435,2.591,4.199,3.18
		c-0.357,0.89-1.202,1.526-2.181,1.782c-0.031,0.323-0.033,0.593-0.006,0.919c1.426,0.072,2.876-0.03,4.337-0.216L612.25,772z"
      />
    </a>

    <a (click)="SelectCode('MK')">
      <path
        [class.selected]="IsSelected('MK')"
        id="MK"
        d="M501,719
		c-1.276-2.314,4.132-3.588,1.539-5.818c0.685-0.693,1.16-2.462,1.762-2.882c0.836-0.583,2.655-0.64,3.658-1.03
		c2.246-0.874,0.459-1.297,2.785-0.008c1.037,0.574,1.774,1.195,2.969,1.463c-0.06-0.598-0.565-1.706-0.487-2.219
		c0.155-1.014,0.992-1.076,0.981-2.212c-0.277-0.138-0.489-0.358-0.68-0.476c0.793-0.61,2.107-1.067,2.723-1.818
		c0.704-0.857-0.039-1.339,0.981-1.993c1.035-0.664,2.02,0.019,3.025-0.5c0.761-0.393,1.435-1.551,1.786-2.219
		c3.295-0.281,3.972-2.328,6.445-4.094c1.086-0.776,2.959-2.029,3.456-3.25c0.487-1.197-0.153-2.427,0.8-3.474
		c1.143,2.103,1.761,1.372,3.739,1.268c2.847-0.15,3.269,0.52,4.211,2.568c0.365,0.792,0.002,1.213,0.606,2.145
		c0.129,0.199,1.053,0.19,1.344,0.545c0.371,0.452,0.116,1.173,0.407,1.504c1.171,1.33,2.672,1.926,2.699,3.751l-0.014-0.09
		c-0.855,0.13-1.466,0.447-1.992,1.59c-0.313,0.68,0.307,1.76-0.045,2.449c-0.24,0.471-1.163,0.595-1.505,0.976
		c-1.006,1.123-1.997,2.247-2.863,3.575c2.027,1.567,0.035,2.95-0.037,4.706c3.643,0.727-1.375,4.057,0.235,6.562
		c-0.116,0.453-0.291,0.034-0.53,0.231l0.556,0.432c-0.724-0.417-1.5-0.354-2.111-0.682c0.003,0.001-1.875-1.156-1.432-1.014
		c-0.244-0.079-0.348-0.665-0.725-0.773c-0.654-0.186-1.302,0.799-1.813,0.749c-0.902-0.089-1.861-0.896-2.743-0.674
		c-1.345,0.339-0.747,2.198-3.05,1.786c-0.475-0.085-0.815-1.199-1.426-1.274c-0.902-0.11-1.296,0.637-2,0.692
		c-1.28,0.101-2.211-0.344-3.318-0.061c-0.284,0.073-2.878,2.184-3.219,2.574c0.257,0.141,0.553,0.58,0.806,0.744
		c-0.238,0.793-0.63,1.408-1.275,1.999l-0.512,0.012c-0.981-0.213-0.139-0.92-1.419-0.698c-0.553,0.096-0.987,1.16-1.57,1.38
		c-2.204,0.831-2.551-0.586-4.222-1.505c-1.405-0.772-2.602-0.458-3.277-0.689l-0.017-0.742c-0.167-0.092-0.524-0.051-1.17,0.204
		c-1.112-1.537-1.001-2.042-2.626-3.149c-0.527-0.359-0.973-0.567-1.392-0.695L501,719z"
      />
    </a>

    <a (click)="SelectCode('ML')">
      <path
        [class.selected]="IsSelected('ML')"
        id="ML"
        d="
		M346.287,402.039c2.626-0.083,3.397,2.204,6.514,1.411c2.749-0.7,2.169-1.387,3.449,0.861c0.635,1.115,0.51,1.952,1.78,2.677
		c-1.479,2.121-2.458,2.901-0.543,5.01c1.679,1.849,2.872,1.285,4.95,0.277c0.662,1.648,2.712,5.366,5.063,4.743
		c3.677-0.974,1.459-5.257,1.995-7.462c1.543-6.352,11.708,1.432,13.148-4.592l0.201-0.951c-0.549-0.423-0.5-0.197-0.649-1.762
		c-0.069-0.723-0.203-2.593,0.105-3.25c0.208-0.441,0.417-0.733,0.639-0.927l0.311,0.677c-0.653-2.06-0.297-4.372-1.001-6.513
		c-0.171-0.52-0.926-0.941-1.023-1.455c-0.122-0.645,0.687-1.218,0.535-1.832c-0.246-0.989-1.159-2.338-1.993-3
		c-2.625-2.085-3.731-1.465-4.018-4.702c-0.293-3.307-0.679-6.938-5.211-3.769c-0.207-1.651-0.779-3.495-1.977-4.799
		c-2.405-2.617-5.142-0.847-8.048,0.742c-0.032-2.173,0.448-2.852,1.222-4.668c1.227-2.878,0.705-2.483-1.75-3.256
		c-2.717-0.855-7.234-3.421-6.775-6.962c-1.955-0.542-2.307,2.092-4.162,0.5c-1.583,1.896-2.134,3.054-4.513,1.995
		c-0.124,0.983-0.767,2.126-0.855,2.954c-0.141,1.315,0.193,1.294,0.312,2.325c0.186,1.606,0.292,3.589,1.231,5.133
		c-1.077,0.848-2.95,1.791-3.505,3.068c-0.241,0.554,0.344,1.887-0.144,2.794c-0.68,1.263-1.968,1.451-2.519,2.949
		c-0.449,1.224,0.073,2.182-0.093,3.456c-1.651-0.211-5.332-1.873-5.463,1.539l0.373,0.278c0.39,0.594,0.23,0.941,0.878,1.922
		c0.439,0.665,1.369,0.829,1.754,1.545c0.293,0.544,0.349,2.163,0.557,2.944c0.733,2.742,0.995,3.024,3.743,1.873
		c2.504-1.049,3.032-2.954,5.694-1.743c1.478,0.673,3.523,1.939,4.531,3.182c-1.455,0.908-0.79,2.683-1.712,4.055
		c-0.769,1.144-2.417,2.087-3.318,3.194L346.287,402.039z"
      />
    </a>

    <a (click)="SelectCode('N')">
      <path
        [class.selected]="IsSelected('N')"
        id="N"
        d="
		M547.178,747.119c0.344,0.105,0.694,0.324,1.266,0.687c1.816,1.152,0.583,1.549,1.105,2.944c0.613,1.637,1.287,1.139,2.518,2.182
		c1.051,0.89,1.681,2.775,2.432,3.318l2.226-0.225c0.392-1.327,1.172-2.732,1.467-4.081c0.343-1.565-0.167-2.895,0.831-4.195
		c-1.567-2.485-9.074-1.441-11.524-0.749"
      />
    </a>

    <a (click)="SelectCode('NE')">
      <path
        [class.selected]="IsSelected('NE')"
        id="NE"
        d="
		M486.269,450.739c-0.309-0.999-0.618-1.999-0.926-2.999c-3.37-10.931-6.739-21.862-10.109-32.793
		c-0.402-1.305-0.809-2.657-0.654-4.014c0.127-1.107,0.62-2.133,0.935-3.201c1.662-5.622-1.753-11.535-5.965-15.613
		c-2.635-2.551-5.644-4.742-8.365-7.191l-0.423,0.659c-0.223,0.597-0.784,1.059-1.077,1.624c-3.051-1.577-1.098,1.486-1.169,1.775
		c-0.218,0.896-2.046,3.014-3.268,3.031c-3.96,0.053-0.487-4.819-5.949-2.301c-1.856-2.234-2.524,0.952-3.539,1.97
		c-1.371,1.376-4.344,1.586-4.474,4.021c-0.048,0.886,0.828,1.837,0.967,2.798c0.126,0.871-0.485,1.544-0.073,2.505
		c0.605,1.412,2.562,1.836,3.348,2.995c-0.827,0.624-2.436,2.673-3.342,2.956c-1.132,0.354-1.955-0.602-2.999-0.218
		c-0.411,0.151-1.396,1.448-1.676,1.806c-0.286,0.366-1.321,0.751-1.475,1.182c-0.251,0.704,0.808,1.557,0.669,2.03
		c-0.989,3.36-3.885,0.945-6.451,1.234c-1.806,0.204-5.376,2.849-6.718,4.054c0.798,2.242-2.396,3.007-3.536,4.395
		c-0.795,0.968-1.486,2.384-2.061,3.501c-0.855,1.658-1.823,3.013-1.257,5.249c0.427,1.69,1.188,2.385,0.918,4.072l0.282,0.31
		c1.28,0.21,1.516,1.549,2.806,1.986c2.947,0.996,8.229-4.295,9.011,1.908c0.296,2.348-0.832,1.838-1.51,3.518
		c-0.671,1.663,0.325,3.335,0.073,5.026c-0.143,0.963-1.155,2.749-1.825,3.424c-1.131,1.141-3.861,0.747-3.649,2.519
		c2.012,0.714,2.636,0.348,4.151,1.774c0.826,0.779,1.265,1.236,2.06,1.769c0.764,0.511,1.11,0.196,1.944,1.002
		c1.597,1.543,2.498,4.48,4.061,6.254c0.906,1.029,1.959,1.786,2.797,2.855l0.335,0.15c1.408-1.746,2.101,0.522,4.612-0.061
		c1.338-0.31,1.792-2.221,3.255-2.161l-0.755,0.211c0.549-1.75,2.566-1.947,3.311-3.494c1.079-2.239-0.606-2.46,2.251-3.262
		c1.418-0.398,2.149-0.332,3.438-1.051c0.975-0.544,1.254-1.109,2.444-1.506c1.828-0.609,3.883-0.324,5.762-0.649
		c0.392,2.547,2.836,3.258,5.244,2.655c0.919-0.23,1.914-1.639,2.787-1.656c1.482-0.029,1.726,1.452,3.526,0.948
		c0.838-0.234,1.47-1.548,2.225-1.497c2.332,0.157,0.941,1.946,1.194,2.692c0.296,0.874-0.67,1.661,1.068,1.586
		c0.923-0.04,2.07-1.9,3-2.298l-0.5,0.531c0.575-0.645,0.894-1.366,0.968-2.201c-1.426-0.294-1.046-1.757,0.026-2.373
		c0.847-0.486,2.157,0.143,2.969,0.285c0.024-0.876,0.049-1.798,0.075-2.673c0.368-0.047,0.836-0.106,1.212-0.038L486.269,450.739z"
      />
    </a>

    <a (click)="SelectCode('NG')">
      <path
        [class.selected]="IsSelected('NG')"
        id="NG"
        d="
		M532.187,651.737c0.949-0.532,2.075-0.123,2.763-0.538c0.898-0.541,1.356-1.999,1.355-2.949c-0.001-1.843-1.254-1.708-1.768-3.45
		c2.4-1.19,0.052-3.379,1.975-4.086c1.823,2.614,2.273,1.12,4.537,0.849c2.083-0.249,3.775,0.98,5.212-1.813
		c0.368-0.715,0.518-2.012,0.745-2.75c0.365-1.187,0.922-1.948,0.999-3.256c0.071-1.208,0.694-4.149,0.282-5.193L548,629.25
		c0.314-0.244,0.54-0.548,0.68-0.911c-1.642-1-5.145-3.636-5.724-5.544c-1.897,0.261-2.778,0.629-4.694,0.456
		c-1.983-0.18-3.173,0.471-5.307,0.751c-2.289,0.3-4.846,0.089-7.205,0.055c-2.267-0.033-3.047-0.133-2.276-2.745
		c-1.722-1.542-1.448-2.06-1.724-4.06c-0.214-1.547,0.032-3.76-1.974-4.049c0.487-3.3,3.592-3.503,5.953-5.206
		c-1.007-2.021-3.527-1.955-5.442-1.782c-0.173-2.188-1.723-1.289-3.024-1.413c-0.845-0.08-1.2,0.102-2.001-0.05
		c-0.768-0.146-1.686-0.746-2.46-0.974c-0.22,1.807-2.796,3.185-4.363,3.71c-1.253,0.42-0.835,0.338-1.988,0.282
		c-1.382-0.066-1.292-2.212-2.976,0.176c-2.026-1.326-1.946-2.096-4.419-2.426c-1.58-0.211-3.139-0.332-4.78-0.218
		c0.727,0.795,0.862,1.673,0.548,2.705c-0.202,0.665-1.125,0.466-1.341,0.982c-0.17,0.407-0.041,1.183-0.232,1.512
		c-0.628,1.079-0.279,1.465-1.507,2.451c-0.67,0.538-1.744,0.706-2.493,1.299l-0.026-0.087c0.097-0.066,0.193-0.13,0.288-0.193
		c0.468,0.427,1.51,3.089,1.438,3.58c-0.222,1.525-1.58,2.222-2.194,3.7c-1.463,3.519-0.744,4.605,1.426,7.7
		c0.996,1.422,2.193,2.444,1.623,4.049c-0.634,1.788-1.553,1.06-1.604,3.25c-0.068,2.96,1.57,5.151,3.799,7.251l0.064,0.204
		c0.521-0.487,0.812-1.11,0.724-1.916c2.058,0.361,1.634-1.569,2.513-1.749c2.232-0.458,1.531,1.237,2.255,2.156
		c2.246,2.848,5.302,0.63,8.657-0.487c-0.602-2.807,3.006-2.273,4.769-2.694c1.342-0.321,1.458-1.757,2.719-0.269
		c0.605,0.714,0.334,2.186,0.075,2.95c0.715,0.649,1.873,1.458,2.78,1.499c1.129,0.051,1.876-1.257,2.938-1.267
		c4.106-0.04,0.128,4.42,0.79,6.086c1.28,3.219,6.634,1.446,9.105,3.565L532.187,651.737z"
      />
    </a>

    <a (click)="SelectCode('NN')">
      <path
        [class.selected]="IsSelected('NN')"
        id="NN"
        d="
		M532.5,689.5c-0.017-0.414,0.312-0.983,0.288-1.462c0.948,0.042,1.701,0.2,2.674,0.174c-0.129-0.614,0.131-1.509,0.052-1.949
		c-0.072-0.402-0.825-1.667-0.823-1.694c0.075-1.614-0.022-1.079,1.574-2.318c2.652-2.06,1.165-2.552-1.446-3.568
		c-2.677-1.042-4.147-0.307-5.067-3.432c-0.122-0.413-0.553-2.386-0.512-2.706c0.109-0.852,0.803-0.891,1.01-1.799
		c0.257-1.13,1.536-2.159-0.73-2.55c0.958-0.842,2.425-1.497,2.692-2.9c-1.483-1.039-3.069,0.79-4.28-0.762
		c-2.386,1.85-4.387,4.518-6.138,7.176c-1.674,2.541-2.672,2.961-6.007,3.58c0.213,4.438-8.913,6.966-10.268,2.544
		c-0.881,0.861-2.932,0.812-4.013,1.232c-2.514,0.977-1.812,1.558-2.438,3.505c-0.207,0.644-1.294,1.148-1.336,1.932
		c-0.06,1.095,0.866,0.95,0.969,1.563c0.233,1.383,0.155,2.661-0.257,4.155c-1.09-0.7-2.634-1.709-3.656-0.15
		c1.133,1.413,1.058,4.364-1.501,3.645c-0.15-1.037-2.017-2.638-3.005-1.481c-0.871,1.021,1.482,2.8,1.725,3.206
		c0.699,1.169,1.803,0.63,0.505,2.561c-0.902,1.343-2.776,1.328-3.512,3.001l-0.043-0.206c0.842,1.322,2.417,1.692,2.593,3.424
		c0.701-0.437,1.558-1.785,2.448-1.902c1.583-0.207,0.702,0.4,1.5,1.185c0.376,0.37,0.076,1.053,0.684,1.56
		c0.705,0.589,1.612-0.525,2.391,0.372c2.798,3.224-3.236,5.303-5.048,5.867c1.968,1.406,1.683,1.933,1.786,4.012
		c0.108,2.202,0.166,2.533,3.006,3.132c1.103,0.233,1.855,0.156,2.728,0.424L501,719c-1.276-2.314,4.132-3.588,1.539-5.818
		c0.685-0.693,1.16-2.462,1.762-2.882c0.836-0.583,2.655-0.64,3.658-1.03c2.246-0.874,0.459-1.297,2.785-0.008
		c1.037,0.574,1.774,1.195,2.969,1.463c-0.06-0.598-0.565-1.706-0.487-2.219c0.155-1.014,0.992-1.076,0.981-2.212
		c-0.277-0.138-0.489-0.358-0.68-0.476c0.793-0.61,2.107-1.067,2.723-1.818c0.704-0.857-0.039-1.339,0.981-1.993
		c1.035-0.664,2.02,0.019,3.025-0.5c0.761-0.393,1.435-1.551,1.786-2.219c3.295-0.281,3.972-2.328,6.445-4.094
		c1.086-0.776,2.959-2.029,3.456-3.25c0.487-1.197-0.153-2.427,0.8-3.474L532.5,689.5z"
      />
    </a>

    <a (click)="SelectCode('NP')">
      <path
        [class.selected]="IsSelected('NP')"
        id="NP"
        d="
		M419,730.75c-1.3-4.481-4.542-2.864-7.749-4.938c-1.365-0.883-1.416-3.011-3.002-3.586c-1.343-0.486-4.702,1.016-5.698,1.748
		c-2.459-1.589-3.6-4.923-6.001-6.717c-1.125-0.84-1.653-2.266-2.792-0.707c-1.084,1.483,0.763,3.108,0.048,4.505
		c-0.953,1.862-1.978,0.162-3.56,0.69c-1.765,0.589-1.311,1.706-2.182,3.255c-0.841,1.495-2.004,1.062-2.761,2.052
		c-0.766,1.001-0.766,2.702-1.801,3.949l0.004,0.632c0.271,1.359,0.451,2.696,0.802,3.563c0.695,1.715,1.625,3.336,2.699,4.818
		c1.411,1.946,1.769,2.29,2.05,4.475c0.218,1.697,0.667,4.1,2.258,5.206c0.818,0.569,4.703,0.772,2.212,2.807
		c1.573,1.032,5.026,2.102,4.724,4.5l-0.083-0.224c0.571-0.211,1.152-0.384,1.729-0.517c3.532-0.813,7.286-0.687,10.662-2.007
		c5.023-1.965,8.329-6.723,11.889-10.964L422,743.25c-1.341-0.975-3.763-1.649-4.255-3.5c-0.357-1.345,0.6-1.96,0.753-3.513
		c0.111-1.124-0.514-2.296-0.498-3.486c0.018-1.394-0.075-1.651,0.408-2.17L419,730.75z"
      />
    </a>

    <a (click)="SelectCode('NR')">
      <path
        [class.selected]="IsSelected('NR')"
        id="NR"
        d="
		M650.786,684.745c-0.137,0.001-0.274,0.001-0.411,0.002c-0.952,0.002-1.911-0.006-2.849,0.04c0.133,0.197,0.284,0.55,0.437,0.782
		c-0.615,0.96-1.66,1.172-2.414,2.157c-0.29-1.121-1.309-1.34-2.086-2.231c0.237-0.154,0.568-0.595,0.812-0.745
		c-0.628-2.145-3.154-2.274-5.025-2.805c-1.853-0.526-3.239-2.667-5.225-2.238c-0.333-1.174-0.649-3.437-2.012-4.023
		c-1.071-0.46-1.741,0.692-2.763,0.768c-0.95,0.07-1.279-0.214-1.932-0.264c-1.121-0.086-0.97-1.427-2.086,0.064
		c-0.472,0.63,0.587,1.639-0.039,2.443c-1.395,1.791-2.371-0.138-3.443-0.968c-2.466,1.936-2.272-2.26-4.468-1.932
		c1.609,5.758-3.13,2.781-6.221,3.493c-0.92,0.212-1.33,1.644-2.574,1.474c-0.663-0.09-1.335-1.226-1.931-1.586
		c-1.21-0.733-3.534-0.975-3.518-2.637c1.499-0.052,4.653-0.496,4.973-2.039c0.448-2.157-1.902-2.663-3.479-2.537
		c0.338-1.527,2.403-2.508,3.149-4.031c0.22-0.449,0.638-1.13,0.762-1.419c0.153-0.357-0.526-1.209,0.099-1.969
		c1.448,0.121,3.322,0.582,3.456-1.294c0.042-0.586-1.468-3.267-1.736-3.5c-1.317-1.143-5.787-3.255-7.013-0.75l-0.236-0.322
		c-0.305-0.601-1.079-1.253-0.714-2.184c0.583-1.485,2.817-0.614,3.737-1.98c-2.214-1.64,1.749-5.044-1.982-6.574
		c-1.264-0.519-4.312,0.135-6.267,0.023c-0.384-1.305,3.131-4.146,4.248-4.705c-0.925-1.364-2.562-0.56-3.56-1.507
		c0.697-0.716,2.033-1.101,1.973-2.194c-0.114-2.04-3.217-1.1-2.209-3.318c0.515-1.133,3.698-1.38,3.967-1.975
		c0.58-1.282-1.315-2.362-0.956-3.012l-0.001-0.407c4.917,0.382,9.834,0.764,14.751,1.146c12.374,0.961,24.099,8.574,32.326,17.868
		c1.23,1.39,2.427,2.846,3.191,4.537c1.013,2.241,1.207,4.752,1.387,7.204c0.495,6.744,0.975,13.649-0.852,20.159
		c-0.2,0.713-0.427,1.418-0.674,2.118L650.786,684.745z"
      />
    </a>

    <a (click)="SelectCode('NW')">
      <path
        [class.selected]="IsSelected('NW')"
        id="NW"
        d="
		M554.5,756.25c-0.752-0.543-1.381-2.429-2.432-3.318c-1.231-1.042-1.905-0.544-2.518-2.182c-0.522-1.396,0.71-1.792-1.105-2.944
		c-0.53-0.336-0.87-0.549-1.19-0.662l-0.28,1.369c-0.774,1.441-1.11,2.081-1.043,3.736c0.061,1.499,1.16,2.525-0.182,3.751
		l-0.082,0.241c1.895,0.26,4.359,0.004,5.935,0.558c0,0,1.838-0.511,2.084-0.603L554.5,756.25z"
      />
    </a>

    <a (click)="SelectCode('OL')">
      <path
        [class.selected]="IsSelected('OL')"
        id="OL"
        d="
		M448.642,586.497c-0.208-0.674-0.339-1.333,0.09-1.815c0.75-0.842,5.409-1.931,6.267-1.931c0.78-0.001,1.198,0.691,2.238,0.573
		c0.478-0.055,0.904-0.235,1.326-0.447l-0.063-0.127c-0.504-1.117-0.557-2.367-1.063-3.487c-0.74-1.64-1.985-2.439-2.936-3.825
		c-1.096-1.597-0.677-2.607-1.306-4.437c-0.408-1.186-1.408-2.042-1.688-3.252c-0.322-1.391,0.62-3.059,0.241-4.248
		c-0.628-1.973-1.774-0.584-3.198-1.552c-1.125-0.765-0.019-2.383-2.239-1.888c-1.578,0.352-1.356,1.617-2.311,2.724
		c-1.328-2.619-2.643,0.759-2.737,2.214c-0.1,1.542,1.797,4.016-0.513,4.75l0.224-0.207c-1.148,0.889-1.487,2.016-0.681,3.414
		c0.8,0.153,0.914,0.597,1.419,0.981c-1.832,1.02-1.462,2.976-1.462,4.313l0.109,0.448c2.069-0.633,4.555-2.165,5.853-2.416
		c0.362,2.223-2.836,3.718-1.481,6.23c0.293,0.542,1.595,1.185,2.025,1.732c0.715,0.912-0.063,1.981,1.494,2.506L448.642,586.497z"
      />
    </a>

    <a (click)="SelectCode('OX')">
      <path
        [class.selected]="IsSelected('OX')"
        id="OX"
        d="
		M475.5,718.5c0.142-2.619,4.508-3.774,4.448-6.725c-1.141,0.591-2.323,1.75-3.661,1.687c-0.184-1.172,0.4-3.612,1.158-4.462
		c1.658-1.863,0.645,0.377,2.754,0.718c0.756-2.125,1.02-3.932,2.819-4.987c1.585-0.929,4.903-1.304,3.819-4.193
		c0.558-0.066,1.566,0.061,2.12,0.255c0.842,1.322,2.417,1.692,2.593,3.424c0.701-0.437,1.558-1.785,2.448-1.902
		c1.583-0.207,0.702,0.4,1.5,1.185c0.376,0.37,0.076,1.053,0.684,1.56c0.705,0.589,1.612-0.525,2.391,0.372
		c2.798,3.224-3.236,5.303-5.048,5.867c1.968,1.406,1.683,1.933,1.786,4.012c0.108,2.202,0.166,2.533,3.006,3.132
		c1.632,0.344,2.496,0.012,4.12,1.119c1.625,1.108,1.514,1.613,2.626,3.149c2.582-1.018,0.554,1.372,0.187,2.088
		c-0.74,1.445-1.232,3.065-1.794,4.662c-2.009-0.458-1.692,0.7-2.151,2.051c-0.176,0.518-0.067,1.061-0.251,1.542
		c-0.081,0.211-1.25,1.448-1.266,1.245c0.095,1.199,3.584,3.368,5.211,3.206c3.652-0.364,3.403-2.539,6.188,0.556
		c1.743,1.937,3.828,3.164,2.018,5.895c-2.724-0.123-4.522,1.006-2.956,3.544l-0.044-0.455c-0.156,0.282-0.199,0.794-0.72,1.205
		c-1.062,0.837-0.222,1.205-2.041,1.018c-0.971-0.1-1.28-1.435-2.92-0.967c0.949,1.495,0.68,3.431-1.249,3.998
		c0.558,0.932,1.64,1.042,1.686,2.164c-0.776,0.213-1.646,0.528-2.461,0.535c-0.773,0.007-1.399-0.812-1.999-0.779
		c-0.746,0.042-0.872,0.977-1.495,1.049c-0.653,0.077-1.346-0.074-2.006-0.019c-1.34,0.112-3.622,0.965-4.761,0.761
		c-1.648-0.296-1.277-2.197-3.438-1.211c-1.138,0.52-1.678,2.668-3.232,3.018c-2.095,0.472-1.072-0.067-2.494-1.13
		c-2.086-1.559-4.274-2.128-6.824-2.939l-0.06-0.099c0.282-0.171,0.554-0.36,0.802-0.596c0.9-0.856,1.007-1.914,1.698-2.962
		c3.21,1.025,3.079-1.626,3.299-3.649c0.328-3.023,1.398-3.376-1.733-4.507c-2.966-1.071-3.246-0.124-6.006,0.312h-0.5
		c-0.919-1.812,0.915-2.882,0.194-4.518c-0.663-1.503-3.266-2.011-4.125-0.77c-1.946-0.948-0.117-3.465-2.786-3.513
		c0.188-0.589,0.17-1.937,0.462-2.455c0.404-0.717,1.36-0.952,1.775-1.563c1.392-2.052-0.156-2.49,0.032-4.907
		c2.121,1.618,3.056-1.737,4-3.025c0.878-1.198,1.987-2.477,2.159-3.486L475.5,718.5z"
      />
    </a>

    <a (click)="SelectCode('PA')">
      <path
        [class.selected]="IsSelected('PA')"
        id="PA"
        d="
		M192.5,302.25c2.273-0.874,4.56-1.952,6.751-2.181c0.783-0.082,2.963-0.92,3.197,1.236c0.275,2.529-2.23,1.185-3.003,1.74
		c-1.167,0.837-0.992,2.929-2.445,3.686c-1.812,0.944-2.522-1.333-3.512,1.216c-0.507,1.305,0.945,3-1.481,3.057
		c-1.477,0.035-1.489-1.805-3.206-1.042c-0.631-0.896-1.456-5.219-1.012-6.175c0.765-1.65,4.05-2.562,5.461-1.537 M203.5,296.25
		c-2.693,3.62,5.149,1.26,6.617,0.244c0.674-0.466,1.267-0.646,1.889-1.238c0.653-0.622,0.254-1.476,1.02-1.975
		c1.348-0.879,1.695,0.682,2.91-1.361c0.409-0.689,0.667-2.324,0.753-3.161c0.258-2.515,0.254-3.029-2.48-1.521
		c-1.638,0.903-2.951,2.224-4.403,3.344c-1.951,1.505-5.466,4.186-6.556,6.419 M222.25,320.25c-1.478,0.074-1.913,2.101-1.762,3.444
		c0.28,2.494,1.56,2.267,3.579,3.056c1.061,0.414,2.269,1.273,3.432,0.755c0.756-0.337,0.351-1.568,0.969-1.954
		c0.813-0.507,1.885-0.254,2.781-0.301c2.848-0.148,6.302,0.102,8.731-1.245c1.385-0.767,6.869-5.641,7.982-3.823
		c-0.637,0.824-1.299,1.764-1.435,2.781c1.65,0.132,3.15-0.264,4.647-0.943c0.874-0.396,4.815-2.352,5.136-3.201
		c1.124-2.967-3.08-1.203-4.509-0.58c-0.11-1.049,2.389-3.246,3.198-4.268c0.698,1.116,1.008,3.465,2.999,2.229
		c1.814-1.126,0.127-3.47,0.289-5.161c0.356,0.119,0.773,0.026,1.149,0.187c1.475-2.394-1.666-1.932-2.686-2.525
		c-0.961-0.559-0.951-1.426-1.738-1.956c-0.899-0.606-1.833-0.552-2.706-1.044c-0.898-0.507-1.577-1.208-2.361-1.504
		c-0.726-0.274-1.865-0.471-2.682-0.758c-1.921-0.674-3.405-1.225-4.763-2.743c-2.366-2.646-2.581-6.814-5.994-8.437
		c-1.506-0.716-4.043-1.458-5.506-1.194c-1.849,0.333-3.807,1.676-2.531,3.393c-1.267-0.199-2.295-0.287-3.525,0.238
		c-2.257,0.964-0.923,0.503-1.263,2.368c-0.102,0.56,0.434,0.592,0.081,1.494c-0.214,0.548-1.347,0.807-1.505,1.245
		c-0.728,2.016,0.667,1.933,2.444,2.442c1.157,0.331,2.68,0.347,3.793,0.751c1.756,0.639,2.096,1.501,3.45,2.769
		c2.967,2.776,5.258,0.102,9.017,0.525c0.098,1.585-2.846,2.682-4.212,3.149c-2.521,0.862-2.882,1.012-4.555,3.008
		c-0.767,0.915-4.183,3.574-3.65,5.004c0.691,1.856,3.757,0.727,4.774,0.224c1.599-0.79,2.81-2.112,4.676-2.173
		c3.492-0.113,2.469,1.456,0.519,2.737c-2.042,1.341-4.09,2.035-6.5,2.255c-1.587,0.145-5.075-0.794-5.056,1.464
		c-1.721,0.721-3.344-4.06-4.957-0.956 M218.527,319.346c-0.984-0.293-1.027,0.987-1.469,1.457c-0.78,0.829-2.171,3.269-0.387,3.516
		c1.469,0.204,4.041-3.745,2.278-4.781C218.792,319.445,218.652,319.383,218.527,319.346z M224,305.5
		c-2.037,1.981,7.689,4.766,8.216,3.262c-0.098,0.278-3.449-3.332-3.948-3.585c-1.346-0.685-3.683,0.1-4.268,1.073 M229.5,342.75
		c-1.967,0.857-3.152,3.232-3.263,5.25c-0.066,1.212-0.148,4.44,0.757,5.286c0.769-0.806,1.668-1.658,2.048-2.748
		c2.903,0.178,2.021-3.914,2.964-5.789c0.446-0.888,1.925-2.609,1.317-3.569c-1.093-1.726-2.552,0.411-2.867,1.531
		c-0.395-0.092-0.992,0.143-1.4,0.057c-0.116,0.238-0.218,0.481-0.307,0.731 M255,332.25c-0.131,1.214-0.106,1.672-0.299,2.738
		c-0.231,1.275-1.945,3.039,0.806,3.28c1.708,0.149,2.58-1.635,2.442-2.962c-0.056-0.54-1.041-1.189-1.217-1.806
		c-0.073-0.257,0.422-1.653,0.479-1.962c-1.465-0.334-4.061,0.908-1.961,1.962 M252.75,329.5c-1.332,0.252-2.788,1.324-2.968,2.698
		C251.75,332.834,255.52,328.975,252.75,329.5z M253,341.25c-2.357,1.44-4.483,3.116-6.501,5.007
		c-1.609,1.508-4.191,3.496-5.511,5.23c-1.373,1.803-1.237,3.875,0.999,4.776c1.995,0.804,3.977-1.745,5.549-0.269
		c-2.27,2.503-5.997,0.925-8.592,2.188c-2.907,1.414-3.416,5.005-3.432,7.818c-0.019,3.456,1.207,6.446,5.292,6.501
		c2.698,0.036,2.446-0.504,2.946-3.264c0.23-1.272,0.384-4.946,2.436-4.025c2.417-4.685,3.347-10.224,6.363-14.936
		c1.484-2.319,3.871-5.268,4.207-8.026c0.64-5.248-3.33-0.641-5.006-0.25 M230.25,360.5c0.439-0.029,0.72-0.208,0.844-0.536
		c-3.166,0.014-4.261,5.378-7.324,4.507c0.097,1.522-0.176,4.485-1.226,5.522c-0.107-2.009,0.267-3.991,0.169-5.954
		c-2.191-0.623-1.91,1.822-3.482,2.356c-1.163,0.394-1.52-0.235-2.693-0.606c-0.359,1.125-0.102,2.244-0.287,3.449
		c-0.284,1.85-1.066,2.454-2.162,3.963c3.333,1.456,0.941,3.898-0.1,6.063c0.061-0.127-0.301,1.393-0.307,1.431
		c-0.09,0.492-0.988,0.274-0.955,1.056c0.035,0.823,1.57,1.931,2.012,2.536c3.183-1.758,3.949-4.116,5.705-7.056
		c1.832-3.065,2.271-3.614,6.019-3.693c0.591,2.646-2.022,2.234-3.211,3.713c-1.915,2.381,1.588,2.294,2.755,4.449
		c0.559,1.033,1.201,2.08,0.494,3.305c-0.545,0.945-1.018,0.305-1.737,0.996c-0.905,0.87-2.975,3.868-2.474,5.448
		c0.973,3.068,4.037,1.02,5.21-0.386c1.653-1.981,2.077-2.499,4.744-3.044c2.331-0.477,3.522-0.918,5.182-2.52
		c2.137-2.062,1.456-2.572,1.075-5.249c-0.399-2.81-0.549-3.741-2.074-6.194c-1.074-1.727-1.823-3.424-2.419-5.306
		c-0.811-2.564,0.704-12.307-3.507-8.75 M254.25,379.5c0.143,2.327-2.036,3.042-2.431,5.001c-0.384,1.904,1.012,2.303,1.223,4.205
		c1.672-0.075,1.349-1.911,1.714-3.217c0.324-1.156,1.223-2.173,1.555-3.221c1.123-3.544-1.635-4.205-2.812-0.268 M283.25,362.75
		c0.813,1.823,2.081,4.048,2.561,6c0.514,2.087,0.189,3.243,1.619,5.069c1.084,1.383,2.312,2.813,3.381,4.119
		c2.036,2.489,2.172,1.866,2.646-1.255c0.064-0.425-0.321-0.803-0.225-1.238c0.111-0.505,1.154-1.039,1.236-1.763
		c0.127-1.109-1.047-2.08-1.4-2.988c-0.263-0.676-0.398-2.228-0.814-2.698c-0.659-0.747-1.703-0.636-2.566-1.189
		c-1.384-0.888-2.201-2.405-3.439-3.556c-1.701-1.582-4.562-1.436-2.5,1.25 M248.704,290.103c-2.557,0.947-6.267-2.185-7.971,0.033
		c1.595,5.157,4.376,11.296,9.766,11.584c1.539,0.082,3.238-0.335,4.521,0.52c0.813,0.542,1.299,1.518,2.185,1.931
		c1.584,0.739,3.287-0.678,4.461-1.973c1.627-1.793,3.255-3.587,4.882-5.38l-0.63-0.342c-1.234-0.566-2.851-0.67-3.631-1.456
		c-0.399-0.402-0.013-1.717-0.47-2.331c-0.345-0.463-2.045-1.129-2.568-1.383c-2.425-1.177-7.463-1.972-9.75-1.556L248.704,290.103z
		 M313.981,303.155c-0.04-1.061-0.115-2.171,0.075-3.168c0.185-0.974,1.052-1.967,0.943-2.986c-0.142-1.318-3.029-5.1-4.248-5.255
		c-2.091-0.266-5.694,4.236-8,4.759c-1.007,0.229-2.35-0.389-3.255,0.234c-0.877,0.604-0.684,2.383-1.601,3.204
		c-1.205,1.079-6.714,1.941-8.148,1.019c-1.857-1.194-0.716-4.77-1.558-6.461c-0.882-1.77-2.774-1.605-4.132-3.001
		c-0.569-0.584-0.794-1.276-1.117-1.994c-0.181-0.402-0.544-2.658-0.439-1.756l-0.334-0.534c-3.28-0.023-6.559,1.591-8.482,4.259
		c1.325,3.666-2.016,7.276-5.212,9.508c-3.196,2.232-6.988,4.857-7.011,8.755c3.47-5.196,9.606-8.502,15.854-8.543
		c0.846,2.033-2.331,3.156-4.532,3.218c-2.201,0.062-5.162,2.115-3.625,3.691c1.045-1.43,3.841-0.399,3.708,1.367
		c-0.465,1.16-2.142,0.922-3.343,1.268c-1.201,0.347-1.038,2.848-0.031,2.106c-1.191,1.362-3.506,1.529-4.881,0.352
		c-1.398,0.081-2.591,1.44-2.491,2.837c0.1,1.397,1.475,2.571,2.87,2.452c-1.585,1.856-3.609,3.891-6.027,3.565
		c0.012,4.416,0.023,8.832,0.035,13.249c1.237-3.03,2.474-6.059,3.71-9.089c-0.47,1.849-0.009,4.766,1.856,4.364
		c-2.08,2.429-3.174,5.679-2.985,8.871c0.725-0.167,1.451-0.334,2.176-0.501c0.158,1.929,0.317,3.858,0.475,5.788
		c-1.82-1.853-4.505,1.16-5.309,3.63c-1.247,3.833-2.495,7.667-3.742,11.5c2.152-2.262,4.303-4.523,6.455-6.784
		c-2.053,3.245-3.407,6.93-3.943,10.733c1.555-1.528,3.111-3.055,4.666-4.583c-3.524,4.659-4.089,11.369-1.394,16.551
		c2.378-2.516,5.146-5.214,8.607-5.279c-8.674,5.011-14.037,15.243-13.222,25.227c0.187,2.291,0.659,4.674-0.135,6.831
		c-0.604,1.641-1.869,2.934-2.874,4.366c-3.035,4.325-3.626,10.252-1.506,15.091c4.184-1.297,8.108-3.428,11.474-6.232
		c1.264-1.053,2.562-2.563,2.119-4.147c-0.263-0.939-1.086-1.616-1.478-2.508c-0.809-1.84,0.382-3.881,1.352-5.641
		c2.06-3.736,3.279-7.932,3.543-12.19c0.217-3.507-0.194-7.116,0.851-10.471c1.045-3.355,4.218-6.451,7.676-5.824
		c-4.754-6.839-7.461-15.082-7.687-23.408c1.885,1.288,4.257-0.679,5.677-2.467c5.063-6.372,10.126-12.744,15.189-19.116
		c2.408-2.115,5.7-3.19,8.891-2.902c-10.033,7.231-18.838,15.983-24.704,26.871c0.683,2.593,1.366,5.187,2.049,7.78
		c0.884,3.358,2.631,7.436,6.103,7.485c-1.496-4.288-1.636-9.038-0.395-13.406c1.463,3.318,3.962,6.17,7.059,8.055
		c0.464-2.484-0.175-5.154-1.714-7.158c2.095-0.568,3.254,2.338,3.466,4.498c0.211,2.161,1.482,5.052,3.546,4.379
		c4.176-1.633,5.118-8.239,1.566-10.975c1.089,0.661,2.655,0.365,3.428-0.648c-2.697-2.567-2.649-7.446,0.098-9.959l-0.192,0.719
		c-0.186-0.738,1.078-4.944,1.481-5.7c0.588-1.102,1.806-0.398,1.787-2.3c-0.007-0.681-1.081-2.193-1.275-3
		c-0.182-0.762-0.485-2.205-0.244-3c0.477-1.572,1.174-0.642,1.769-1.538c1.129-1.701,1.221-4.534,0.723-6.461
		c-0.271-1.051-1.382-2.004-1.248-3.251c0.223-2.071,0.558-1.1,2.019-1.737l-0.013-0.263c0.175-1.347-1.943-3.472-2-5.486
		c-0.023-0.798-0.081-2.818,0.195-3.508c0.692-1.729,0.278-1.076,2.305-0.574c3.019,0.747,4.328,0.356,7.494-0.194
		c3.83-0.665,2.439-1.283,1.257-4.449"
      />
    </a>

    <a (click)="SelectCode('PE')">
      <path
        [class.selected]="IsSelected('PE')"
        id="PE"
        d="
		M532.743,688.469c1.143,2.103,1.761,1.372,3.739,1.268c2.847-0.15,3.269,0.52,4.211,2.568c0.365,0.792,0.002,1.213,0.606,2.145
		c0.129,0.199,1.053,0.19,1.344,0.545c0.371,0.452,0.116,1.173,0.407,1.504c1.171,1.33,2.672,1.926,2.699,3.751l-0.014-0.09
		c0.495-0.075,1.073-0.088,1.763-0.161c1.605-0.17,3.175-1.343,4.708-1.293c0.316-0.729,0.796-1.049,1.496-0.824L554,698
		c0.019-2.762-2.309-3.963-1.962-6.706c1.452-0.561,1.986,0.872,3.219,0.725c1.32-0.157,1.977-2,2.742-2.519
		c0.841-0.57,2.218-0.532,3.213-1.245c0.841-0.603-0.15-3.002,2.3-1.78c0.473-0.634,0.193-3.434,0.013-4.212
		c-0.558-2.418-1.217-1.575,0.225-3.269c-0.289,0.34,1.896-1.176,1.426-1.055c0.811-0.21,1.697,0.235,2.58,0.073
		c1.458-0.269,3.13-1.226,2.269-2.968c1.612-0.381,2.619-1.692,2.757-3.252c2.029-0.852,8.676-2.665,6.743,1.352
		c0.096,0.029,1.947,0.723,1.924,0.656c0.085,0.257-0.057,1.422-0.144,1.256c0.451,0.867-0.24,2.396,1.907,1.226L583,676.5
		c-0.079-0.976,1.487-1.023,2.468-1.557c-1.22-1.578-2.171-1.673-1.46-3.693c0.22-0.624,1.827-3.758,2.23-4.011
		c0.568-0.357,1.652,0.586,2.306,0.467c1.367-0.248,1.978-1.485,3.151-1.912c1.624-0.592,3.694,0.28,4.098-1.999
		c1.091,0.167,3.486,0.909,4.525,0.279c1.455-0.882,1.066-2.897-0.048-3.755c0.397-0.365,1.169-0.708,1.686-0.788
		c0.029,0.025,0.25,0.465,0.281,0.507c2.267-1.142-0.575-1.917,0.063-3.543c0.583-1.485,2.817-0.614,3.737-1.98
		c-2.214-1.64,1.749-5.044-1.982-6.574c-1.264-0.519-4.312,0.135-6.267,0.023c-0.384-1.305,3.131-4.146,4.248-4.705
		c-0.925-1.364-2.562-0.56-3.56-1.507c0.697-0.716,2.033-1.101,1.973-2.194c-0.114-2.04-3.217-1.1-2.209-3.318
		c0.515-1.133,3.698-1.38,3.967-1.975c0.58-1.282-1.315-2.362-0.956-3.012l-0.001-0.407c-3.713-0.289-7.55-0.562-11.07,0.652
		c-3.521,1.214-6.667,4.329-6.703,8.054c-0.01,1.024,0.198,2.117-0.276,3.024c-1.04,1.989-4.959,3.082-3.637,4.895
		c-2.503-1.333-5.343-2.029-8.179-2.006c-0.581-4.546-5.463-8.05-9.955-7.146c1.508-5.422,4.972-10.276,9.609-13.465
		c2.016-1.386,4.287-2.506,5.833-4.403c3.529-4.329,1.994-10.71,0.285-16.027L576.5,605c-0.245,0.007-1.207,0.393-1.711,0.812
		c1.084,1.146-0.251,1.432-0.343,2.439c-0.086,0.944,0.211,2.274,0.017,3.461c-1.748,0.247-0.968-0.96-1.97-1.468
		c-0.964-0.489-1.754-0.232-2.742-0.55c-2.117-0.681-2.874-2.332-5.268-0.72c-0.321-1.84-2.113-3.601-3.5-1.523
		c-1.161,1.739,0.497,2.835-1.732,4.048c-0.656,0.357-1.669,0.071-2.444,0.489c-0.937,0.505-1.735,2.043-2.556,2.781
		c-1.726,1.551-2.61,1.61-1.5,3.726c0.885,1.686,2.559,1.566,3.243,3.263c1.044,2.584-0.633,1.381-2.061,2.682
		c-1.009,0.919-0.682,3.023-2.883,2.012c-0.625-0.287-1.388-4.132-2.95-1.006c0.668,0.799,1.024,1.751,1.119,2.769
		c-0.405,0.047-0.612,0.261-0.931,0.338c0.412,1.044-0.211,3.985-0.282,5.193c-0.077,1.307-0.634,2.069-0.999,3.256
		c-0.227,0.738-0.377,2.035-0.745,2.75c-1.438,2.793-3.13,1.564-5.212,1.813c-2.264,0.271-2.714,1.764-4.537-0.849
		c-1.923,0.707,0.425,2.896-1.975,4.086c0.514,1.742,1.767,1.607,1.768,3.45c0.001,0.95-0.457,2.408-1.355,2.949
		c-0.688,0.414-1.814,0.006-2.763,0.538c-1.126,0.631-0.761,2.491-2.655,1.538c-0.035,1.385-0.375,1.938-0.045,2.975
		c0.345,1.083,2.005,0.89,1.225,2.712c-2.256-0.309-2.215,0.49-1.962,2.025c0.133,0.808,0.941,4.527,0.75,4.263l-0.007-0.075
		c0.872-0.083,1.815-0.515,2.719,0.118c-0.267,1.403-1.734,2.058-2.692,2.9c2.266,0.391,0.987,1.42,0.73,2.55
		c-0.206,0.909-0.901,0.948-1.01,1.799c-0.041,0.32,0.39,2.294,0.512,2.706c0.92,3.126,2.39,2.391,5.067,3.432
		c2.611,1.016,4.098,1.508,1.446,3.568c-1.596,1.24-1.499,0.705-1.574,2.318c-0.001,0.027,0.751,1.292,0.823,1.694
		c0.079,0.441-0.18,1.335-0.052,1.949c-0.972,0.025-1.725-0.133-2.674-0.174c0.024,0.479-0.305,1.049-0.288,1.462"
      />
    </a>

    <a (click)="SelectCode('PH')">
      <path
        [class.selected]="IsSelected('PH')"
        id="PH"
        d="
		M227,242.25c-0.327,0.051-0.492,0.222-0.494,0.512c0.854,0.684,1.899,0.673,2.957,0.451c0.134-0.136,0.019-0.494,0.074-0.676
		c0.253-0.005,0.689,0.035,0.92-0.08c1.515-2.716-3.262-1.377-3.956,0.544 M231.75,262.75c-0.009,0.904,0.008,1.821-0.039,2.712
		c-0.599-0.151-1.365,0.077-1.904-0.18c-0.405,1.194,0.849,3.121,1.997,3.718c2.313,1.203,1.447-0.051,1.884-2
		c0.301-1.345,1.878-3.415,0.823-4.708c-1.527-1.87-2.787,0.73-2.761,2.208 M225.25,271.5c0.169,0.339,0.713,0.795,0.538,1.712
		c7.76,1.483-0.662-4.301-0.538-0.712 M224,263.75c0.069-0.355,6.57-8.25,2.789-8.038c1.798-4.559-7.878-6.269-9.857-1.456
		c-1.092,2.655,1.276,3.15,3.007,5.245c1.249,1.512,2.727,5.882,5.061,3.749 M214.5,250.25c-3.057-2.049-9.232,2.203-4.55,2.444
		c0.785,0.04,1.58-0.706,2.3-0.65c0.767,0.06,1.252,1.217,2.249,0.961c2.15-0.552,0.463-2.267-0.749-3.005 M283.375,287.3
		c-1.401-1.45-0.493-3.839,0.479-5.605c1.839-3.344,3.679-6.688,5.518-10.032c-7.608,8.385-15.215,16.769-22.823,25.154L266.75,297
		c-1.21-1.082-3.488-1-4.462-1.981c-0.399-0.402-0.013-1.717-0.47-2.331c-0.345-0.463-2.045-1.129-2.568-1.383
		c-2.425-1.177-7.463-1.972-9.75-1.556l0.153-0.255c0.536-0.508,0.945-1.175,1.519-1.652c3.428-2.853,9.917,2.375,12.643-1.155
		c-9.156-0.181-18.328,0.392-27.39,1.713c-1.95-2.586-5.642-4.053-8.846-4.532c-1.256-2.939,2.781-5.324,5.967-5.578
		c4.112-0.328,8.295,0.272,12.148,1.745c1.74-0.727,3.479-1.454,5.219-2.18c-1.597,0.006-3.193-0.486-4.509-1.391
		c0.22-1.43,2.447-1.981,3.309-0.818c-0.429-1.294-0.859-2.587-1.289-3.881c2.751,1.273,6.247,0.716,8.467-1.349
		c-0.759-0.999-2.371-1.199-3.351-0.415c-0.224-1.016-0.06-2.112,0.451-3.018c-2.845,0.574-5.69,1.149-8.535,1.723
		c0.931-4.566,2.523-8.997,4.712-13.111c3.494,1.793,7.277,3.023,11.157,3.628c-1.389-1.835-2.434-3.929-3.066-6.142
		c-1.707-1.085-3.736-1.656-5.759-1.62c-0.737-2.515,1.824-4.967,4.419-5.326c2.596-0.359,5.157,0.641,7.707,1.244
		c2.55,0.603,5.542,0.704,7.464-1.077L271.5,246c2.037-1.371,2.283-3.614,5.249-3.499c3.074,0.119,2.414,2.429,4.488,3.698
		c2.097,1.284,6,0.536,8.026-0.393c2.285-1.048,3.714-3.659,6.23-3.374c2.627,0.297,3.253,2.867,6.008,2.818
		c1.359-0.024,2.724-0.486,3.819-1.3c1.65-1.227,1.266-2.671,2.23-3.962c1.295-1.735,4.458-1.986,6.327-0.744
		c1.924,1.279,2.674,4.574,3.873,6.512c1.911,3.088,2.997,2.264,6,0.807c2.896-1.405,6.702-2.231,8.244-4.618
		c1.155-1.788,0.016-1.68,2.5-2.189c1.754-0.359,3.606-0.445,5.401-0.706c2.079-0.303,4.406-0.423,6.36-1.301
		c1.041-0.468,1.662-1.426,2.975-1.8c-2.086-2.919-1.998-6.169,0.494-8.743c3.125-3.228,4.77-2.868,5.064-7.662
		c2.42-0.513,3.188-1.788,4.511-3.739c0.954-1.407,1.623-5.313,3.464-5.568c0.811-0.112,4.432,1.175,5.486,1.456
		c0.623,0.166,2.059,1.247,2.494,1.254c0.817,0.013,2.782-1.258,2.256-1.198l0.531,0.057c0.723,1.08,2.589,1.897,3.743,3.199
		c0.613,0.692,1.627,2.108,1.912,2.994c0.65,2.023,0.529,1.161-0.743,2.426c-1.185,1.178-1.935,1.155-2.701,2.883
		c-0.579,1.308-1.06,3.049-1.431,4.442c-0.817,3.064,0.24,5.137,0.132,8.005c-0.082,2.186-1.641,4.998-1.144,7.194
		c0.26,1.147,1.866,1.235,1.455,3.056c-0.302,1.337-1.709,1.854-2.764,2.544c-2.455,1.608-5.961,3.67-7.736,5.993
		c-1.374,1.799-1.116,1.298,0.556,2.702c1.487,1.247,3.193,2.206,4.702,3.464c2.552,2.128,4.355,4.158,2.762,7.478
		c2.524,0.881,5.452,0.493,7.992,1.607c1.001,0.439,0.974,0.99,2.232,1.15c0.969,0.123,1.562-0.708,2.5-0.194l-0.247-0.009
		c0.631,0.578,1.607,1.074,2.066,1.702c0.487,0.667,0.637,1.525,1.001,2.306c0.45,0.967,0.74,1.913,1.493,2.744
		c0.531,0.585,2.102,1.184,2.442,1.758c1.09,1.841-1.534,2.83-2.06,4.749c-0.681,2.485,0.078,3.572,1.373,5.488
		c0.672,0.994,0.972,2.087,1.607,3.024c0.467,0.689,1.453,0.678,1.836,1.475c0.373,0.777-0.32,1.307,0.233,2.325
		c0.526,0.968,1.715,0.991,1.823,2.25c0.31,3.612-2.94,1.674-4.567,2.439c-2.043,0.96-1.015,4.117-0.319,6.017
		c0.19,0.517,1.139,0.915,1.281,1.482c0.14,0.561-0.636,1.229-0.536,1.499c0.289,0.774,1.115,1.313,1.323,2.251l-10.083,8.417
		l2.078,0.048L386,321c-0.084-0.068-0.299-0.619-0.255-0.286c0.652,2.633-1.887,1.517-3.013,2.281
		c0.387-0.262-1.26,2.293-1.169,2.068c-0.258,0.637-0.101,1.343-0.369,1.882c-1.322,2.654-1.551,1.508-3.944,1.244
		c-2.208-0.244-3.927,1.117-6.25,1.562l0.091-0.489c-0.768-0.588-1.558-1.144-2.146-1.922c-2.618,1.911-4.884,2.902-7.902,3.941
		c-0.25,1.733-3.209,2.507-4.755,2.182c0.621-2.702-1.436-5.179,1.247-7.198c-0.936-2.029-3.388-0.981-5.103-1.44
		c-0.851-0.228-0.929-0.991-2.127-1.073c-1.007-0.069-1.648,0.226-2.36,0.789c-1.805,1.425-1.224,3.973-4.452,3.161
		c-2.213-0.557-2.326-2.283-3.494-4.006c-1.411-2.082-2.506-2.9-2.749-5.421c-0.184-1.903-0.948-5.095,0.687-6.59
		c0.953-0.871,2.692-1.183,3.744-1.751c1.478-0.797,2.597-1.495,4.304-1.981c-0.988-0.993-2.507-2.377-3.797-3.193
		c-2.103-1.331-2.08-0.641-4.505,0.179c-4.505,1.524-1.504-1.881-4.402-3.204c-0.693-0.316-4.688,0.178-5.592,0.27
		c-1.389,0.141-2.629,0.758-4.001,0.985c-3.164,0.524-6.465,0.109-9.687,0.301l-0.02-0.133c-0.04-1.061-0.115-2.171,0.075-3.168
		c0.185-0.974,1.052-1.967,0.943-2.986c-0.142-1.318-3.029-5.1-4.248-5.255c-2.091-0.266-5.694,4.236-8,4.759
		c-1.007,0.229-2.35-0.389-3.255,0.234c-0.877,0.604-0.684,2.383-1.601,3.204c-1.205,1.079-6.714,1.941-8.148,1.019
		c-1.857-1.194-0.716-4.77-1.558-6.461c-0.882-1.77-2.774-1.605-4.132-3.001c-0.569-0.584-0.794-1.276-1.117-1.994
		c-0.181-0.402-0.544-2.658-0.439-1.756"
      />
    </a>

    <a (click)="SelectCode('PL')">
      <path
        [class.selected]="IsSelected('PL')"
        id="PL"
        d="
		M334,852.75c-0.7,0.134-2.006-0.531-2.967-0.712c0.102,2.051,1.599,1.224,2.812,1.606c-0.166-0.052,3.558,0.971,2.613,1.318
		c-0.235,0.086-0.438,0.001-0.677,0.081c0.571,1.104,1.678,0.987,1.4,2.355c-0.381-0.114-0.987,0.014-1.371-0.095
		c0.178,0.564,0.136,1.572,0.4,2.122c-4.265-1.878-8.537-5.539-13.45-3.167c-1.296,0.626-2.389,1.633-3.719,2.183
		c-1.937,0.801-5.244,0.849-7.26,0.261c-0.114-0.033-5.553-2.437-5.243-0.886c0.282,1.414-0.568,3.059-0.855,4.434
		c-0.173,0.826,0.292,1.692,0.128,2.493c-0.577,2.825-1.147,1.316-2.94,1.438l-1.372,0.068c-0.572-2.038,1.652-8.05-2.206-7.288
		c-0.468-1.981-1.431-4.212-0.8-5.969c0.231-0.645,1.239-1.753,1.562-2.437c0.35-0.742,0.622-1.771,0.912-2.499
		c-2.36-0.127-1.753-2.168-3.719-2.819c-1.771-0.586-3.172,1.075-4.999,0.012h-0.008c-0.18-1.702-0.183-3.455-0.433-4.574
		c1.382-0.37,2.484-1.15,3.266-2.286c1.554,1.007,2.528,3.516,4.673,3.367c0.398-0.028,0.734-0.074,1.016-0.344
		c-0.103,0.099-3.299-3.028-3.282-3.623c0.063-2.248,5.271-1.277,6.911-2.975c0.952-0.986,1.375-2.351,2.022-3.559
		c1.095-2.046,3.39-3.403,4.828-5.255l0.757-1.25c1.059,1.33,4.243,0.67,5.7,0.744c0.621,0.032,1.546,0.628,2.55,0.274
		c1.038-0.365,1.399-1.591,2.3-1.969c0.588-0.247,2.295-0.189,2.895,0.006c0.956,0.311,1.317,1.263,1.987,1.513
		c0.972,0.363,1.616,0.18,2.581,0.419c1.061,0.263,1.23,1.559,2.693,0.718c-0.109-0.62,0.307-1.2,0.344-1.669
		c1.387,0.191,1.796,1.462,1.949,2.712c0.157,1.277-0.832,2.041-0.762,2.987c0.128,1.725,4.291,3.902,4.549,1.801
		c0.871,0.174,1.344,0.311,1.694,1.25c1.499-1.171,5.651-2.974,7.475-3.005c-0.198,2.704,6.299,2.312,8.262,2.505
		c0.637,2.234-2.514,3.119-2.968,5.213c-0.244,1.127,0.419,2.691,0.006,3.756c-0.424,1.092-1.986,1.226-2.274,2.231
		c-0.362,1.262,2.093,6.62,3.193,7.531c0.334,0.277,1.401,0.008,1.573,0.214c0.632,0.755,0.362,1.114,0.802,1.96
		c0.627,1.209,1.832,1.387,0.406,2.765c-1.673,0.305-3.995,0.444-5.256,1.756c-0.388-0.207-0.879-0.162-1.274-0.37
		c-0.243,0.89-0.251,1.946,0.073,2.657l-0.453-0.257c-2.026-0.614-3.767,0.646-6.053,0.068c-1.464-0.37-1.04-1.981-3.207-1.598
		c-0.278-0.914-0.226-2.666-0.843-3.407c-0.827-0.992-1.737-0.218-2.479-1.541c-0.776-1.385,0.389-3.107-0.1-4.522
		c-0.154-0.444-1.754-1.98-1.747-1.881c0.127,1.92-1.38,3.789-0.741,5.601c0.013,0.038,0.084,0.118,0.189,0.224"
      />
    </a>

    <a (click)="SelectCode('PO')">
      <path
        [class.selected]="IsSelected('PO')"
        id="PO"
        d="
		M496.237,824.263c2.002,0.616,5.428-0.197,4.801,3.199c0.79-0.019,1.195,0.407,1.919,0.581c0.124,1.453-1.556,1.746-2.701,2.268
		c-1.996,0.909-1.531,0.293-2.507,2.244c-0.667,1.333-0.729,2.915-1.75,3.706c-0.575,0.446-3.717,1.196-4.493,1.006
		c-1.725-0.424-2.248-2.439-3.438-3.33c-1.086-0.813-2.599-1.205-3.823-1.889c-0.973-0.544-1.951-1.367-3.008-1.812
		c-1.83-0.772-3.649,0.594-5.028,0.018c0.704-0.75,1.066-1.789,1.737-2.492c1.31-1.373,0.919-0.49,2.292-0.994
		c1.761-0.647,3.468-2.578,5.419-1.238c-0.083-0.299-0.049-0.693-0.113-0.987c1.587-0.746,3.15-3.226,4.956-3.044
		C492.464,819.46,494.356,823.684,496.237,824.263z M527.75,819.25c-0.166-0.286-0.99-1.161-1.074-1.432
		c-0.161-0.515,0.414-1.108,0.336-1.306c-0.502-1.289-1.428-2.166-1.981-3.462c1.095-1.055,1.088-3.065-0.745-3.087
		c-0.19-3.652-10.562-5.811-10.324-3.245c-1.197-0.541-2.71-0.218-3.907-0.774c-1.466-0.681-1.747-2.185-3.763-1.657
		c-0.648,1.485-2.632-0.666-4.043-0.787l-0.131-0.376c0.005,0.468-0.027,0.932-0.114,1.382c-0.139,0.725-1.192,4.45-1.805,4.706
		c-0.994,0.416-1.374-1.202-2.202-1.161c-1.384,0.068-1.45,1.147-2.505,1.898c-1.711,1.218-3.184,0.694-2.274,3.563
		c-0.855,0.545-1.324,1.472-1.219,2.488l0.571,0.216c2.252,1.379,4.382,3.325,6.878,4.259c0.87-2.115-0.156-3.903-1.426-5.435
		c0.782,0.943,2.592-0.271,3.446,1.542c0.524,1.112-0.113,3.105,0.078,4.333c2.728,0.719,2.105-2.75,2.807-4.201
		c0.976-1.972,3.848-1.722,3.395,0.785c-0.313,1.733-1.332,0.545-1.81,1.69c-0.855,2.047,2.347,1.359,4.014,1.273
		c0.292-0.015-0.989-2.556-0.749-2.869c0.233-0.303,3.792,0.304,4.217,0.494c-2.934,5.573,4.944,4.464,4.012,8.055
		c0.982-3.784,6.781-6.185,10.164-7.03L527.75,819.25z"
      />
    </a>

    <a (click)="SelectCode('PR')">
      <path
        [class.selected]="IsSelected('PR')"
        id="PR"
        d="
		M414.912,573.062c-0.762-0.535-1.231-1.359-1.2-2.274c-1.742,0.357-2.77-0.829-4.462-0.788c-1.162,0.028-1.283,0.309-2.194,0.807
		c-0.24,0.131-0.178,1.052-0.489,1.211c-0.327,0.167-0.9-0.044-1.068,0.038c-1.204,0.586-3.524,0.652-4.743,1.427
		c-1.589,1.01-4.013,3.048-3.757,3.268l0.102-0.506c1.135-3.961,4.44-7.251,7.405-12.145l-0.008-0.349
		c0.759-1.805,0.16-3.291-1.013-4.719c-0.328-0.399-3.713-2.343-0.524-2.818c-0.059-0.66,0.353-1.22,0.319-1.87
		c1.787,0.288,2.406-0.946,1.949-2.586c-0.284-1.018-1.398-0.543-1.506-1.77c-0.002-0.026,0.52-0.873,0.562-1.187
		c0.074-0.548,0.639-0.235,0.518-1.099c-0.091-0.649-0.588-0.907-0.686-1.263c-0.276-1.002-0.811-1.591-0.618-2.938l-0.005-0.076
		c1.291-0.095,2.575,0.21,3.603,1.017l0.153,0.059c1.119,0.134,3.86,1.46,3.787-2.211c0.528,0.069,1.759,0.783,2.2,0.724
		c0.883-0.117,1.631-1.111,2.257-1.037c1.049,0.124,1.36,1.368,2.061,1.732c1.013,0.525,2.22,0.292,3.2,0.8
		c0.726,0.376,1.108,1.008,1.75,1.487c0.65,0.484,0.861,0.787,1.757,1.269c0.797,0.429,1.366-0.789,1.999,0.731
		c0.238,0.572-0.373,2.406-0.199,3.262c0.316,1.556,2.241,3.8,0.436,5.006c-1.726,1.154-4.592-0.431-4.005,2.682
		c0.123,0.652,1.119,1.561,1.256,2.556c0.182,1.317-0.374,1.739,0.244,2.95c0.501,0.982,2.561,3.181,3.256,4.05l0.251-0.005
		c-2.668-0.384-3.737,3.342-3.789,5.223c-1.457-0.648-2.345,0.391-3.462,1.282l0.045-0.087c-0.099-0.053-0.202-0.105-0.308-0.156
		c-1.575-0.75-2.963-0.444-3.8-2.22c-0.487,0.111-1.04,0.306-1.437,0.713"
      />
    </a>

    <a (click)="SelectCode('RG')">
      <path
        [class.selected]="IsSelected('RG')"
        id="RG"
        d="
		M502.75,786.75c-0.085-0.309,2.122-1.891,3.05-1.949c2.09-0.132,3.036,1.214,5.194-0.052c3.408-1.998,2.317-7.103,3.506-10.761
		c0.692-2.13,3.133-2.149,5.318-3.176c2.671-1.255,2.436-1.419,2.932-3.813c0.485-2.343,0.773-2.19-1-4.055
		c-0.75-0.789-1.432-1.462-2.252-2.138c-1.285-1.06-1.014-0.378-1.749-1.807c-0.437-0.85-0.743-1.757-1.236-2.694
		c-0.541-1.029-0.919-0.802-1.014-2.306c-0.158-2.503,1.162-3.081-1-4.963c-0.118-0.103-1.209,0.202-1.568-0.006
		c-0.427-0.247-0.516-1.37-1.182-1.731c-2.135-1.158-1.197,0.109-2.264,0.95c-1.062,0.837-0.222,1.205-2.041,1.018
		c-0.971-0.1-1.28-1.435-2.92-0.967c0.949,1.495,0.68,3.431-1.249,3.998c0.558,0.932,1.64,1.042,1.686,2.164
		c-0.776,0.213-1.646,0.528-2.461,0.535c-0.773,0.007-1.399-0.812-1.999-0.779c-0.746,0.042-0.872,0.977-1.495,1.049
		c-0.653,0.077-1.346-0.074-2.006-0.019c-1.34,0.112-3.622,0.965-4.761,0.761c-1.648-0.296-1.277-2.197-3.438-1.211
		c-1.138,0.52-1.678,2.668-3.232,3.018c-2.095,0.472-1.072-0.067-2.494-1.13c-2.086-1.559-4.274-2.128-6.824-2.939l-0.06-0.099
		c-0.729,0.441-1.528,0.756-2.157,1.405c0.551,0.995,1.909,0.883,2.411,1.75c1.116,1.929-1.053,1.611-0.979,3.199
		c0.045,0.953,1.991,1.404,2.053,2.695c0.057,1.18-1.304,1.498-1.524,2.362c-0.367,1.437,0.869,3.737,2.006,4.443
		c0.945,0.586,1.59-0.804,2.686,0.564c0.535,0.668,0.315,1.986,0.314,2.182v0.543c0.523,0.188,1.01,0.399,1.237,0.47
		c0.378,0.118,1.493-0.275,1.775-0.031c0.509,0.441,0.273,1.273,0.481,1.518c0.29,0.343,0.034,0.97,0.489,1.449
		c0.517,0.544,1.478,0.042,2.018,0.477c0.781,0.63,1.692,1.823,1.317,2.836c-0.32,0.864-1.659,0.999-2.016,1.544
		c-0.513,0.783-0.332,2.034-0.512,2.907c1.077,0.181,1.413-0.093,1.497-1.174c1.472-0.067,1.698,0.817,1.395,1.893l-0.931,1.568
		c0.688-0.421,1.631-0.595,2.249-1.069c0.37-0.284,1.207-1.58,1.433-1.685c0.85-0.398,3.202-0.221,4.068,0.286
		c0.898,0.526,5.747,7.647,5.288,2.257c1.198-0.093,1.824,0.14,2.124,0.61L502.75,786.75z"
      />
    </a>

    <a (click)="SelectCode('RH')">
      <path
        [class.selected]="IsSelected('RH')"
        id="RH"
        d="
		M559.5,802.75c-0.271-2.747,1.305-2.844,2.5-4.763c0.979-1.573,1.981-3.843,2.006-5.743c0.03-2.276-1.549-3.411-2.268-5.439
		c-0.31-0.875-0.535-2.633-0.237-3.56c0.295-0.916,1.511-1.215,1.704-2.051c0.09-0.391-0.655-2.689-1.006-2.95
		c-1.545-1.15-0.996,0.053-2.443,0.206c-0.935,0.099-2.098,0.219-2.993,0.231c-1.765,0.024-1.4-0.23-2.751-0.688
		c-1.849-0.627-1.409-0.594-3.031,0.242c-0.04,0.021-0.072,1.163-0.275,1.275c-0.66,0.364-0.813-0.205-1.456-0.017
		c-1.608,0.469-4.309,1.131-5.899,0.505c2.336-1.826-0.517-1.703-1.796-1.187c-1.668,0.673-3.437,2.041-4.805,3.188l-0.001-0.512
		c1.055,2.067-0.032,3.49,0.232,6.012c0.309,2.954,1.326,2.994-1.481,4.938c-0.811,0.562-2.221,1.939-3.013,2.255
		c-1.108,0.442-1.734-0.115-3.199-0.155c-0.227,2.923,0.645,5.491,0.225,8.461c-0.325,2.296-3.511,4.222-3.687,6.257l0.277,0.174
		c0.591-0.186,1.329-0.358,1.452-0.236c0.794,0.793,2.267,0.644,3.407,0.767c-0.48-2.101,1.418-2.53,2.611-1.216
		c0.68,0.749-0.511,1.597,0.227,2.204c0.429,0.353,1.897-0.01,2.449,0.045c2.01,0.198,3.381,0.742,4.276-1.751
		c0.281-0.784-0.555-1.359-0.036-2.306c0.413-0.754,1.694-1.403,2.474-1.399c0.019,0.454,0.266,0.773,0.338,1.18
		c0.562-0.121,2.28-0.491,2.711-0.969c0.874-0.97-0.136-1.496,1.001-2.242c1.696-1.113,0.729,0.342,1.488,0.742
		c1.058,0.557,0.522,0.932,2.254,0.507c0.373-0.092,0.063-1.228,0.476-1.217c1.392,0.037,0.372,0.59,1.024,1.419
		c0.544,0.691,0.078,2.037,1.481,2.305c1.598,0.305,4.399-2.845,3.795-4.274L559.5,802.75z"
      />
    </a>

    <a (click)="SelectCode('RM')">
      <path
        [class.selected]="IsSelected('RM')"
        id="RM"
        d="
		M566.5,745.75c-0.258-0.152-0.525-0.262-0.73-0.436c0.72-0.43,1.563-0.726,2.436-0.856c0.603-2.928,5.949,0.19,3.519,2.044
		c0.778,2.467,4.213,7.045,6.775,7.768c0.889,0.251,1.667-1.236,2.706-0.212c0.706,0.695,0.023,2.086,0.044,2.943
		c0.065,2.782,0.266,2.97,2.75,3.25l-1.5,3.5c-3.1,3.027-11.643-2.6-14.256-4.474l-1.994-1.026c1.867-0.856-0.044-2.849-0.269-4.244
		c-0.002-0.012,0.131-2.734,0.075-2.561c0.614-1.894,0.616-0.386,1.693-1.444c1.018-1,1.408,0.377,0.513-1.574
		c-0.048-0.106-1.719-2.125-1.994-2.432c-0.041-0.046-0.083-0.091-0.124-0.134L566.5,745.75z"
      />
    </a>

    <a (click)="SelectCode('S')">
      <path
        [class.selected]="IsSelected('S')"
        id="S"
        d="
		M464.318,583.049c0.51,0.478,0.921,1.124,1.25,1.945c1.437,3.587-1.993,2.075-3.63,4.694c-0.517,0.827-2.393,5.658-2.163,6.317
		c0.208,0.597,3.891,2.336,4.531,2.751c1.419,0.921,3.02,1.86,4.651,2.286c-0.524,1.813,0.134,2.474,0.544,4.206l-0.108-0.21
		c1.19-0.615,2.699-0.16,4.108-0.041c2.288,0.193,2.757-0.236,3.556,1.995c0.872,2.436,1.413,4.002,2.876,6.244
		c0.364,0.557,1.164,2.816,1.75,3.029c1.526,0.557,0.872-0.825,2.013-1.049c0.818-0.161,1.686,0.56,2.368,0.488
		c1.274-0.136,2.398-1.044,3.45-1.736l-0.262,0.28c0.75-0.593,1.824-0.761,2.493-1.299c1.227-0.986,0.878-1.371,1.507-2.451
		c0.191-0.329,0.062-1.105,0.232-1.512c0.216-0.517,1.139-0.317,1.341-0.982c0.314-1.032,0.18-1.91-0.548-2.705
		c1.641-0.114,3.2,0.007,4.78,0.218c2.473,0.331,2.392,1.1,4.419,2.426l1.026-0.695c-0.036-1.871,1.873-1.359,2.725-2.688
		c-0.854-0.797-0.496-0.465-0.75-1.248c-0.525-0.02-1.065-0.435-1.686-0.351c0.16-1.019,0.595-2.083,0.423-3.169
		c-1.628-0.002-2.263-0.778-1.705-2.299c0.53-1.446,1.501-0.59,2.523-1.738c-0.484-0.461-1.058-1.073-1.748-1.298
		c0.286-0.359,0.34-1.105,0.624-1.478c-1.305-0.897-2.728-0.076-4.1-0.743c-2.056-1.001-0.93-1.379-1.806-2.986
		c-0.374-0.685-2.066-2.737-3.194-2.825c-1.441-0.113-1.692,1.809-3.519,0.532c-0.123-0.127-0.036-0.494-0.074-0.665
		c-2.911-0.774,1.932-2.72,2.017-3.068c-3.151-1.688-1.094-2.426-2.981-4.547c-0.439-0.494-1.359,0.159-1.761-0.215
		c-0.537-0.5-0.509-1.372-0.932-1.966c-0.726-1.02-0.97-2.393-2.536-2.277c0.254-0.358,0.282-1.155,0.448-1.436
		c-0.904-0.039-2.618-0.362-3.466-0.031c-1.212,0.473-0.89,1.306-2.258,1.81c-1.253,0.462-2.28-0.793-3.493-0.566
		c-1.977,0.369-0.909,1.245-1.744,2.512c-1.41,2.138-3.982,2.096-6.067,3.184c-0.791,0.413-1.581,1.134-2.377,1.623
		c-0.824,0.506-3.027,1.04-2.311,1.438L464.318,583.049z"
      />
    </a>

    <a (click)="SelectCode('SA')">
      <path
        [class.selected]="IsSelected('SA')"
        id="SA"
        d="
		M359.25,758.25c0.225-2.146,1.98-1.537,3.181-2.55c0.869-0.732,1.668-2.237,2.036-3.151c-2.568-0.327-1.157-4.826,0.026-5.811
		c1.197-0.997,3.895-0.18,5.718-0.276c0.255-1.2-1.683-3.363-1.962-4.962c-0.484-2.771-0.199-2.649,1.507-4.438
		c1.52-1.595,1.781-2.615-0.257-4.074c-1.043-0.747-1.538,0.542-2.444-1.051c-0.683-1.2,0.03-2.67,0.23-3.898l0.213,0.461
		c-1.358-1.371-3.447-1.51-4.457-2.993c-0.74-1.087-1.237-5.015-0.81-6.201c0.644-1.792,2.86-2.694,3.968-4.056
		c1.778-2.184,0.643-2.65-0.762-4.238c-0.654-0.74-1.031-1.547-1.725-2.256c-0.459-0.469-1.406-0.636-1.736-1.243
		c-0.438-0.805,0.353-1.318-0.008-2.013c-0.977-1.877-2.165-2.38-4.162-1.693c-0.997,0.343-1.016,1.18-2.306,1.205
		c-1.129,0.022-2.096-0.966-3.001-1.456c-1.862-1.008-3.513-2.167-5.711-2.093c0.047-0.347-0.122-0.827-0.076-1.174
		c-2.634,0.201-1.753-0.361-2.268-2.038c-0.693-2.255-0.016-1.503-2.189-1.933c-1.283-0.254-3.237-0.334-4.56-0.818
		c-1.286-0.47-1.925-1.277-3.112-2.017c0.36-0.003,0.582,0.127,0.916,0.268l-1.248-0.165c-0.514,0.514-1.047,1.008-1.599,1.482
		c-5.361,4.603-12.166,7.188-19.01,8.944c-4.245,1.089-8.517,2.99-8.233,7.363c-2.263,0.635-4.525,1.27-6.788,1.905
		c-0.515,0.144-1.06,0.307-1.414,0.708c-0.398,0.451-0.479,1.122-0.896,1.554c-1.723,1.786-5.558-2.607-6.696-0.402
		c-0.426,0.825,0.187,1.932-0.298,2.723c-0.246,0.401-0.71,0.603-1.151,0.766c-4.517,1.665-10.559,2.53-11.752,7.194
		c-0.155,0.606-0.167,1.339,0.3,1.755c0.356,0.317,0.876,0.346,1.353,0.358c3.32,0.086,6.64,0.172,9.96,0.258
		c0.517,4.674-3.092,9.428-7.733,10.186c0.253,2.553,2.306,4.824,4.821,5.332c-0.437-2.301,2.832-3.508,5.1-2.923
		c2.268,0.585,4.572,1.984,6.787,1.221c-2.71,0.908-5.637,1.157-8.461,0.72c0.01,0.783,0.02,1.566,0.03,2.349
		c0.639-0.584,1.72,0.008,2.077,0.797c0.357,0.789,0.317,1.707,0.637,2.512c0.84,2.108,3.741,2.536,5.891,1.812
		c2.15-0.725,3.985-2.225,6.161-2.866c2.754-0.811,6.764-1.015,6.989-3.877c0.082-1.043-0.484-2.127-0.113-3.105
		c0.418-1.1,1.77-1.465,2.937-1.614c3.266-0.417,6.596-0.32,9.832,0.285c0.005-0.844,0.011-1.688,0.016-2.533
		c2.128-0.127,4.293,0.519,6.003,1.791c-1.747,0.194-2.207,2.815-1.087,4.17c1.12,1.355,3.011,1.727,4.745,2.012
		c3.398,0.559,6.796,1.118,10.194,1.677c-3.687,2.78-8.838,3.489-13.139,1.809c-0.072,0.851,0.71,2.484,0.638,3.335
		c0.923,1.515,1.847,3.03,2.771,4.545c1.898,0.831,4.346,0.104,5.483-1.628c2.968,0.384,6.017,0.13,8.88-0.74
		c0.177-0.897,0.354-1.795,0.531-2.692c1.439-2.8,5.937-1.873,7.94,0.555c1.242,1.506,1.992,3.344,2.865,5.099L359.25,758.25z"
      />
    </a>

    <a (click)="SelectCode('SE')">
      <path
        [class.selected]="IsSelected('SE')"
        id="SE"
        d="
		M568.244,759.276c-0.02,0.49-0.493,1.142-0.538,1.681c-1.227-0.138-2.532-0.077-2.919,1.231c0.449,0.392,0.365,0.855,0.689,1.263
		c-1.068,0.407-1.279,1.352-0.726,2.3l-0.475-0.413c-0.312-0.101-0.633-0.196-0.969-0.281c-0.107-0.027-1.363,0.275-1.624,0.261
		c-0.45-0.024-0.544-0.857-1.176-0.823c-1.348,0.072-2.387,1.324-3.007,2.505l-2.75-1c-1.039-0.693-0.133-1.591-0.237-2.75
		c-0.084-0.938-1.027-2.342-0.956-3.001c0.192-1.794,2.678-2.041,4.193-1.51c1.239,0.434,1.172,0.831,2.243,0.948
		c0.464,0.051,2.4-0.355,3.02-0.425c1.481-0.166,3.377-1.06,4.873-0.23L568.244,759.276z"
      />
    </a>

    <a (click)="SelectCode('SG')">
      <path
        [class.selected]="IsSelected('SG')"
        id="SG"
        d="
		M543,729.625c0.861-0.002,1.7,0.061,2.513,0.343c0.092-0.204,0.175-0.48,0.28-0.688c0.964,0.1,1.853,0.857,2.664,1.187
		c-0.07-0.406-0.114-2.113,0.275-2.291c1.31-0.6,0.883,0.955,1.574,1.273c1.959,0.901,2.511,0.467,2.632,2.487
		c0.026,0.428-0.716,1.385-0.698,2.076c0.017,0.655,0.958,1.22,1.016,1.986c0.114,1.489-1.299,2.335-0.505,4.001l-0.003,0.111
		c0.646,0.018,1.182,0.006,1.503-0.087c2.726-0.788,2.988-5.874,6.25-4.774l-0.155-0.513c3.604-0.632,5.366-2.251,6.355-6.049
		c0.408-1.566,0.299-4.07,0.3-5.687c0-1.266-0.343-2.107,0.042-2.57L567,721c-0.084-0.725-0.518-1.279-1.468-1.55
		c0.897-1.989-1.889-1.849-1.231-3.644c0.508-1.387,2.408-0.813,2.948-2.807c0.985-3.631-2.423-5.831-4.243-7.506
		c-1.355-1.247-1.907-1.58-3.706-2.557c-0.787-0.428-0.446-1.422-1.549-1.441c-0.987-0.017-1.351,1.473-1.737,1.471
		c-2.041-0.011-1.319-2.149-1.575-3.273c-0.247-1.086,0.804-1.073-0.433-1.687c-0.867-0.431-1.439-0.13-1.799,0.699
		c-1.533-0.05-3.103,1.122-4.708,1.293c-1.882,0.2-2.924-0.054-3.755,1.751c-0.313,0.68,0.307,1.76-0.045,2.449
		c-0.24,0.471-1.163,0.595-1.505,0.976c-1.006,1.123-1.997,2.247-2.863,3.575c2.027,1.567,0.035,2.95-0.037,4.706
		c3.643,0.727-1.375,4.057,0.235,6.562c-0.116,0.453-0.291,0.034-0.53,0.231l0.556,0.432c0.747,0.431,2.831,2.353,3.139,3.118
		c0.617,1.534-1.066,2.766,1.018,3.763c-0.485,0.586-0.467,1.28-0.712,1.937L543,729.625z"
      />
    </a>

    <a (click)="SelectCode('SK')">
      <path
        [class.selected]="IsSelected('SK')"
        id="SK"
        d="
		M439.25,597c0.035,0.011,1.162-0.122,1.712-0.294c-0.29-2.709-0.378-4.212,1.538-6.194c0.542-0.56,1.927-2.13,2.75-2.219
		c0.931-0.1,1.811,1.204,2.75,0.954c2.5-0.665-0.427-3.265,0.732-4.566c0.75-0.842,5.409-1.931,6.267-1.931
		c0.78-0.001,1.198,0.691,2.238,0.573c1.316-0.15,2.242-1.259,3.763-1.323c2.292-0.097,3.708,0.849,4.568,2.994
		c1.437,3.587-1.993,2.075-3.63,4.694c-0.517,0.827-2.393,5.658-2.163,6.317c0.208,0.597,3.891,2.336,4.531,2.751
		c1.419,0.921,3.02,1.86,4.651,2.286c-0.524,1.813,0.134,2.474,0.544,4.206l-0.951,0.495c-0.501,0.628-0.269,2.069-0.794,2.754
		c-0.688,0.899-1.267,0.679-2.005,1.258c-2.104,1.649-1.394,1.25,0.019,2.987c0.976,1.2,1.284,2.231,3.199,2.299
		c-0.886,1.162-1.296,2.714-3.024,3.152c-1.747,0.442-4.514-1.928-4.944,0.306l-0.301-0.449c-2.654-1.63-3.12,1.32-3.949-2.551
		c-0.477-2.225-1.212-3.875-4-3.061c-2.136,0.623-2.35,2.816-4.749,3.06c-0.473,0.048-0.807-0.131-1.161-0.289l-0.251-0.438
		c0.326-1.269,1.292-2.15,0.161-3.785c-1.938-2.803-2.337-0.338-4.249,0.011c-2.15,0.393-3.335-2.034-4.743-3.055L437,607.5
		c0.504-2.063,1.883-3.304,2.006-5.5c0.07-1.263,0.359-3.342,0.368-4.999L439.25,597z"
      />
    </a>

    <a (click)="SelectCode('SL')">
      <path
        [class.selected]="IsSelected('SL')"
        id="SL"
        d="
		M534.25,760c-0.208-0.329-0.349-0.66-0.525-0.999c1.024-1.145,0.332-2.459-0.288-3.695c-0.897-1.79-1.22-1.574-1.194-3.562
		c0.015-1.113,1.02-3.375-0.494-3.754c-1.063-0.266-2.361,1.684-2.931,2.33c-1.248,1.417-1.341,2.144-3.318,2.181
		c-2.38,0.044-1.652-0.886-3.238-2c-0.747-0.525-2.914-1.253-3.749-1.264c-1.318-0.018-2.31,1.055-3.263,0.764l0.296,0.255
		c0.548,1.074-0.165,1.868-0.046,3.745c0.095,1.503,0.473,1.277,1.014,2.306c0.493,0.937,0.799,1.844,1.236,2.694
		c0.735,1.429,0.464,0.747,1.749,1.807c0.82,0.676,1.502,1.349,2.252,2.138c1.773,1.865,1.485,1.712,1,4.055
		c-0.167,0.806-0.251,1.36-0.392,1.787l0.284,0.413c1.411,0.459,3.014-0.061,4.18-0.937c0.554-0.416,0.186-1.375,0.743-1.517
		l0.184,0.005c0.166-1.279,0.083-2.767,1.713-2.787c-0.204-1.689,0.106-2.429,1.531-2.919c0.568-0.195,1.138,1.055,1.749,0.924
		c0.448-0.096,1.048-1.349,1.244-1.718L534.25,760z"
      />
    </a>

    <a (click)="SelectCode('SM')">
      <path
        [class.selected]="IsSelected('SM')"
        id="SM"
        d="
		M550.25,767.5c-3.974-0.838-2.224,4.271-2.711,6.964c0.946,0.226,1.765,0.433,2.711,0.536l0.26,0.17
		c0.082-0.26,0.165-0.491,0.241-0.669c0.569-1.34,3.355-2.283,3.211-3.702c-0.136-1.345-2.765-1.755-3.349-3.14L550.25,767.5z"
      />
    </a>

    <a (click)="SelectCode('SN')">
      <path
        [class.selected]="IsSelected('SN')"
        id="SN"
        d="
		M434,763.5c-0.207-1.407-2.897-2.464-3.018-3.488c-0.284-2.404,3.344-1.51,4.454-1.3l-0.186,0.038
		c1.113,1.044,3.884-2.342,5.711-2.538c-0.085-2.817-2.218-3.652,1.789-5.162c1.088-0.41,2.247-0.314,3.332-0.995
		c1.64-1.03,1.127-1.97,1.906-3.068c2.455-3.457,4.207-0.438,7.525-1c1.154-0.195,0.992-0.752,2.225-1.181
		c1.152-0.401,2.592,0.052,3.768-0.301c1.497-0.449,1.448-1.007,2.939-0.942c1.572,0.069,1.427,0.976,3.3,0.393
		c1.072-0.333,1.825-1.438,3.006-1.718c1.093-0.26,2.384,0.189,3.5,0.012c2.76-0.437,3.039-1.383,6.006-0.312
		c3.131,1.13,2.061,1.484,1.733,4.507c-0.22,2.023-0.089,4.674-3.299,3.649c-0.69,1.048-0.797,2.107-1.698,2.962
		c-0.887,0.843-2.087,1.1-2.959,2.001c0.551,0.995,1.909,0.883,2.411,1.75c1.116,1.929-1.053,1.611-0.979,3.199
		c0.045,0.953,1.991,1.404,2.053,2.695c0.057,1.18-1.304,1.498-1.524,2.362c-0.367,1.437,0.869,3.737,2.006,4.443
		c0.945,0.586,1.59-0.804,2.686,0.564c0.535,0.668,0.341,1.854,0.314,2.73c0,0.369,0.001-0.744,0-0.549l-0.353,0.423
		c-0.584-0.187-1.152-0.301-1.402-0.121c-1.282,0.923,0.793,1.692,0.022,2.767c-1.012,1.41-2.753,0.38-3.335-0.794
		c-1.322,0.049-2.797,1.115-1.213,2.212c-0.807,1.772-4.515,2.48-6.031,2.325c-1.014-0.103-1.31-0.931-2.511-0.636
		c-0.308,0.076-0.215,1.13-0.665,1.335c-0.556,0.254-0.946,0.081-1.512,0.232c-2.721,0.727-3.316-1.527-5.5-1.492
		c-1.728,0.027-4.012,2.8-4.75,4.248l0.049-0.101c-1.039-0.468-2.072-0.943-3.036-1.413c-3.085-1.505-1.103-1.806-0.765-4.236
		c0.294-2.112-2.702-5.425-4.316-6.441c-0.718-0.453-1.582-0.497-2.432-0.822c-0.427-0.163-1.026,0.203-1.449-0.038
		c-0.366-0.209-0.357-1.076-0.552-1.193c-1.585-0.947-2.964-1.822-4.572-3.439c-0.962-0.967-1.569-1.57-2.224-1.701L434,763.5z"
      />
    </a>

    <a (click)="SelectCode('SO')">
      <path
        [class.selected]="IsSelected('SO')"
        id="SO"
        d="
		M468.806,808.282c1.619,0.206,1.746,1.116,1.962,2.219c0.131,0.668-1.218,0.848-0.467,1.935c0.428,0.62,1.594,0.22,1.949,0.565
		c0.865,0.837,0.391,0.133,0.749,1.248c0.105,0.326-0.401,1.367-0.248,2.013c0.26,1.098,2.644,2.2,0.543,3.032l0.219,4.708
		l-0.242,0.507c1.004,0.182,2.052,0.634,3.23,1.519c0.267,0.201,2.478-3.055,2.722-3.225c1.194-0.833,3.187-0.836,4.704-1.326
		c1.464-0.473,5.33-2.502,5.48-4.109c0.109-1.174-1.788-2.768-1.81-4.17c0.001,0.043,2.204,1.362,3.685,2.246L492,816
		c-0.104-1.016,0.364-1.943,1.219-2.488c-0.91-2.869,0.563-2.345,2.274-3.563c1.055-0.751,1.121-1.829,2.505-1.898
		c0.828-0.041,1.208,1.576,2.202,1.161c0.613-0.256,1.666-3.981,1.805-4.706c0.33-1.722-0.127-3.654-0.48-5.218
		c1.158,0.138,2.944-1.261,3.412-2.344c1.027-2.378-0.651-2.981-1.687-4.638c-1.172-1.874-0.44-1.518-0.181-3.543
		c0.225-1.758,0.152-2.913-2.282-2.725c0.46,5.391-4.39-1.731-5.288-2.257c-0.866-0.507-3.218-0.684-4.068-0.286
		c-0.226,0.106-1.063,1.401-1.433,1.685c-0.618,0.474-1.562,0.648-2.249,1.069h-1.749c-2.301,0.992-3.41,3.984-6.445,2.944
		c-1.119-0.383-5.931-4.41-5.823,0.056c0.015,0.635,1.052,1.295,1.266,1.994c0.235,0.765,0.059,1.523,0.252,2.256
		c0.399,1.515,1.2,2.4,1.961,3.682c-1.218,0.963-1.721,1.732-2.525,3.068c-1.175,1.955-0.253,2.22-0.688,4.056
		c-0.74,3.121-5.924,0.526-4.999,4.694"
      />
    </a>

    <a (click)="SelectCode('SP')">
      <path
        [class.selected]="IsSelected('SP')"
        id="SP"
        d="
		M435.5,802.5c-0.889-0.581-1.712-1.215-2.724-1.544c0.344-1.537,1.908-1.364,2.543-2.444c0.638-1.085-0.276-2.489,0.232-3.268
		c1.114-1.706,4.814,0.27,6.198,1.029c0.651-0.535,1.345-2.357,1.751-3.024c0.427-0.703,0.979-0.094,1.255-1.249
		c0.201-0.84-1.078-1.17-0.767-2.007c0.608-1.629,5.954-0.785,6.055,1.212c0.194,0.068,0.583,0.146,0.706,0.263
		c1.39-2.367,3.334,0.223,5.213,0.242c-0.013-0.666-0.603-1.729-0.486-2.223c0.173-0.732,1.26-0.649,1.283-1.744
		c0.017-0.794-1.104-0.824-1.265-1.743c-0.104-0.594,0.485-1.723,0.729-2.27c-0.793-0.352-1.612-0.715-2.426-1.082l-0.049,0.101
		c0.738-1.448,3.022-4.221,4.75-4.248c2.184-0.035,2.779,2.22,5.5,1.492c0.566-0.151,0.956,0.022,1.512-0.232
		c0.449-0.205,0.357-1.26,0.665-1.335c1.201-0.295,1.498,0.532,2.511,0.636c1.515,0.154,5.224-0.554,6.031-2.325
		c-1.584-1.098-0.109-2.164,1.213-2.212c0.583,1.174,2.324,2.204,3.335,0.794c0.771-1.075-1.304-1.844-0.022-2.767
		c0.528-0.38,2.465,0.547,2.992,0.711c0.378,0.118,1.493-0.275,1.775-0.031c0.509,0.441,0.273,1.273,0.481,1.518
		c0.29,0.343,0.034,0.97,0.489,1.449c0.517,0.544,1.478,0.042,2.018,0.477c0.781,0.63,1.692,1.823,1.317,2.836
		c-0.32,0.864-1.659,0.999-2.016,1.544c-0.513,0.783-0.332,2.034-0.512,2.907c1.077,0.181,1.413-0.093,1.497-1.174
		c1.472-0.067,1.698,0.817,1.395,1.893c-0.432,1.534-1.443,1.034-2.681,1.568c-2.301,0.992-3.41,3.984-6.445,2.944
		c-1.119-0.383-5.931-4.41-5.823,0.056c0.015,0.635,1.052,1.295,1.266,1.994c0.235,0.765,0.059,1.523,0.252,2.256
		c0.399,1.515,1.2,2.4,1.961,3.682c-1.218,0.963-1.721,1.732-2.525,3.068c-1.175,1.955-0.253,2.22-0.688,4.056
		c-0.594,2.506-4.053,1.327-4.915,2.922l-0.279,1.054c-2.032,4.713-4.765,0.488-7.506,1.694c-0.869-1.471-3.47-3.818-2.588-5.661
		c-0.089-0.091-0.177-0.183-0.263-0.277c-1.199,0.602-2.243,1.815-3.436,2.482l-1.797,1.437c-0.464-2.695-2.487-1.874-4.466-1.657
		c-1.216,0.133-1.23,0.195-2.195-0.05c-0.522-0.133-1.01-1.016-2.061-1.017c-0.893-0.001-2.922,2.369-4.506,1.024
		c-1.049-0.891,0.503-2.98-1.288-3.956c-1.181-0.644-2.172-0.248-3.097,0.357L435.5,802.5z"
      />
    </a>

    <a (click)="SelectCode('SR')">
      <path
        [class.selected]="IsSelected('SR')"
        id="SR"
        d="
		M481.968,455.549c-1.426-0.294-1.046-1.757,0.026-2.373c0.847-0.486,2.157,0.143,2.969,0.285c0.024-0.876,0.049-1.798,0.075-2.673
		c0.368-0.047,0.836-0.106,1.212-0.038l0.019-0.011c1.871,6.045,3.786,12.08,5.995,18.007l-0.764,0.004
		c-1.158,0.397-1.261,1.45-2.5,1.748c-0.469,0.113-0.989,0.058-1.487,0.005l0.061-0.484c-0.018-0.783-0.078-3.707-0.321-4.025
		c-1.126-1.473-2.362-0.072-3.009-2c-0.249-0.74,0.706-2.049,0.204-3.238c-0.397-0.94-2.176-2.875-2.949-3.536L481.968,455.549z"
      />
    </a>

    <a (click)="SelectCode('SS')">
      <path
        [class.selected]="IsSelected('SS')"
        id="SS"
        d="
		M609.905,748.726c0.296,0.523,0.639,0.993,0.599,1.523c-0.135,1.796-1.999,4.024-3.565,4.738c-3.789,1.729-8.157,2.159-12.211,1.2
		c-3.292,1.922-6.931,3.247-10.687,3.891L584,760.25c-2.484-0.28-2.685-0.468-2.75-3.25c-0.02-0.858,0.663-2.248-0.044-2.943
		l-0.456-0.557c1.671-3.144,2.796-3.196,5.956-3.288c0.175-1.217,0.453-2.351,0.831-3.424c1.002,0.026,2.139-0.038,2.706-0.038
		c1.17,0,1.449,0.12,2.739,0.5c1.485,0.437,3.355-0.002,4.89,0.047c1.975,0.063,3.29,0.727,5.183,1.147
		c1.978,0.439,4.263,0.056,6.444,0.056L609.905,748.726z"
      />
    </a>

    <a (click)="SelectCode('ST')">
      <path
        [class.selected]="IsSelected('ST')"
        id="ST"
        d="
		M440.5,657.25c-1.511-0.786,0.375-2.711,0.005-4.25c-0.269-1.119-1.652-3.277-2.243-4.27c-0.816-1.37-1.561-2.62-2.317-3.98
		c-0.848-1.526-2.332-2.162-3.17-3.514c1.473-1.008,0.744-2.215,1.419-3.505c0.408-0.78,1.266-1.276,1.61-1.982
		c0.169-0.345,0.971-0.493,0.975-0.985c0.008-0.983-1.381-0.561-1.561-1.064c-0.313-0.873-0.25-1.933-0.181-2.913
		c3.642-0.058,0.617-4.545,0.457-5.789c-0.095-0.743-0.035-3.646-0.002-4.054c0.11-1.344-0.47-1.315,1.063-2.389
		c1.89-1.324,4.338-0.724,6.251-1.743c0.817-0.435,1.899-1.544,2.75-1.756c1.108-0.276,1.499,0.539,2.444,0.443
		c2.399-0.244,2.613-2.437,4.749-3.06c2.788-0.813,3.523,0.837,4,3.061c0.83,3.871,1.296,0.921,3.949,2.551
		c0.865,0.531,1.541,4.214,1.544,5.012c0.004,1.363-0.816,3.444-0.554,5.443c0.276,2.107,2.995,3.648,2.525,5.456
		c-1.932-0.77-2.115,0.465-1.957,2.026c0.297,2.933,0.67,0.953,2.494,2.007c1.122,0.648,2.438,2.087,0.444,3.218
		c-0.558,0.317-3.146-0.209-3.944-0.212l0.191,0.261c-0.452,0.09-0.998,0.51-1.935,0.745c-1.436,0.36-3.037,0.013-4.224,1.231
		c0.585,1.101,1.549,2.115,1.219,3.513c-0.449,1.897-1.038,0.71-2.306,1.677c-2.484,1.894-2.876,6.142-5.194,8.323l-4.167,1.583
		L442,657.167L440.5,657.25z"
      />
    </a>

    <a (click)="SelectCode('SW')">
      <path
        [class.selected]="IsSelected('SW')"
        id="SW"
        d="
		M554.449,765.735c-0.531-0.653,0.155-1.468,0.064-2.485c-0.084-0.938-1.027-2.342-0.956-3.001c0.072-0.673,0.466-1.128,1.011-1.406
		L554.5,758.5c-1.466-0.412-4.048-0.412-4.794,1.206c-1.135,0.081-6.193,1.646-3.251,3.087c-0.255,0.712-0.574,1.714-0.706,2.206
		l0.047,0.284c0.732,0.715,0.867,1.986,2.203,2.716l0.06,0.043c0.387-0.536,1.055-0.782,2.19-0.543l0.252-0.499
		c0.155-2.836,2.577-0.212,3.961-0.288c0.081-0.232,0.007-0.439,0.073-0.675L554.75,766
		C554.622,765.915,554.524,765.826,554.449,765.735"
      />
    </a>

    <a (click)="SelectCode('SY')">
      <path
        [class.selected]="IsSelected('SY')"
        id="SY"
        d="
		M343,671.5c-1.19-2.907,5.197-2.818,5.949-4.307c1.124-2.225-4.458-2.073-0.462-4.893c1.423-1.004,2.167-0.527,3.456-2.069
		c0.593-0.709,1.449-1.835,1.757-2.731c0.521-1.52-0.52-1.811,0.998-3.337c1.106-1.112,1.622-0.698,3.057-0.919
		c2.867-0.442,2.95-2.942,5.486-4.992c2.235-1.806,4.459-3.279,6.569-5.251c1.934-1.807,2.967-1.855,5.434-2.683
		c1.796-0.603,4.831-1.983,6.755-1.836c1.497,0.114,2.033,1.509,3.245,1.774c1.671,0.366,4.067-0.909,5.255-2
		c2.63-2.415,3.475-4.484,7.444-3.038c1.972-2.252,1.449-4.01,5.306-3.23c1.524,0.308,5.528,2.78,5.719,0.062
		c-2.386-0.937-0.616-3.742-0.72-5.568c-0.04-0.701-0.212-1.309-0.444-1.876l-0.01-0.024c2.049-0.834-0.626-2.751,0.674-4.142
		c1.447-1.548,3.212,1.449,4.519,1.786c2.45-2.478,5.288-0.986,6.318,1.081c0.813,1.633,0.845,2.436,2.431,3.993
		c1.04,1.021,2.114,2.954,3.725,2.988c0.409,1.321-0.391,1.561-0.705,2.275c-0.118,0.269-0.75,0.317-0.95,0.744
		c-0.217,0.463,0.2,1.289-0.051,1.693c-0.539,0.87-1.663,1.29-2.079,2.25c-0.515,1.188,0.537,2.099,0.335,3.262
		c-0.176,1.007-1.654,1.026-1.266,2.487c0.345,1.303,2.072,0.678,2.46,1.794c0.514,1.475-3.589,3.624-4.03,4.889
		c-0.593,1.703,0.225,0.669,0.769,1.88c0.576,1.284,0.664,0.487,0.617,2.001c-0.048,1.529-1.139,0.842-0.38,2.438
		c-0.034-0.071,2.403,2.913,2.105,2.768c0.988,0.483,2.217-0.783,2.981-0.036c1.076,1.052-0.379,2.399-0.962,3.086
		c-1.167,1.373-2.524,3.132-4.056,3.931c-2.468,1.288-3.575,1.326-3.055,4.751c0.587,3.869,2.192,1.328,4.367,3.287
		c2.129,1.917,0.016,4.42,0.439,6.712c0.247,1.341,1.514,4.518,2.249,5.501l-0.017-0.406c-1.106,2.216-2.208,0.093-3.495,0.888
		c-0.787,0.486-1.32,3.077-1.238,4.018l-0.013-0.035c-1.077,2.251-1.665,0.97-3.176,0.585c-0.781-0.199-2.744-0.209-3.367-0.531
		c-2.053-1.062-1.602-4.315-4.726-1.781c-0.258-2.09-1.265-1.372-1.968-0.263c-0.596,0.938-0.626,3.192-0.5,4.276l-1.655-1.899
		c-0.807-1.389-0.197-1.305-0.535-2.856c-0.226-1.036-0.524-2.225-1.372-2.932c-0.999-0.833-1.963-0.329-2.895-0.868
		c-0.977-0.565-1.185-1.676-2.149-2.381c-0.894-0.654-2.392-0.778-3.4-1.313c-2.066-1.097-3.593-2.488-5.925-3.318
		c-2.884-1.027-3.107,0.163-5.569,0.842c-1.493,0.412-2.157-0.564-3.499,0.476c-0.813,0.631-1.205,2.391-2.251,2.949
		c-1.337,0.714-2.444-0.158-3.556,0.295c-1.237,0.504-1.533,1.574-2.207,2.622c-1.087,1.689-0.428,1.751-2.487,2.077
		c-0.728,0.115-2.345-0.186-3-0.476c-2.471,1.735-2.997,2.181-3.494,5.032c-0.196,1.126-0.578,1.435-0.443,2.487
		c0.09,0.702,0.802,1.117,0.943,1.757c0.594,2.694-1.097,6.454-1.506,9.256l-0.302-0.726c-0.704-0.362-1.553-0.341-2.641,0.033
		c-0.997,0.343-1.016,1.18-2.306,1.205c-1.129,0.022-2.096-0.966-3.001-1.456c-1.862-1.008-3.513-2.167-5.711-2.093
		c0.047-0.347-0.122-0.827-0.076-1.174c-2.634,0.201-1.753-0.361-2.268-2.038c-0.693-2.255-0.016-1.503-2.189-1.933
		c-1.283-0.254-3.237-0.334-4.56-0.818c-1.286-0.47-1.925-1.277-3.112-2.017c0.36-0.003,0.582,0.127,0.916,0.268l-0.668-0.761
		c5.638-5.967,8.762-14.285,8.32-22.493L343,671.5z"
      />
    </a>

    <a (click)="SelectCode('TA')">
      <path
        [class.selected]="IsSelected('TA')"
        id="TA"
        d="M363,782
		c-0.388-1.107,0.656,0.917,0.77,1.25c0.281,0.822,0.477,1.83,0.443,2.712c-2.066,0.107-8.245-0.905-8.724,1.538
		c-0.013,0.067,1.349,3.984,1.312,3.949c0.613,0.579,3.296,0.564,4.199,0.752c2.292,0.477,1.826,0.323,2.756,2.055
		c0.246,0.457-0.239,0.888,0.225,1.557c0.493,0.711,1.609,0.785,2.275,1.243c2.53,1.74,4.036,4.125,7.456,3.662
		c-0.11-0.664,0.193-1.524,0.081-2.186c0.854,0.197,1.801,0.796,2.701,0.987c0.997,0.212,1.84-0.371,2.962,0.275
		c0.548,2.342-1.223,4,0.799,5.2c1.757,1.043,4.097-0.935,5.038,1.463c1.476,0.22,4.583-1.505,5.4-1.161
		c1.419,0.597,0.524,2.803,0.094,3.656c2.072,1.336,3.563,1.656,5.705,0.574c1.438,1.692,1.349,2.996,3.501,4.231
		c0.944,0.541,1.274,0.154,2.193,1.001c0.712,0.656,1.086,1.603,1.827,2.242c0.54,0.466,1.97,0.413,2.186,1.307l0.051,0.193
		c0.927-0.971,2.047-3.426,2.794-4.706c2.682-0.157,7.757,0.148,6.281-3.618c-0.218-0.556-1.246-0.151-1.33-1.17
		c-0.107-1.302,0.92-1.239,1.505-2.256c0.746-1.297,1.04-3.981-0.992-1.97c-0.749-0.623-0.507-2.14-0.02-3.03
		c0.827-1.512,1.322-0.874,2.343-1.932c1.372-1.421,1.831-4.393,4.164-1.537c0.738-0.613,1.437-1.424,2.224-2.081
		c-1.722-2.205-1.386-3.046-4.017-2.738c-0.624,0.073-0.725-0.684-1.402-0.411c-0.446,0.18-0.619,1.332-1.03,1.398
		c-1.441,0.231-2.016,0.117-2.062-1.661c-0.985-0.023-3.273,1-3.992,0.03c-0.717-0.967,0.872-2.506,0.498-3.818
		c-0.188-0.658-1.172-0.874-1.461-1.494c-0.205-0.439-0.184-1.398-0.233-1.493c-0.512-0.984-1.3-2.034-1.774-3.007
		c-1.235-2.534-1.933-3.198-4.494-4.762c-1.618-0.987-1.284-0.859-2.319-2.244c-0.67-0.897-0.665-2.149-1.931-1.75l0.364-0.24
		c-0.242,0.734-0.394,1.454-0.426,2.121c-0.067,1.374,1.189,2.447,1.526,3.779c0.386,1.529-0.547,3.145-1.842,4.044
		c-1.296,0.899-2.887,1.236-4.431,1.553c-2.836,0.583-5.694,1.168-8.589,1.175c-7.67,0.02-15.124-3.982-22.57-4.927L363,782z"
      />
    </a>

    <a (click)="SelectCode('TD')">
      <path
        [class.selected]="IsSelected('TD')"
        id="TD"
        d="
		M417.5,434.75c0.511-2.052-0.352-2.712-0.818-4.556c-0.566-2.236,0.402-3.591,1.257-5.249c0.576-1.117,1.266-2.533,2.061-3.501
		c1.14-1.388,4.334-2.152,3.536-4.395c1.342-1.205,4.912-3.85,6.718-4.054c2.566-0.289,5.462,2.126,6.451-1.234
		c0.139-0.473-0.92-1.326-0.669-2.03c0.154-0.431,1.189-0.816,1.475-1.182c0.279-0.358,1.265-1.655,1.676-1.806
		c1.044-0.384,1.868,0.572,2.999,0.218c0.906-0.283,2.515-2.332,3.342-2.956c-0.785-1.159-2.743-1.583-3.348-2.995
		c-0.412-0.962,0.199-1.634,0.073-2.505c-0.139-0.96-1.015-1.912-0.967-2.798c0.131-2.435,3.103-2.645,4.474-4.021
		c1.015-1.018,1.682-4.204,3.539-1.97c5.463-2.518,1.99,2.354,5.949,2.301c1.222-0.016,3.05-2.135,3.268-3.031
		c0.07-0.289-1.883-3.352,1.169-1.775c0.292-0.564,0.853-1.027,1.077-1.624c-0.013,0.214-0.038,0.448-0.013,0.661l0.307-1.437
		c-1.581-1.433-3.059-2.956-4.305-4.694c-3.257-4.544-4.655-10.201-7.837-14.798c-0.681-0.984-1.46-1.931-2.475-2.566
		c-1.288-0.806-2.839-1.04-4.33-1.334c-3.841-0.758-7.444-2.185-10.857-4.036L431.25,358c-1.33,0.035-1.131,1.705-2.051,2.486
		c-1.275,1.083-2.059,0.315-3.699,0.257c-3.692-0.131-5.516,2.251-6.81,5.457c-0.836,2.069,0.476,2.435-2.146,2.237
		c-1.552-0.117-2.645-1.337-4.562-0.437c-1.033,0.485-2.329,1.953-3.287,2.694c-1.284,0.992-2.946,1.836-1.795,3.874
		c-1.934,1.793-4.667,2.747-5.402,5.164c-0.416,1.367-1.579,5.296-0.768,6.343c0.626,0.809,3.484,0.353,3.812,1.677
		c0.354,1.429-1.661,1.779-2.568,2.506c-2.246,1.802-2.774,3.944-5.72,3.987c-1.422,0.021-3.234-0.811-4.512-0.694
		c-1.737,0.158-1.658,1.145-2.482,1.962c-1.057,1.048-2.02,1.614-3.419,1.973c-1.765,0.453-2.669-0.345-3.543,1.515
		c-0.309,0.657-0.174,2.527-0.105,3.25c0.19,1.994,0.059,1.082,1.25,2.305c0.894,0.919,1.932,1.337,2.312,3.001
		c0.327,1.433-0.368,2.419-0.325,3.749c0.129,3.968,1.645,1.208,3.813,1.496c1.101,0.146,2.553,1.749,3.506,2.186
		c1.163,0.533,2.125,0.349,3.011,1.265c1.369,1.414,0.935,4.257,3.177,5.311c1.944,0.914,4.431-0.923,6.28,0.427
		c-1.685,4.261,2.444,2.974,2.593,5.762c0.1,1.875-2.528,3.578-2.335,5.462c0.162,1.578,1.905,2.046,3.524,2.788l-0.155,0.145
		c0.243-0.525,0.528-1.015,1.155-1.339c3.553-1.836,1.004,2.776,3.218,3.432c1.378-0.91,2.056-3.192,3.719-3.618L417.5,434.75z"
      />
    </a>

    <a (click)="SelectCode('TF')">
      <path
        [class.selected]="IsSelected('TF')"
        id="TF"
        d="
		M440.115,657.354c-0.201,0.088-0.409,0.2-0.627,0.341c-1.854,1.197-1.544,3.201-3.226,4.672c-1.598,1.398-4.266,1.981-6.275,2.382
		c-4.219,0.841-8.629,3.967-9.237,8.501l0.013-0.014c-1.766-0.866-3.055,0.642-3.567-2.736c-0.52-3.425,0.587-3.463,3.055-4.751
		c1.531-0.799,2.889-2.558,4.056-3.931c0.583-0.686,2.038-2.033,0.962-3.086c-0.764-0.747-1.993,0.518-2.981,0.036
		c0.298,0.146-2.139-2.839-2.105-2.768c-0.759-1.596,0.332-0.909,0.38-2.438c0.047-1.514-0.041-0.717-0.617-2.001
		c-0.543-1.211-1.362-0.177-0.769-1.88c0.441-1.265,4.544-3.414,4.03-4.889c-0.389-1.116-2.115-0.491-2.46-1.794
		c-0.387-1.461,1.091-1.48,1.266-2.487c0.203-1.163-0.85-2.074-0.335-3.262c0.416-0.96,1.54-1.38,2.079-2.25
		c0.25-0.404-0.167-1.23,0.051-1.693c0.201-0.427,0.832-0.475,0.95-0.744c0.235-0.536,0.745-0.805,0.812-1.463L424.75,631
		c0.95-0.744,1.179,0.101,2.244,0.306c1.372,0.264,1.866-0.055,2.938-0.123c1.345-0.086,5.007-0.877,5.818,0.068l-0.712-0.463
		c-0.068,0.98-0.131,2.04,0.181,2.913c0.18,0.503,1.568,0.081,1.561,1.064c-0.004,0.492-0.807,0.64-0.975,0.985
		c-0.345,0.706-1.203,1.203-1.61,1.982c-0.675,1.29,0.055,2.496-1.419,3.505c0.837,1.352,2.322,1.988,3.17,3.514
		c0.755,1.36,1.501,2.609,2.317,3.98c0.591,0.993,1.974,3.151,2.243,4.27c0.37,1.539-1.516,3.464-0.005,4.25L440.115,657.354z"
      />
    </a>

    <a (click)="SelectCode('TN')">
      <path
        [class.selected]="IsSelected('TN')"
        id="TN"
        d="
		M569.5,771.25c0.862,0.443,1.649,1.04,2.056,1.919c0.675-2.074,3.129-2.012,4.689-1.856c1.47,0.147,1.245-0.134,2.518,0.924
		c0.517,0.43,0.12,1.275,0.587,1.545l-0.348,2.163c-0.096,0.453-0.393,2.974-0.318,3.31c0.271,1.22,0.856,1.347,1.817,2.25
		c0.475,0.446,1.467,1.841,2,2.258c1.803,1.409,3.446,0.214,5.75,0.543c2.788,0.398,4.552,1.138,7.494,0.394
		c1.16-0.293,2.342-0.846,3.512-1.213c1.047-0.328,1.681-0.913,2.55-1.243c1.945-0.738,3.589-0.002,5.694-0.744l0.356,0.229
		c0.229,0.455,0.755,0.834,1.333,1.221c0.631,0.423,1.824,0.19,2.578,0.737c0.696,0.505,0.854,1.408,1.434,2.007
		c1.62,1.672,4.097,2.275,3.048,5.555c-0.612,1.913-5.144,2.874-3.698,5.213c1.307-0.571,2.806,0.287,3.199,1.538l0.013,0.023
		c-0.468,0.261-0.923,0.545-1.364,0.858c-3.378,2.399-5.487,7.403-3.015,10.728c-1.732-0.631-3.526-0.547-5.234-1.021
		c-1.544-0.428-2.966-1.722-4.65-1.601c-1.668,0.122-2.935,2.305-4.097,3.33c-1.51,1.332-3.298,2.742-5.151,3.544
		c-1.769,0.766-2.332,0.417-4.244,0.368c-2.231-0.056-4.589,0.645-6.664,1.71l-0.557-0.703c-0.337-0.05-0.758,0.056-1.195,0.294
		c0.307-0.848,0.793-2.426,0.837-3.336c0.037-0.764,0.01-3.143-0.731-3.7c-0.742-0.558-2.912-0.531-3.937-0.256
		c-1.478,0.396-2.449,2.049-3.73,1.98c0.035-1.438-0.753-2.574-1.076-3.93c-1.621-0.027-2.646,0.654-4.163,0.007
		c-0.054,1.37-0.86,2.054-2.294,1.706c-1.829-0.444-0.742-0.678-1.244-2.25c-0.637-1.995-1.96-3.125-3.765-3.135l0.01,0.135
		c-0.271-2.747,1.305-2.844,2.5-4.763c0.979-1.573,1.981-3.843,2.006-5.743c0.03-2.276-1.549-3.411-2.268-5.439
		c-0.31-0.875-0.535-2.633-0.237-3.56c0.295-0.916,1.511-1.215,1.704-2.051c0.09-0.391-0.655-2.689-1.006-2.95l-0.449,0.006
		c-0.257-1.483-0.069-3.027-0.143-4.494l0.143-0.006c0.174,0.229,2.035,0.649,2.232-0.975c1.167,0.57,1.721,1.047,2.967,0.73
		c-0.28,0.071,2.242-1.927,2.063-1.687c0.155-0.209,0.445-1.284,0.294-1.123L569.5,771.25z"
      />
    </a>

    <a (click)="SelectCode('TQ')">
      <path
        [class.selected]="IsSelected('TQ')"
        id="TQ"
        d="
		M350.5,860.75c-0.325-0.711-0.317-1.766-0.073-2.657c0.394,0.208,0.886,0.163,1.274,0.37c1.262-1.312,3.583-1.451,5.256-1.756
		c1.427-1.377,0.221-1.556-0.406-2.765c-0.439-0.847-0.169-1.205-0.802-1.96c-0.173-0.206-1.239,0.062-1.573-0.214
		c-1.1-0.911-3.555-6.269-3.193-7.531c0.288-1.005,1.849-1.139,2.274-2.231c0.414-1.065-0.25-2.629-0.006-3.756
		c0.454-2.094,3.605-2.979,2.968-5.213c-1.963-0.192-8.46,0.199-8.262-2.505l-0.456,0.218c0.973-1.817,2.548-3.666,4.5-3.95
		c0.414-0.06,0.877,0.756,1.237,0.711c0.612-0.076,1.32-0.724,1.713-0.768c0.356-0.039,0.475-0.757,1.043-0.762
		c0.818-0.007,0.663,0.939,1.195,1.086c2.589,0.711,3.667,0.249,5.05,2.444c0.429,0.68,0.945,1.886,1.507,2.45
		c0.703,0.705,1.714,0.035,2.298,1.511c1.803-1.001,1.012-2.55,3.262-1.735c0.952,0.345,2.335,2.311,2.638,2.957
		c0.478,1.019-0.481,1.279,1.049,2.617c0.797,0.697,2.108,0.717,1.757,1.188l0.501,0.043c-0.362,0.714-0.779,1.413-1.162,2.081
		c-1.215,2.119-1.936,5.242,0.053,6.66c-1.198,0.591-2.396,1.182-3.594,1.774c-1.076,0.999,1.242,1.999,2.3,3.017
		c1.103,1.061,0.67,3.002-0.372,4.123c-1.043,1.121-2.513,1.727-3.757,2.619c-3.057,2.193-4.604,6.297-3.757,9.963
		c-2.737-1.215-5.973-1.252-8.737-0.099c-2.509-1.223-2.181-5.124-4.237-7.011c-0.721-0.662-1.388-1.023-2.027-1.201L350.5,860.75z"
      />
    </a>

    <a (click)="SelectCode('TR')">
      <path
        [class.selected]="IsSelected('TR')"
        id="TR"
        d="
		M223.5,892.5c-0.124-2.062,3.214-2.46,2.456,0.206c-0.943,0.536-2.129,1.421-2.986,0.543c0.383-0.395,0.518-1.182,0.78-1.499
		 M219.75,894.5c-0.785,0.929,0.233,2.161,1.449,1.449C222.131,895.405,220.812,893.243,219.75,894.5z M223.774,889.743
		c0.249-2.028-2.808-1.767-3.524-0.243C220.56,891.008,223.533,891.702,223.774,889.743z M225.25,888c0.1,0.193,0.84,0.657,1.5,0.75
		 M301.5,866.25c-0.572-2.038,1.652-8.05-2.206-7.288c-0.468-1.981-1.431-4.212-0.8-5.969c0.231-0.645,1.239-1.753,1.562-2.437
		c0.35-0.742,0.622-1.771,0.912-2.499c-2.36-0.127-1.753-2.168-3.719-2.819c-1.771-0.586-3.172,1.075-4.999,0.012l-0.008,0
		c-0.07,1.927-0.53,3.81-1.811,4.699c-2.527,1.754-4.138,0.587-5.087,4.481c-0.254,1.041-0.281,2.219-1.008,3.006
		c-0.535,0.58-1.348,0.82-1.942,1.339c-0.547,0.477-0.869,1.153-1.28,1.752c-1.409,2.057-3.801,3.155-5.909,4.487
		c-2.108,1.332-4.182,3.307-4.205,5.801c-1.374-1.875-3.477-3.986-5.641-3.137c-1.349,0.529-1.844,1.84-2.785,2.805
		c-1.605,1.647-1.704,0.923-3.306,1.215c-3.51,0.641-3.61,4.166-2.045,6.538c0.405,0.614-2.416,3.319,0.506,4.258
		c1.168,0.375,5.379-1.973,6.707-2.392c0.41-0.129,0.863-0.295,1.047-0.684c0.375-0.793-0.66-1.526-0.859-2.38
		c-0.241-1.029,0.893-1.958,1.949-1.934c1.594,0.036,4.014,1.272,5.685,1.68c1.851,0.452,3.84,1.052,5.246,2.409
		c1.557,1.505,1.146,3.982,1.637,5.884c0.724,2.803,2.19,2.935,4.854,3.967c-0.668-0.259,0.746-3.596,1.256-3.9
		c1.461-0.869,2.073,0.361,3.423-0.955c0.502-0.49,1.865-3.157,1.768-3.882c-0.213-1.593-1.863-2.129-2.906-2.987
		c0.183,0.151,3.1-4.496,3.445-4.895c0.187,1.023,0.374,2.046,0.561,3.068c0.486-1.331,0.971-2.661,1.456-3.992
		c3.221,1.3,1.704-1.756,3.946-2.959c-0.334,0.183,1.069,0.456,1.243,0.42c0.572-0.117,1.372-1.562,1.929-1.958
		c0.639-0.455,1.031-0.63,1.486-0.713L301.5,866.25z"
      />
    </a>

    <a (click)="SelectCode('TS')">
      <path
        [class.selected]="IsSelected('TS')"
        id="TS"
        d="
		M497.75,507.5c0.092-0.272-1.011-3.442-1.439-4.25c-0.598-1.129-1.62-1.715-2.561-2.487c-1.573-1.29-0.964-0.988-2.94-1.513
		c-1.056-0.28-1.601-0.346-2.51-0.764c-0.331-0.152-0.448-0.809-0.857-0.93c-1.259-0.372-2.594,0.776-3.525,0.21
		c-2.431-1.476,1.208-3.864,1.343-5.517c0.064-0.782-0.681-2.642-1.011-3.306c-0.265-0.533,0.284-1.085-0.233-1.516
		c-0.63-0.526-1.086,0.395-1.657,0.133c-2.71-1.244-2.798-1.915-2.599-5.012c0.113-1.751-0.309-1.865,0.557-3.494
		c0.566-1.065,1.54-1.769,1.919-2.943c0.408-1.265,0.875-1.326,0.139-1.494L482.25,475c0.175-1.151,0.816-2.322,1.702-3.048
		c0.115-0.094,2.211-1.444,2.298-1.464c0.756-0.173,1.849,0.228,2.75,0.011c1.239-0.298,1.342-1.351,2.5-1.748l0.779,0.035
		c0.401,1.076,0.812,2.147,1.234,3.215c1.495,3.783,3.246,7.666,6.423,10.205c5.134,4.103,12.505,3.637,18.557,6.198
		c0.727,0.308,1.428,0.656,2.106,1.039l0.152,0.807c0.225,0.236,1.009,1.868,0.505,2.744c-1.023,1.778-1.619-0.317-3.255-0.299
		c-1.807,0.02-1.742,1.666-2.988,2.072c-0.88,0.287-2.38-0.565-3.225-0.737c-0.322,2.835-3.336-1.058-4.289-1.229
		c-2.092-0.376-2.924,2.437-4.248-0.326c-1.853,1.591-0.859,3.05,0.061,4.713c0.337,0.609,1.19,1.697,1.452,2.311
		c0.757,1.772,1.009,0.875-0.008,2.562c-0.287,0.475-1.403,0.532-1.717,0.987c-0.333,0.482,0.392,1.131,0.23,1.457
		c-0.394,0.793-0.884,1.746-1.268,2.495c-0.449,0.875,0.377,1.648-0.939,2.066c-1.26,0.401-1.185-1.016-1.861-1.31
		c-0.777-0.339-1.271-0.375-1.613-0.25L497.75,507.5z"
      />
    </a>

    <a (click)="SelectCode('TW')">
      <path
        [class.selected]="IsSelected('TW')"
        id="TW"
        d="
		M545.462,765.027c-0.377-0.221-0.893-0.325-1.668-0.239c-0.427,1.963-4.987,2.952-6.794,3.462
		c-2.246,0.634-1.454-0.066-3.237-0.811c-1.248-0.522-3.12-1.267-2.801,1.024c-0.578-0.025-1.307,0.183-1.887,0.025
		c0,0,0.487-0.675,0.362-0.925s-1.871-0.817-1.871-0.817s0.267-2.762,1.897-2.782c-0.204-1.689,0.106-2.429,1.531-2.919
		c0.568-0.195,1.138,1.055,1.749,0.924c0.448-0.096,1.048-1.349,1.244-1.718l0.263-0.25l-0.249,0.225
		c2.177,1.573,4.169-0.332,5.986-1.224c0.153-0.075,0.788-0.14,1.507-0.176l0.256-0.075l-0.005,0.062
		c0.959-0.04,1.993-0.002,2.517,0.176c1.127,0.382,1.184,1.688,2.738,1.762l-0.448-0.01l-0.191,0.113
		c-0.906,0.564-1.283,1.266,0.095,1.941c-0.255,0.712-0.574,1.714-0.706,2.206L545.462,765.027z"
      />
    </a>

    <a (click)="SelectCode('UB')">
      <path
        [class.selected]="IsSelected('UB')"
        id="UB"
        d="
		M532.5,749.5c4.703-1.616,2.839,0.058,4.999,3.25c1.135,1.678,1.091,1.308,2.946,1.445c1.301,0.096,3.294-0.534,3.461,1.511
		c-2.112,0.285-2.69,0.987-2.157,3.044l-0.256,0.075c-0.608,0.034-1.163,0.099-1.507,0.176c-1.974,0.446-3.81,2.797-5.986,1.224
		L534.25,760c-0.208-0.329-0.349-0.66-0.525-0.999c1.024-1.145,0.332-2.459-0.288-3.695c-0.897-1.79-1.22-1.574-1.194-3.562
		c0.007-0.556,0.262-1.4,0.326-2.152L532.5,749.5z"
      />
    </a>

    <a (click)="SelectCode('W')">
      <path
        [class.selected]="IsSelected('W')"
        id="W"
        d="
		M555.5,758.5c-0.227-0.75-0.903-2.211-1.57-2.326l-2.669,0.52c-2.145-0.567-5.555,0.019-7.26-0.944l-0.117-0.244
		c0.01,0.064,0.018,0.131,0.023,0.201c-2.112,0.285-2.69,0.987-2.157,3.044l-0.005,0.062c0.959-0.04,1.993-0.002,2.517,0.176
		c1.127,0.382,1.184,1.688,2.738,1.762l-0.448-0.01c1.039-0.581,2.587-0.993,3.154-1.034c0.746-1.618,3.328-1.619,4.794-1.206H555.5
		z"
      />
    </a>

    <a (click)="SelectCode('WA')">
      <path
        [class.selected]="IsSelected('WA')"
        id="WA"
        d="
		M437,607.5c0.504-2.063,1.883-3.304,2.006-5.5c0.095-1.698,0.584-4.875,0.257-6.513c-0.454-2.271-2.695-2.832-4.776-3.237
		c-3.139-0.612-4.111,0.112-5.037-3c-0.19-0.639-0.487-2.568-0.89-3.006c-1.223-1.331-1.379-0.034-2.81-0.233
		c-2.667-0.371-2.701-1.47-5.5-0.761c-0.816,0.207-2.135,0.845-2.999,0.763c-1.644-0.156-1.493-0.83-2.746-1.462
		c-1.639-0.826-4.395-2.111-4.511,0.199c-0.043,0.866,0.969,3.976,1.431,4.812c1.298,2.346,3.001,1.51,1.324,3.875
		c-1.032,1.455-2.394,1.648-1.769,3.874c0.137,0.486,1.067,1.029,1.28,1.689c0.331,1.027-1.218,0.916-0.261,1.75l-0.51-0.234
		c0.637,0.484,1.019,1.066,0.955,1.813c-0.097,1.131-0.771,1.542-1.694,1.534l-0.001,0.387c-2.589,4.154,2.981,1.792,4.798,3.052
		L416,608c0.524-1.682,1.568-0.361,2.5-0.807c1.819-0.87,0.782-0.4,1.181-1.931c0.183-0.7-0.211-2.058,0.632-2.712
		c0.882-0.684,1.863,0.239,2.942-0.546c2.185-1.589,0.66-4.392,4.245-3.524c0.188,0.045,2.61,1.299,2.705,1.507
		c0.357,0.779-1.014,1.501-0.773,2.581c0.143,0.64,1.465,1.13,1.769,1.677c0.51,0.919,0.113,2.698,0.614,3.199
		c0.95,0.951,1.566,0.235,2.741-0.006c1.475-0.303,1.668-0.508,2.163-0.23L437,607.5z"
      />
    </a>

    <a (click)="SelectCode('WD')">
      <path
        [class.selected]="IsSelected('WD')"
        id="WD"
        d="
		M547.5,747c-0.706-1.464,0.446-2.456,0.206-3.956c-0.513-0.029-0.843-0.376-1.419-0.331c0.023-0.619-0.385-1.024-0.325-1.675
		c-2.088-0.436-3.99,2.119-5.468,1.212c-1.308-0.802-0.826-4.338-3.406-2.737c0.196-0.012,0.473-0.064,0.661-0.013l0.451-0.063
		c-1.361,1.145-2.062-0.489-3.451-0.381c-2.064,0.161-1.099,0.43-1.794,1.943c-1.229,2.677-1.231,4.341-0.456,7v1.5
		c1.428-0.491,2.251-0.678,2.765-0.612l0.235-0.388c0.16,0.065,0.377,0.275,0.506,0.399c0.25-0.46,0.645-0.602,0.787-1.106
		c1.315-0.568,1.298,0.583,2.006,0.658c1.567,0.165,1.399-0.068,2.964-0.651c2.031-0.756,3.641-1.366,5.213,0.713L547.5,747z"
      />
    </a>

    <a (click)="SelectCode('WF')">
      <path
        [class.selected]="IsSelected('WF')"
        id="WF"
        d="
		M488.75,578c0.406-0.819,3.877-2.358,5.013-3.237c1.169-0.905,2.687-2.088,2.699-4.225c-0.496,0.079-1.196-0.186-1.68-0.081
		c0.417-1.832,1.064-2.914,3.193-3.25c-0.286-1.44-1.452-2.264-1.942-3.419c2.88,0.489,2.382-2.854-0.239-2.244
		c-1.046,3.083-2.836,0.017-4.106-0.48c-1.117-0.437-4.385-1.048-5.411-0.314c3.978,3.021-2.295,3.261-4.089,2.549
		c-1.764-0.701-2.309-0.86-4.187-0.793c-0.927,0.033-1.37-0.148-2.456,0.05c-0.146,0.027-0.976,1.036-1.493,1.162
		c-0.359-1.915-1.49-2.241-3.276-1.93c1.255,3.182-1.698,2.66-3.775,3.212l-0.587-0.509c1.29,0.367,1.448,2.148,2.144,3.496
		c0.807,1.564,2.108,3.338,2.231,5.225c2.1,0.175,4.228-1.082,5.212,1.538l-0.007-0.002c0.116-0.34,0.402-0.594,1.257-0.754
		c1.213-0.227,2.24,1.028,3.493,0.566c1.368-0.504,1.046-1.337,2.258-1.81c0.848-0.331,2.563-0.008,3.466,0.031
		c-0.166,0.281-0.194,1.078-0.448,1.436c1.567-0.116,1.81,1.257,2.536,2.277c0.212,0.297,0.31,0.664,0.423,1.018L488.75,578z"
      />
    </a>

    <a (click)="SelectCode('WN')">
      <path
        [class.selected]="IsSelected('WN')"
        id="WN"
        d="
		M414.75,584.75c0.898-2.196-2.209-3.103-3.751-4.193c-0.883-0.625-2.359-0.101-1.699-2.007c0.223-0.643,1.547-1.164,2.107-1.349
		c-2.564-2.393,1.879-3.242,3.506-4.139c-0.09-0.063-0.176-0.13-0.258-0.201l0.095,0.39c0.397-0.407,0.95-0.602,1.437-0.713
		c0.837,1.776,2.225,1.47,3.8,2.22c1.849,0.881,2.503,2.131,3.575,3.944c0.748,1.265,1.954,3.121,2.988,3.749
		c0.52,0.316,1.871,0.045,2.149,0.601c0.329,0.658-0.787,2.005-0.698,2.949l-0.194-0.326c-0.627-0.206-0.983,0.486-2.056,0.337
		c-2.667-0.371-2.701-1.47-5.5-0.761c-0.816,0.207-2.135,0.845-2.999,0.763c-1.297-0.123-1.477-0.569-2.11-1.062L414.75,584.75z"
      />
    </a>

    <a (click)="SelectCode('WR')">
      <path
        [class.selected]="IsSelected('WR')"
        id="WR"
        d="
		M463.75,707.5c0.153-1.729-1.437-2.619-2.306-3.689c-1.228-1.51-2.253-2.452-3.499-3.811c-0.811-0.884-0.717-1.648-1.39-2.507
		c-1.072-1.369-0.105-0.578-1.549-0.987c-0.827-0.234-1.845,0.3-2.573-0.187c-0.79-0.528-0.489-1.119-0.933-1.568
		c-1.167-1.179-2.098-2.688-3.293-4.237c-0.796-1.032-1.501-0.47-1.711-1.765c-0.14-0.862,1.238-1.994,1.023-2.755
		c-0.465-1.644-3.893-1.806-4.73-0.257c-0.884,1.636,2.251,4.339-0.3,5.542c-1.216-1.932-2.368-0.69-4.044-0.83
		c-2.247-0.188-2.031-1.267-3.627-2.511c-1.633-1.272-3.474-0.948-5.331-0.994c-2.086-0.051-3.273-1.168-5.254-1.35
		c-1.106,2.216-2.208,0.093-3.495,0.888c-0.787,0.486-1.32,3.077-1.238,4.018l-0.013-0.035c2.011,0.777,0.597,2.826,1.952,3.845
		c0.968,0.729,4.396,0.168,5.565,0.148c1.558-0.027,2.708-0.637,2.743,1.786c0.02,1.361-1.352,3.446-1.734,4.999
		c-0.568,2.307-1.358,2.609,0.236,3.958c0.564,0.477,1.616,0.269,2.311,0.986c0.67,0.693,0.373,1.653,0.908,2.318
		c2.177,2.705,4.597,2.768,4.243,6.957l0.038,0.078c0.243-0.118,0.475-0.218,0.69-0.284c1.409-0.434,2.644-0.533,4.023-0.294
		c-0.925-4.126,4.427-0.324,3.802-3.661c4.72-1.766,6.722,2.148,10.541,3.136c3.324,0.861,9.941,2.763,9.262-2.881
		c-0.095-0.793-1.125-1.224-1.036-2.044c-0.015,0.139,0.411-0.604,0.809-1.356"
      />
    </a>

    <a (click)="SelectCode('WS')">
      <path
        [class.selected]="IsSelected('WS')"
        id="WS"
        d="
		M449,656.75c2.319-2.181,2.71-6.43,5.194-8.323c1.268-0.967,1.856,0.221,2.306-1.677c0.331-1.398-0.634-2.412-1.219-3.513
		c1.188-1.218,2.789-0.871,4.224-1.231c1.875-0.47,2.186-1.68,3.3,0.494c0.379,0.739,0.335,1.199,0.457,2
		c0.101,0.662,0.519,2.191,0.56,2.742c0.155,2.067-1.415,2.867-1.796,4.702c1.364,0.747,4.056,1.009,5.486,0.874
		c1.238-0.117,1.822-0.669,2.611-0.559l0.459,0.725c-0.079,0.184-0.123,0.424-0.121,0.728c-3.899-0.778-1.344,2.847-1.888,4.349
		c-0.499,1.379-4.471,3.773-5.574,4.189c-1.336,0.503-1.983-0.148-3.199,0.994c-0.711,0.668-0.751,1.946-1.613,2.694
		c-1.577,1.37-4.075,1.754-5.938,3.062l-1.5,0.25c0.773-0.318,1.163-4.308,1.306-5.25c0.293-1.931,0.592-4.224-0.736-5.818
		c-1.044-1.254-1.756-1.617-2.389-1.57L449,656.75z"
      />
    </a>

    <a (click)="SelectCode('WV')">
      <path
        [class.selected]="IsSelected('WV')"
        id="WV"
        d="M422,680
		c3.687-1.646,2.977-4.813,7.526-3.007c1.093,0.434,2.321,1.625,3.474,1.964c1.66,0.487,3.378-0.731,4.962-1
		c0.094-2.152-0.143-3.683,0.307-5.719c0.321-1.455-0.37-1.507,0.908-2.418c1.459-1.04,2.061-0.081,3.316-0.007
		c1.162,0.068,1.257,0.713,2.512-0.045c1.645-0.994-0.202-1.691,1.995-1.774c0.702-0.026,1.719,1,2.5,1.017
		c0.469,0.01,0.934-0.493,1.442-0.751l0.506-0.492c0.326-1.336,0.517-3.169,0.608-3.768c0.293-1.931,0.592-4.224-0.736-5.818
		c-2.785-3.344-3.207-0.349-6.069-0.159c-2.046,0.136-3.302-1.917-5.763-0.327c-1.854,1.197-1.544,3.201-3.226,4.672
		c-1.598,1.398-4.266,1.981-6.275,2.382c-4.219,0.841-8.629,3.967-9.237,8.501l0.013-0.014c0.257,0.126,0.524,0.302,0.8,0.551
		c2.129,1.917,0.016,4.42,0.439,6.712L422,680z"
      />
    </a>

    <a (click)="SelectCode('YO')">
      <path
        [class.selected]="IsSelected('YO')"
        id="YO"
        d="
		M549.779,544.296c-0.524-1.118-0.973-2.266-1.278-3.462c-1.09-4.273,1.121-6.811,1.732-10.692c1.24,0.19,2.792-0.214,3.283-1.529
		c-2.048-1.832-4.096-3.664-6.144-5.497c-4.47-6.483-8.94-12.966-13.411-19.45c-3.668-5.32-7.614-10.872-13.114-14.082l-0.096,0.664
		c0.225,0.236,1.009,1.868,0.505,2.744c-1.023,1.778-1.619-0.317-3.255-0.299c-1.807,0.02-1.742,1.666-2.988,2.072
		c-0.88,0.287-2.38-0.565-3.225-0.737c-0.322,2.835-3.336-1.058-4.289-1.229c-2.092-0.376-2.924,2.437-4.248-0.326
		c-1.853,1.591-0.859,3.05,0.061,4.713c0.337,0.609,1.19,1.697,1.452,2.311c0.757,1.772,1.009,0.875-0.008,2.562
		c-0.287,0.475-1.403,0.532-1.717,0.987c-0.333,0.482,0.392,1.131,0.23,1.457c-0.394,0.793-0.884,1.746-1.268,2.495
		c-0.449,0.875,0.377,1.648-0.939,2.066c-1.26,0.401-1.185-1.016-1.861-1.31c-3.107-1.355-1.692,2.125-4.138,1.43
		c-2.04-0.579-2.624-3.607-4.819-0.944c-0.816,0.991-4.896,8.563-6.788,3.3c-2.711-0.617-3.167,0.851-1.732,2.656
		c-0.237,0.018-0.777,0.318-1.186,0.339c-0.151,3.404,1.546,5.151,2.418,7.956c0.143,0.462-0.722,1.286-0.418,2.019
		c0.253,0.609,1.666,0.69,1.924,1.294c0.412,0.961-0.377,3.41-0.963,4.168c-1.374-0.72-2.343,0.591-1.962,1.987
		c3.249-0.699,10.345,4.112,5.963,7.289l-0.074,0.039c1.886,0.979,2.68,4.383,5.099,4.974c2.84,0.694,2.298-0.124,3.989,1.723
		c0.591,0.645,2.103,1.794,2.46,2.757c-1.1,1.068-3.074,1.939-4.441,1.544c3.19,2.592,5.303,1.55,3.911,5.963
		c-0.202,0.64,0.211,1.49,0.011,1.944c-0.233,0.527-1.49,0.777-1.529,0.982c-0.237,1.24,1.193,2.544-0.177,3.323l0.5,1
		c-0.401-0.961,5.499,2.189,6,2.198c0.892,0.016,1.383-1.219,2.695-1.448c1.4-0.244,3.295,0.587,4.505,0.967
		c1.187-2.782-1.809-2.08-2.2-3.719c-0.358-1.503,0.536-0.711,1.444-1.193c1.065-0.566,0.766,0.888,1.806-0.806
		c1.359-2.213-0.347-3.848,2.994-3.438c1.847,0.227,4.805,1.318,5.474,3.131L520,559.25c0.213-0.653,0.938-1.86,1.743-1.949
		c1.181-0.131,1.021,1.379,1.557,1.411c1.25,0.075,3.858-1.483,4.457-2.491c0.723,0.649,1.298,1.231,2.192,1.498
		c0.067-0.584,0.452-0.805,0.399-1.43c0.32,0.039,0.784-0.11,1.113-0.076c0.307-2.379-0.561-4.156-1.212-6.212
		c-0.672-2.122-0.042-5.602,2.768-3.012c0.264,0.243-0.331,1.484,0.02,1.71c0.641,0.414,1.182-0.282,1.505-0.142
		c0.742,0.323,2.802,1.172,3.707,1.206c2.412,0.092,0.954-0.743,2.001-1.762c0.524-0.511,2.106-2.499,2.286-0.039
		c1.322,0.076,2.666,0.029,3.925,0.262c-0.067-1.186-0.341-2.167,0.351-3.199c0.321,0.312,1.068,0.409,1.388,0.687
		c0.328-0.313,0.866-0.604,1.124-0.905c-0.258,0.329-0.533,0.643-0.825,0.943"
      />
    </a>
  </g>

  <g id="Other">
    <a>
      <path
        id="Republic_of_Ireland"
        d="M173.75,441.5c-1.249,0.485-2.824,0.513-4,1c-1.835,0.759-1.428,1.432-2.313,3.25
		c-0.625,1.285-1.87,2.323-2.249,3.689c-0.176,0.634,0.065,1.655-0.133,2.256c-0.036,0.108,0.294,0.747,0.169,1.074
		c-0.184,0.485-1.184,0.041-1.431,0.538c-0.862,1.739-0.083,2.981-0.094,4.706c-0.013,1.979-0.764,2.931-1.938,4.482
		c-1.049,1.385-3.326,2.864-3.768,4.499c-0.437,1.62,0.659,3.116-0.038,4.712c-1.924,0.52-4.015-1.562-6.218-0.468
		c-2.114,1.049-2.801,4.758-5.744,2.961c-1.236-0.754-0.822-1.808-2.494-2.192c-1.897-0.436-1.928,0.047-3,1.561
		c-1.495,2.114-1.996,3.213-0.658,5.169c0.307,0.448,1.275,0.855,1.676,1.25c0.266,0.261-0.111,1.125,0.469,1.462
		c1.545,0.899,1.486-0.173,2.744-0.205c0.833-0.021,5.019,0.576,5.336,0.938c1.737,1.988-2.652,2.743-3.805,3.373
		c-0.673,0.368-2.343,1.316-2.831,1.932c-0.785,0.992,0.068,1.821-1.16,2.711c-1.837,1.332-5.451-0.012-7.284-0.268
		c-2.348-0.327-1.511-0.354-2.226,2.069c-1.147,3.887-4.082,4.174-7.726,4.538c-0.152,0.206-0.468,0.917-0.518,1.156
		c1.412,0.432,2.759,2.722,3.931,3.875c1.466,1.443,2.702,3.164,3.849,4.743c0.907,1.249,2.497,3.312,3.768,4.444
		c1.369,1.219,3.119,0.922,4.494,2.177c1.686,1.537,0.727,3.863,1.615,5.568c1.134,2.18,3.44,2.249,5.573,2.513
		c2.475,0.307,2.623,1.017,4.549,2.244c1.93,1.229,3.568,1.122,4.494,3.706c1.127,0.222,2.851,1.059,3.957,0.981
		c1.917-0.135,1.568-1.243,3.25-1.882c2.696-1.023,3.136,2.883,5.719,2.144c0.02-0.157-0.132-0.436-0.126-0.476
		c2.428,0.499,4.636,0.251,4.912-2.726c0.166-1.783-0.821-2.229,0.307-3.95c0.902-1.377,1.682-1.119,2.938-1.75
		c2.91-1.462,1.523-2.516-0.195-5.207c-1.057-1.656-1.514-1.191-0.748-3.105c0.483-1.207,1.624-1.218,1.232-2.95
		c3.406-0.651,5.911-3.819,7.255-6.999c2.179,0.225,4.086,1.398,5.469,3.218c0.672,0.884,0.713,2.579,1.275,3.249
		c0.687,0.818,1.893,0.365,2.656,1.282c0.424,0.51,0.623,2.534,0.561,3.212c-0.153,1.689-1.203,0.748-0.186,2.694
		c0.404,0.773,1.526,1.199,1.988,1.976c0.688,1.157,0.411,2.493,1.107,3.573c1.377,2.137,3.386,1.488,5.085,1.989
		c2.879,0.849,2.527,2.792,2.57,5.026c0.006,0.303,0.24,1.997,0.198,2.229c-0.144,0.814-1.138,1.323-1.03,2.258
		c0.169,1.454,2.567,3.945,3.969,3.712c0.072-0.935,0.503-0.44,1.043-0.713c1.486,0.451,3.296-0.762,5-1.487
		c1.977-0.842,3.99-0.418,6.468-0.552c-0.248-1.347-0.606-3.017-0.431-4.428c1.12,0.275,0.801,1.538,1.451,1.966
		c1.627,1.072,0.35-0.073,1.513-0.248c1.296-0.195,2.336-1.213,3.249,0.999l-0.049-0.45c2.392,2.809,5.881,4.883,6.586,8.96
		c-5.076,1.791-8.686-0.397-13.16-1.934c-0.433,1.391-0.193,5.984,0.373,7.924c0.994,3.409,2.227,2.905,4.111,5.389
		c3.123,4.116,1.73,7.786,2.363,13.223c0.309,2.65,1.883,5.655,3.013,8.002c1.379,2.866,4.314,4.829,5.027,7.387
		c1.22,4.378-2.861,7.953-0.941,13.428c2.124,0.109,3.431,1.408,3.351,3.498c-1.881,0.456-3.964-0.542-5.324-1.351
		c-1.624,1.616-2.68,3.881-2.023,6.351c3.569-0.101,3.802,2.461,4.424,5.074c0.911,3.828,1.848,6.183,3.121,9.889
		c2.154,6.273-1.646,11.049,1.879,17.111c2.763,4.751-5.346,7.712-7.026,11.963c-0.768,1.943-0.252,4.942-0.863,7.037
		c-0.679,2.33-2.499,4.6-2.998,7c-0.588,2.83,0.809,4.916,0.901,7.5c0.151,4.232-0.152,3.693-2.903,6.986
		c-1.745,2.089-3.879,4.606-4.986,7.151c-1.012,2.328-0.761,5.073-2.088,6.938c-1.348-0.937-2.885-1.633-4.486-2.027
		c1.695,3.719,12.657,13.527,3.488,15.376c-0.706,0.143-4.124-1.519-5.428-1.536c-1.748-0.022-3.352,1.368-5.11,1.119
		c-4.117-0.581-5.159-4.851-10.289-3.058c0.099-0.549,0.096-1.428,0.21-1.884c-4.546,0.691-1.279,3.749-2.524,6.334
		c-0.564,1.172-3.477,2.711-4.41,3.548c-1.277-3.731,3.473-9.68-3.361-11.373c-0.952,2.615,0.725,6.276-1.629,8.923
		c-3.36,3.778-2.999-0.233-6.091-0.41c-5.904-0.337-16.975,0.846-20.908,5.912c-0.992-0.56-3.356-0.693-4.399-0.95
		c-0.649,2.175,0.055,3.462,2.321,3.524c-0.396,2.023-1.321,3.734-1.51,5.839c-2.883,1.035-6.496,4.178-9.301,4.734
		c-3.108,0.616-5.406-2.025-7.05,2.716c0.469,0.579,0.602,1.279,0.873,1.675c-1.859,0.323-3.724,0.939-5.434,1.963
		c-2.024,1.211-2.478,3.715-3.587,4.524c-3.077,2.244-9.447,3.586-10.865-0.887c1.543-0.94,1.179-1.922,1.876-3.05
		c-1.886-1.024-4.093-0.665-5.836,0.498c0.214,1.641,2.686,2.73,2.81,4.003c0.231,2.363-2.33,6.1-4.373,7.325
		c-3.727,2.234-7.923,2.159-10.576,6.086c1.279,1.549,1.338,2.535,0.048,4.099c-1.293-3.607-4.152-3.266-7.434-3.022
		c0.257,1.135-0.401,2.725-0.14,3.849c-2.21,0.728-4.122,0.134-6.202,0.576c-1.078,0.229-1.73-0.792-2.721-0.436
		c-1.281,0.46-1.184,2.341-2.127,2.823c-4.408,2.251-5.659-0.371-9.752,0.213c-3.02,0.431-2.365,2.474-4.597,3.533
		c-1.959,0.929-3.625,0.179-5.552,0.841c-3.254,1.118-6.3,3.225-9.456,4.611c-2.382-2.596,2.099-5.664,0.881-8.508
		c-1.894,0.537-3.945,2.046-5.425,2.932c-1.939,1.162-3.233-0.277-4.487,2.841c-0.483-0.724-1.15-0.796-1.585-1.775
		c-1.871,0.778-3.105,2.539-3.987,4.388c-1.543-1.248-3.808-1.807-5.839-1.539c-0.338-1.987,7.911-6.717,10.291-8.048
		c7.617-4.261,4.78-6.128-2.378-2.251c-1.46,0.791-4.966,4.252-6.5,3.922c-6.015-1.297,3.721-4.436,4.133-4.623
		c3.06-1.389,13.842-6.589,13.303-10.349c-0.934,0.113-2.446-0.571-3.023-0.54c0.384-0.67,0.75-2.032,1.035-2.47
		c-2.968,1.206-5.102,4.141-8.436,5.434c-1.899,0.736-2.752,0.412-4.498,1.502c-1.385,0.864-1.569,3.259-2.714,3.786
		c-1.984,0.912-7.133-0.268-9.787,0.298c-3.589,0.765-7.982,2.854-11.924,2.339c-0.627-4.887,9.104-2.158,6.974-7.237
		c3.224,0.348,5.66-1.751,5.537-5.123c2.209,0.806,8.84-3.436,10.534-4.443c1.139-0.677,0.743-2.41,1.855-3.047
		c1.405-0.805,3.61-0.197,5.108-0.759c2.842-1.066,5.179-3.441,7.739-4.865c-5.255,2.88-11.648,3.529-16.712,5.576
		c-4.214,1.703-8.833,4.134-13.012,5.5c-2.384,0.779-3.337,2.367-6.125-0.415c-2.002-1.997-0.023-5.125-1.438-6.036
		c-2.765-1.78-3.508,3.178-5.498,3.545c-5.184,0.957-0.945-4.326-4.972-4.695c1.202-2.52,2.97-5.711,0.074-7.865
		c1.275,0.224,2.674-0.146,3.86,0.262c1.969-4.793,7.633-8.169,12.526-8.765c0.265,0.253,0.46,0.551,0.585,0.894
		c2.577-1.898,5.461-3.042,7.889-4.966c2.246-1.78,3.682-5.244,6.498-2.424c1.37-0.783,2.287-2.168,2.438-3.586
		c-3.682-1.942-4.704,1.597-7.799,2.45c-3.127,0.862-7.083-0.507-10.137-0.415c-6.273,0.189-11.583,0.58-17.4,3.413
		c-2.709-2.919-2.534-9.37,1.804-10.36c0.508,1.374,1.443,1.501,2.107,2.422c0.296-4.996,6.231-8.363,10.94-9.934
		c-0.418,1.68-1.302,3.403-1.921,4.86c3.631,0.773,5.466-2.459,7.895-4.537c-0.065-0.433-0.226-1.382-0.336-1.812
		c3.323,0.618,2.136,5.109,3.997,7.364c4.033,0.508,8-2.377,12.275-2.513c-4.337-2.902-5.277-0.879-5.735-5.913
		c-0.226-2.482,1.829-7.627-3.526-5.562c-0.545-0.488-1.818-2.235-2.161-2.925c1.83-2.723,11.876-5.326,15.183-4.199
		c1.861-2.284-0.414-4.1,0.468-6.339c1.277-3.243,4.301-2.888,6.911-2.972c5.232-0.169,10.753,0.525,16-0.115
		c5.764-0.702,10.605-3.928,15.728-6.289c4.733-2.181,7.838-2.182,13.145-1.048c-3.213-1.937-12.211-4.221-15.733-2.088
		c1.876-1.281,5.294-7.279,0.833-7.424c-2.529-0.082-3.693,5.084-4.474,6.462c-1.713,3.02-2.833,5.192-6.5,6.524
		c-2.716,0.987-5.138-0.62-6.498,2.924c-1.071-0.339-2.341-1.364-2.924-2.323c0.279-0.34,0.652-0.571,0.884-0.926
		c-4.177,1.388-6.592,2.343-10.847,1.689c-0.531-0.082-0.97-1.327-1.601-1.412c-1.127-0.152-1.546,0.582-2.486,0.547
		c-2.028-0.075-4.285,0.293-5.488,1.381c0.573,0.223,0.912,0.262,1.45,0.56c-1.24,2.691-11.994,5.388-14.842,4.083
		c2.582-2.47,21.363-12.491,17.781-16.062c1.873-2.688,4.772-3.993,7.573-2c1.068-1.123,1.875-2.936,1.936-4.41
		c-0.591-0.006-1.281-0.168-1.87-0.151c1.352-4.319,5.362-6.042,8.006-9.41c-2.214-3.172-5.835,0.188-8.582-2.392
		c5.449-2.798,7.499-15.818,13.011-16.623c1.569-0.229,3.372,0.792,5.413,1.437c0.925-3.71,5.379-2.316,7.601-4.289
		c3.264,4.447,3.772-2.143,4.309-3.644c-2.054,0.055-4.363,0.656-5.27-1.42c2.446-0.545,4.014-2.613,3.895-5.046
		c-5.555,2.161-12.135,3.604-17.974,2.864c-3.042-0.385-5.639-1.792-8.948-1.402c-2.393,0.282-5.538,1.99-7.524,1.061
		c-1.605,2.122-3.966,1.469-6.486,1.375c0.681-1.605,1.909-3.118,2.422-4.836c-0.424-0.306-0.952-0.461-1.411-0.709
		c0.612-0.616,0.767-0.839,1.963-0.988c-0.178-0.306-0.959-0.999-0.965-1.303c0.895-0.01,1.443-0.215,2.185-0.564
		c-1.287-1.985-0.411-4.117,1.238-5.473c-2.461,0.085-13.534,14.693-14.386,4.011c0.417-0.237,0.918-0.008,1.374-0.147
		c-0.266-0.438-0.502-1.745-0.872-2.325c1.088-0.069,5.972-2.528,2.444-3.66c-2.252-0.723-4.369,2.566-6.908,2.583
		c-2.77,0.019-7.898-2.894-11.046-3.602c0.306-1.307,1.201-2.281,2.361-2.883c2.043,1.647,4.685,1.36,5.036-1.577
		c-2.633-1.087-5.962-2.565-5.65-5.889c-1.542-0.095-2.611-1.174-3.918-1.558c2.152-1.803,7.597-1.145,9.967-1.494
		c-0.719-0.385-1.74-1.567-2.418-2.023c2.26-1.809,7.717-0.903,9.97-1.074c0.661-0.556,0.948-1.305,1.426-1.926
		c-3.971-3.424-2.189-9.252-0.739-13.413c5,0.22,11.997-2.872,16.318-1.135c-0.79-2.064-2.864-0.886-4.342-2.839
		c10.616-4.034-4.09-6.9-8.075-6.238c-6.558,1.088-10.531,2.833-14.453-3.902c0.299-0.389,0.734-0.618,1.026-0.971
		c-2.777-4.387-10.369,3.092-12.084-1.503c-2.224-5.961,13.674-5.917,16.508-3.986c2.04,1.391,4.568,4.04,7.15,4.289
		c2.302-2.754-0.91-3.552-1.034-5.913c-0.095-1.816,2.269-4.795,1.297-6.398c-2.436-4.019-5.176,5.88-8.446,0.507
		c0.678-0.662,1.174-6.642,2.368-8.938L28.5,523c0.472-0.435,1.006-0.024,1.06-1.016c-1.878-3.65-5.911-2.513-4.608,1.377
		c-2.985,1.381-1.448,3.945-1.002,6.563c-5.483,1.23-4.268-2.021-2.855-5.45c1.417-3.44,0.692-5.12,1.405-8.474
		c1.305-6.144,9.433-3.322,11.099,1.448c0.948-1.226,1.842-2.954,3.29-3.886c0.216,0.068,1.543,0.482,1.547,0.484
		c-0.517-1.421-1.845-3.016-3.271-4.045c1.215-2.085,6.272-0.98,7.935-0.916c3.836,0.148,7.611-0.147,11.4,0.416
		c2.691,0.4,7.049-0.205,9.5,0.488c3.424,0.968,4.221,4.453,7.452,6.135c-1.82,2.451,0.624,4.726,2.988,5.982
		c0.087,0.337-0.182,0.684-0.105,0.89c1.163-2.758,2.408-8.458,2.74-11.422c3.212-0.339,5.476,0.952,8.449,1.912
		c1.531,0.495,1.21,2.056,3.487,1.911c1.3-0.082,2.967-2.334,3.877-2.436c3.01-0.336,3.898,1.387,6.123,3.526
		c2.402,2.309,2.267,4.154,6.935,3.948c-0.777-2.814-5.499-4.788-3.857-7.723c6.786,1.162,5.8-1.729-0.026-3.326
		c0.278-0.494,0.474-1.727,0.884-2.313c-11.587,1.359,0.783-3.424,2.137-7.002c3.308-0.144,2.137-3.246,4.042-3.945
		c3.096-1.135,2.55,1.352,4.736,1.285c6.094-0.188,7.793-6.378,8.234-10.862c1.297-1.081,5.306-4.962,5.837-6.476
		c-3.12,0.077-7.459,0.864-9.972,2.362c-0.194-0.451-0.356-0.874-0.548-1.36c-2.968,0.003-5.158,2.105-7.413,3.733
		c-2.1-5.602-19.56-0.512-19.549-9.818c0.003-2.278,5.513-4.926,7.585-5.477c2.936-0.781,6.144-1.853,9.317-0.2
		c-0.361-0.397-0.807-0.921-1.206-1.253c2.157,0.538,4.456,1.146,6.824,0.864c-1.842-2.648-6.74-5.258-9.454-6.811
		c2.993-0.501,8.456-0.76,11.48,0.2c-1.249-0.598-2.133-1.966-2.958-2.728c0.683-0.329,1.08-0.822,1.53-1.087
		c-3.945-2.308-1.166-6.473-4.629-7.998c0.354-0.388,0.737-0.977,1.043-1.389c-1.657-0.225-3.298-0.606-4.89-1.135
		c2.279,0.539,4.225-0.32,4.992-2.39c1.672-0.534,4.803-3.117,5.461-5.059c0.704-2.08-2.887-6.958,2.878-6.102
		c-0.022-0.584,0.157-1.286,0.151-1.873c4.637,1.841,9.63,0.294,13.875-1.627c-0.505-1.247-0.277-2.696-0.899-3.823
		c6.643-0.553,4.008,4.389,10.373,5.497c-0.132,0.572-0.13,1.791-0.335,2.339c4.357-1.206-0.004-6.043-1.399-8.073
		c1.148-0.879,2.849-1.403,4.258-1.301c-1.194,7.694,3.873,3.452,5.137,9.37c2.613-0.905,0.592-3.926-1.01-5.534
		c0.632-1.958-0.358-3.131-2.536-3.486c1.262-2.006,5.855-4.884,7.957-3.036c1.754,1.542,0.277,5.883,1.101,8.595
		c1.281,4.216,3.362,3.562,1.388,7.926c-0.85,1.878-5.625,4.686-0.551,5.699c-1.879,2.341-4.276,4.298-4.884,7.309
		c4.045-0.99,6.538-5.97,10.412-7.884c-2.347-2.2-2.113-5.569,1.463-6.098c-0.362-2.829-3.066-4.977-3.45-7.915
		c-0.266-2.036,0.508-8.841,1.516-9.521c3.363-2.271,4.468,2.379,7.41-2.113c2.296-3.506-0.044-4.825-2.374-7.29
		c4.075-0.612,10.609,2.257,12.973,4.913c0.506,2.728,4.914,4.613,7.111,5.887c4.536,2.629,5.176,1.389,0.863,5.002
		c-4.637,3.885-15.64,8.017-11.974,15.611v-2L173.75,441.5z"
      />
    </a>
  </g>

  <g id="Shetland_inset">
    <rect id="Shetland_box" x="500.922" y="42.574" width="89.936" height="118.205" />

    <a (click)="SelectCode('ZE')">
      <path
        [class.selected]="IsSelected('ZE')"
        id="ZE"
        d="
		M572.5,48c-0.078-0.273-0.001-0.454,0.231-0.543c1.837,0.286,1.014,2.215,1.574,3.522c0.795-1.163,2.765-4.282,4.949-1.991
		c1.153,1.209-0.125,4.031-1.661,4.749c0.612,0.961,0.126,1.367,0.037,2.269c-0.003,0.033-0.363,2.234-0.37,2.25
		c-0.764,1.802-2.118,2.671-2.011,4.757c0.06,1.175,0.996,0.804,0.56,2.299c-0.207,0.71-1.476,2.01-2.256,2.151
		c-0.753,0.136-3.703-0.659-4.257-1.205c-1.967-1.943,0.474-6.549,0.706-8.981c0.206-2.158-0.485-3.365,0.495-5.337
		c0.762-1.534,2.872-2.959,2.5-4.689 M563,60c-0.621,1.399-1.601,0.393-1.987,0.72c-1.103,0.935-1.022,1.438-1.263,2.78
		c-0.31,1.724-0.039,3.675-0.051,5.205c-1.893-0.892-3.572,2.86-3.454,4.544c0.064,0.907,0.954,1.583,1.009,2.501
		c0.066,1.101-0.772,1.815-0.717,2.987c0.072,1.534,1.339,3.873,1.657,5.513c0.446,2.293,0.408,3.349,3.268,2.962
		c0.009-0.296,0.074-0.629,0.076-0.924c2.73,0.012,5.031,0.215,4.225-3.564c-0.161-0.754-1.295-1.608-1.03-2.479
		c0.335-1.101,1.724-0.469,2.011-2.251c0.394-2.445-2.08-2.118-2.05-4.05c0.017-1.08,1.106-1.511,0.872-2.706
		c-0.221-1.13-1.669-1.428-1.529-2.955c1.08,0.211,1.777,1.35,2.532,2.179c1.798-0.578,0.52-1.828,0.418-2.949
		c-0.136-1.486,0.347-2.624,0.269-4.013c-0.154-2.727-3.346-5.401-5.006-1.75 M570.5,71.25c0.158,1.409-0.016,8.413,3.962,7.461
		c0.109-1.103-0.551-1.983-0.93-2.923c2.019-0.135,3.234,3.003,5.174,1.411c0.25-0.205,1.128-2.838,1.056-3.199
		c-0.318-1.594-0.543-0.768-1.52-1.311c-0.11-0.061-1.401-0.22-1.806-0.371c-0.886-0.33-0.861-1.158-1.937-1.318
		c-1.045-0.155-4.101,0.586-4.25,0.999 M550.75,70.5c-0.548,0.381-1.089,0.882-1.686,1.3c-1.145,0.801-0.737,0.555-2.064,0.937
		c-3.065,0.884-2.095,0.596-3.194,3.47c-0.607,1.589-3.041,2.784-3.054,4.543c-0.011,1.537,2.249,2.921,2.661,4.169
		c-1.338-0.93-3.993-3.423-3.957-5.125c-0.253-0.122-0.469-0.158-0.706-0.319c-1.062,1.142-0.59,2.704-1.307,3.719
		c-0.871,1.233-2.565,0.899-3.644,2.387c-2.951,4.069,4.706,1.552,6.424,2.225c-0.873,1.123-0.52,2.768,0.762,3.498
		c0.586-0.519,0.529-6.196,1.837-4.072c0.498,0.808-0.117,4.085-0.055,5.268c0.026,0.491-0.798,1.505-0.487,1.951
		c0.617,0.884,1.641,0.103,2.161,0.495c0.982,0.738,1.177,1.379,1.013,3.273c-7.667-3.672,0.268,9.339,1.294,2.606
		c0.515,1.274,0.213,2.111,0.257,3.426c0.034,1.015,0.461,2.346,0.205,3.462c-2.218,0.196-3.636-4.54-6.224-5.186
		c-0.568,0.751-0.427,1.505,0.236,2.161c-1.063,0.275-1.761,0.555-2.53,1.008c-1.499,0.884-1.51,1.034-2.681,1.042
		c-2.284,0.016-3.828-1.062-5.764,1.208c-0.984,1.154-0.79,1.049-0.824,2.562c-0.017,0.74,0.285,2.876,0.819,3.612
		c0.826,1.138,2.229,0.852,3.323,1.577c0.892,0.591,0.775,1.485,1.89,1.848c0.165,1.553,2.196,1.862,2.08,0.026
		c0.589,0.936,1.624,1.76,2.149,2.749c0.354,0.667,0.363,1.938,0.864,2.431c2.262,2.224,3.645-0.595,2.724-2.711
		c2.06,0.388,3.592-1.16,3.269-3.244c1.309-0.679,2.463,0.347,3.462-0.781c0.65,1.468-0.688,3.677-0.311,5.487
		c0.229,1.1,0.77,3.167,1.774,4.001c-2.58,2.751-3.266,5.952-4.955,9.198c2.779,0.915,4.197-3.322,4.023-5.416
		c3.389,0.129,0.002,4.564-0.242,5.779c-0.194,0.966,0.336,2.26-0.039,3.451c-0.286,0.907-0.821,1.956-0.993,2.718
		c-0.36,1.598-0.391,2.517-1.221,4.019c-0.633,1.146-1.571,2.228-1.255,3.556c0.377,1.582,2.308,1.419,2.894,2.145
		c0.935,1.159,1.201,3.066,1.107,4.516c0.559-0.543,0.977-0.266,1.254-1.413c0.195,0.228,0.536,0.505,0.677,0.71
		c-0.089-2.642-0.85-4.942-0.474-7.514c0.17-1.166,1.068-2.523,0.974-3.729c-0.101-1.294-2.069-2.778,0.019-3.488
		c1.352-0.46,1.917,1.441,2.762,1.229c2.242-0.561-0.244-2.062-0.662-2.987c-1.087-2.399,0.127-3.547,2.624-3.062
		c-0.054-1.465-1.839-2.134-2.217-3.749c-0.385-1.646-0.12-4.43,0.486-5.952c0.849-0.532,0.488,0.01,1.063-0.98
		c0.48,0.111,1.19-0.179,1.669-0.069c0.161-1.318-0.74-2.365-1.618-3.268c1.911-1.943,0.235-6.809-2.068-7.246
		c0.675-1.006,0.896-2.281,0.512-3.41c1.199-0.039,4.194,5.676,3.998,0.998c0.892-0.261,1.724-0.224,2.619-0.075
		c-0.409-2.019-5.396-1.544-3.605-4.224c0.888-1.328,5.037,0.187,3.399-2.669c-0.503-0.876-5.696-1.076-4.404-3.269
		c0.827-1.404,3.151,2.636,4.498-0.757c0.3-0.025,0.616-0.055,0.919-0.081c0.522-2.611-1.365-2.986-3.156-2.244
		c-1.348-2.126,2.605-3.614,3.381-5.218c0.512-1.06,1.518-3.566-0.968-2.453c-0.621,0.278-1.471,2.277-2.019,2.891
		c-0.32,0.358-2.193,1.879-2.464,1.779c-1.864-0.691,0.2-2.526,0.032-3.217c-0.342-1.402-1.411-1.261-2.01-2.3
		c-0.605-1.049,0.283-2.26-0.753-3.024c-0.672-0.495-2.16,0.08-2.748,0.512c-1.558,1.142-0.499,0.996-0.75,2.049
		c-0.12,0.503,0.542,0.787,0.247,1.519c-0.295,0.729-1.011,0.484-1.448,0.926c-0.701,0.709-1.334,2.107-1.801,2.574
		c-3.151,3.153-1.511-1.388-0.318-3.305c1.743-2.8,0.931-3.162,0.62-6.2c-0.158-1.537,0.846-1.957-0.581-3.502
		c1.361-1.746,4.03-9.125,2.285-10.79c-0.408,0.32-1.033,1.001-1.261,1.541 M559.75,119.75c-0.117,1.48,1.042,1.649,1.269,2.75
		c0.223,1.079-0.422,1.831-0.268,3c0.118,0.892,0.608,2.34,1.681,2.574c2.287,0.5,0.732-1.334,1.563-2.329
		c1.442-1.727,4.95,0.09,2.019-3.569c-0.336-0.42-1.054-0.376-1.449-0.908c-0.37-0.498,0.029-1.821-0.283-2.049
		c-0.846-0.619-1.971-0.145-2.531,0.562c-1.036-0.889-2.152-0.444-2.25,0.968 M565.5,99.5c-1.129-0.094-0.645,0.841-0.686,1.693
		c0.018-0.384,0.676,2.478,0.474,2.257c2.305,2.526,3.923-0.972,4.955-2.457c0.793-1.141,4.055-3.981,0.464-3.455
		c-1.098,0.161-2.651,1.552-3.706,1.962c-1.118,0.434-2.358-0.617-2.251,1.25 M579.25,92.75c-0.697,0.805-1.495,1.471-1.73,2.462
		c1.515,0.209,2.724-0.738,4.192-0.75C581.955,92.823,580.316,91.518,579.25,92.75z M508.75,123
		c-3.883,1.019,1.165,3.019,1.294,4.456c1.715,0.328,2.309-3.123,1.717-4.205c-0.83-1.518-3.616-1.763-3.511,0.499 M528,102.5
		c-2.5,1.147,3.522,4.674,4.255,1.513c0.705-3.04-4.998-2.696-5.005,0.487"
      />
    </a>
  </g>
</svg>
